"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const plivo_browser_sdk_1 = __importDefault(require("plivo-browser-sdk"));
const Sentry = __importStar(require("@sentry/browser"));
const needs_payment_setup_filter_1 = require("../filters/needs-payment-setup.filter");
const is_prepaid_billing_filter_1 = require("../filters/is-prepaid-billing.filter");
const util_helper_1 = require("../helpers/util.helper");
const media_helper_1 = require("../helpers/media.helper");
const environment_1 = require("@environment/environment");
const OpenAIRealtimeCtrl_1 = require("./OpenAIRealtimeCtrl");
const RushOpportunityService_1 = require("../services/RushOpportunityService");
angular.module('callX').controller('AgentSalesDashboardCtrl', [
    '$scope',
    '$stateParams',
    '$modal',
    'UserService',
    '$rootScope',
    '$state',
    'toaster',
    '$timeout',
    '$window',
    '$http',
    'WebSocketService',
    'WebSocketKeepAliveBrokerService',
    'WakeLockService',
    'BillingService',
    'LoggerService',
    '$controller',
    function ($scope, $stateParams, $modal, UserService, $rootScope, $state, toaster, $timeout, $window, $http, webSocketService, webSocketKeepAliveBrokerService, wakeLockService, billingService, loggerService, $controller) {
        var username_agent = $stateParams.username;
        var userId = $stateParams.userId;
        var $ = window._originalJQuery || window.jQuery || window.$;
        $scope.callClosed = false;
        $scope.offerDetailsFlag = false;
        $scope.totalLayout = false;
        $scope.salesLayout = false;
        $scope.dynamicLayout = false;
        $scope.showAlertModel = true;
        $scope.showDataModel = false;
        $scope.role;
        $scope.getuserRole;
        $scope.getsalesRole;
        $scope.isMuted = false;
        $scope.switchStatus = false;
        $scope.callUUID = null;
        $scope.lastRecievedCaller = null;
        $scope.agentDashboradLoaderFlag = false;
        $scope.reconnectingState = false;
        $scope.socketStatusSentTime = 0;
        $scope.socketStatusRecievedTime = 0;
        // Initialise all audio-device and microphone-monitoring state/functions
        // by composing AudioDeviceController onto the same $scope.
        $controller('AudioDeviceController', { $scope: $scope });
        // Single-tab enforcement with hybrid approach
        $scope.duplicateTab = false;
        var tabId = Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
        var activeKey = 'callxActiveTab';
        var heartbeatInterval = null;
        var isPrimary = false;
        var tabCleanupComplete = false;
        var useBroadcastChannel = typeof BroadcastChannel !== 'undefined';
        var channel = null;
        function setTabStatus(primary) {
            var becamePrimary = primary && !isPrimary;
            var becameSecondary = !primary && isPrimary;
            isPrimary = primary;
            $scope.duplicateTab = !primary;
            if (!$scope.$$phase) {
                $scope.$apply();
            }
            if (becameSecondary && typeof cancelSocketReconnect === 'function') {
                cancelSocketReconnect();
                webSocketService.discard();
                if (!hasActiveCall() && typeof $scope.logoutPlivo === 'function') {
                    $scope.logoutPlivo();
                }
                $scope.reconnectingState = false;
            }
            if (becamePrimary && typeof $scope.goLive === 'function' && localStorage.getItem('switchStatus') === 'true') {
                $timeout(function () {
                    if (isPrimary && typeof $scope.goLive === 'function') {
                        $scope.goLive(true, true);
                    }
                }, 0);
            }
            // console.log(primary ? 'This is the primary tab' : 'Another tab exists, disabling this one');
        }
        function claimPrimaryRole() {
            var now = Date.now();
            localStorage.setItem(activeKey, JSON.stringify({
                tabId: tabId,
                timestamp: now
            }));
            setTabStatus(true);
            startHeartbeat();
        }
        function checkPrimaryStatus() {
            try {
                var stored = localStorage.getItem(activeKey);
                if (!stored) {
                    claimPrimaryRole();
                    return;
                }
                var data = JSON.parse(stored);
                var now = Date.now();
                var timeDiff = now - data.timestamp;
                if (data.tabId === tabId) {
                    setTabStatus(true);
                }
                else if (timeDiff > 5000) {
                    claimPrimaryRole();
                }
                else {
                    setTabStatus(false);
                }
            }
            catch (e) {
                claimPrimaryRole();
            }
        }
        function startHeartbeat() {
            if (heartbeatInterval) {
                clearInterval(heartbeatInterval);
            }
            heartbeatInterval = setInterval(function () {
                if (isPrimary) {
                    var now = Date.now();
                    localStorage.setItem(activeKey, JSON.stringify({
                        tabId: tabId,
                        timestamp: now
                    }));
                }
                else {
                    checkPrimaryStatus();
                }
            }, 2000);
        }
        function cleanup() {
            if (tabCleanupComplete)
                return;
            tabCleanupComplete = true;
            $window.removeEventListener('unload', cleanup);
            if (heartbeatInterval) {
                clearInterval(heartbeatInterval);
            }
            if (isPrimary) {
                try {
                    var stored = localStorage.getItem(activeKey);
                    if (stored) {
                        var data = JSON.parse(stored);
                        if (data.tabId === tabId) {
                            localStorage.removeItem(activeKey);
                        }
                    }
                }
                catch (e) {
                    console.error('Cleanup error:', e);
                }
            }
            if (channel) {
                channel.postMessage({ type: 'closing', tabId: tabId });
                channel.close();
            }
        }
        if (useBroadcastChannel) {
            channel = new BroadcastChannel('callx-primary-tab');
            channel.onmessage = function (e) {
                var msg = e.data;
                if (msg.type === 'claim' && msg.tabId !== tabId) {
                    setTabStatus(false);
                }
                else if (msg.type === 'closing' && msg.tabId !== tabId) {
                    setTimeout(checkPrimaryStatus, 100);
                }
            };
            checkPrimaryStatus();
            if (isPrimary) {
                channel.postMessage({ type: 'claim', tabId: tabId });
            }
        }
        else {
            checkPrimaryStatus();
        }
        startHeartbeat();
        $window.addEventListener('unload', cleanup);
        $scope.$on('$destroy', cleanup);
        $scope.isInDispositionPage = false;
        $scope.billingStatus = null;
        $scope.billingStatusLoaded = false; // Flag to prevent multiple calls
        $scope.loadBillingStatus = function () {
            if (!userId || $scope.billingStatusLoaded) {
                return;
            }
            $scope.billingStatusLoaded = true; // Set flag to prevent further calls
            billingService.getAgentBillingStatus(userId)
                .then((data) => $scope.billingStatus = data)
                .catch(() => $scope.billingStatus = null);
        };
        $scope.loadBillingStatus();
        // Load billing config for prepaid balance display
        $scope.billingConfig = null;
        $scope.billingConfigLoading = false; // Flag to prevent multiple calls
        $scope.loadBillingConfig = function () {
            if (!userId || $scope.billingConfigLoading) {
                return;
            }
            $scope.billingConfigLoading = true; // Set flag to prevent further calls
            billingService.getAgentBillingConfig(userId).then((response) => {
                $scope.billingConfig = response === null || response === void 0 ? void 0 : response.payload;
                $scope.billingConfigLoading = false;
            }).catch(() => {
                $scope.billingConfig = null;
                $scope.billingConfigLoading = false;
            });
        };
        $scope.loadBillingConfig();
        // Flag indicating if this agent is eligible for Customer Service calls
        $scope.eligibleForCustomerServiceCalls = false;
        try {
            var storedUserDetails = window.localStorage.getItem('user_details');
            // console.log('storedUserDetails', storedUserDetails);
            if (storedUserDetails) {
                var parsedUserDetails = JSON.parse(storedUserDetails);
                if (parsedUserDetails && parsedUserDetails.eligibleForCustomerServiceCalls !== undefined) {
                    $scope.eligibleForCustomerServiceCalls = !!parsedUserDetails.eligibleForCustomerServiceCalls;
                }
            }
        }
        catch (e) {
            console.log('Error reading eligibleForCustomerServiceCalls from user_details', e);
        }
        // Function to get sales agent stats and update customer service eligibility
        $scope.getsalesAgentStats = function () {
            var callbacks = {
                success: function (response) {
                    // console.log('Sales agent stats response:', response);
                    if (response && response.data && typeof response.data.eligible_for_customer_service_calls !== 'undefined') {
                        $scope.eligibleForCustomerServiceCalls = !!response.data.eligible_for_customer_service_calls;
                        // console.log('Updated eligibleForCustomerServiceCalls:', $scope.eligibleForCustomerServiceCalls);
                    }
                },
                error: function (error) {
                    console.error('Error fetching sales agent stats:', error);
                }
            };
            // Assuming UserService has a method to get sales agent data
            // You may need to adjust this based on the actual service method
            if (UserService.getSalesAgents) {
                UserService.getSalesAgents(userId, callbacks);
            }
            else {
                console.warn('UserService.getSalesAgents method not found');
            }
        };
        // Load customer service eligibility status
        $scope.getsalesAgentStats();
        // Sidebar collapse state (mobile-only)
        $scope.isMobileViewport = function () {
            var vw = ($window && $window.innerWidth) ? $window.innerWidth : (document && document.documentElement && document.documentElement.clientWidth ? document.documentElement.clientWidth : 1024);
            return vw < 1400; // auto-collapse breakpoint
        };
        $scope.mobileCollapsed = $scope.isMobileViewport();
        $scope.toggleMobile = function () {
            // Allow collapsing/expanding regardless of viewport
            $scope.mobileCollapsed = !$scope.mobileCollapsed;
        };
        // No auto-uncollapse on resize; user controls collapse state explicitly now
        // Initialize status update queuing and retry mechanism
        var STATUS_UPDATE_TIMEOUT = 3000; // 3 seconds timeout for status update
        var MAX_STATUS_UPDATE_RETRIES = 3; // Maximum number of retry attempts
        var STATUS_HISTORY_MAX_AGE = 5 * 60 * 1000; // 5 minutes - how long to keep status history
        var STATUS_HISTORY_CLEANUP_INTERVAL = 60 * 1000; // 1 minute - how often to clean status history
        $scope.statusRequests = {}; // Stores timestamps for each status update request
        $scope.lastStatusRequest = null; // Stores the latest status update request and timestamp
        $scope.pendingStatusUpdate = null; // Stores the full message and retry count for the status that is currently pending confirmation
        $scope.pendingStatusUpdateTimeoutId = null; // Stores the timeout ID
        $scope.statusUpdateQueue = []; // Queue for status updates to handle rapid status changes
        $scope.lastSentStatus = null; // Tracks the last status that was sent to the server
        // Function to handle status update timeouts with exponential backoff
        function handleStatusUpdateTimeout() {
            if (!$scope.pendingStatusUpdate)
                return; // No pending update to handle
            var statusToRetry = $scope.pendingStatusUpdate.message.status;
            var currentRetries = $scope.pendingStatusUpdate.retryCount;
            console.error('Status update for ' + statusToRetry + ' timed out. No confirmation received from server. Retry ' + (currentRetries + 1) + '/' + MAX_STATUS_UPDATE_RETRIES);
            // Check if we should retry and if WebSocket is connected
            if (currentRetries < MAX_STATUS_UPDATE_RETRIES) {
                // Only retry if the WebSocket is currently connected
                if ($rootScope.socket && $rootScope.socket.readyState === WebSocket.OPEN) {
                    // Increment retry count
                    $scope.pendingStatusUpdate.retryCount++;
                    // Calculate exponential backoff delay (1s, 2s, 4s...)
                    var backoffDelay = Math.pow(2, currentRetries) * 1000; // 1000, 2000, 4000 ms
                    var retryRequestTimestamp = $scope.pendingStatusUpdate.timestamp;
                    console.log('Retrying status update for ' + statusToRetry + ' in ' + (backoffDelay / 1000) + ' seconds');
                    // Set a timeout to retry after the backoff delay
                    setTimeout(function () {
                        if (!$scope.pendingStatusUpdate
                            || $scope.pendingStatusUpdate.message.status !== statusToRetry
                            || $scope.pendingStatusUpdate.timestamp !== retryRequestTimestamp) {
                            return;
                        }
                        // Re-check WebSocket state before retry
                        if ($rootScope.socket && $rootScope.socket.readyState === WebSocket.OPEN) {
                            if ($scope.pendingStatusUpdate.message) {
                                // Re-send the original message
                                sendMessageThroughWebSocket($scope.pendingStatusUpdate.message, true); // Pass true for isRetry
                            }
                            else {
                                console.error("No message to retry.");
                                failPendingStatusUpdate(statusToRetry);
                            }
                        }
                        else {
                            console.error("WebSocket not connected during retry attempt. Giving up.");
                            failPendingStatusUpdate(statusToRetry);
                        }
                    }, backoffDelay);
                    // Don't set pendingStatusUpdateTimeoutId here as we're doing custom timing with backoff
                }
                else {
                    console.error('WebSocket not connected. Cannot retry status update.');
                    failPendingStatusUpdate(statusToRetry);
                }
            }
            else {
                failPendingStatusUpdate(statusToRetry);
            }
        }
        // Helper function to handle error of a status update
        function failPendingStatusUpdate(status) {
            // Max retries reached or WebSocket disconnected, give up and show error to user
            console.error('Status update for ' + status + ' failed after ' + MAX_STATUS_UPDATE_RETRIES + ' retries. Please try again.');
            // toaster.pop('error', 'Status Update Failed', 'Could not update status to ' + status + ' after multiple attempts. Please check your connection and try again.');
            // Clear pending state
            $scope.pendingStatusUpdate = null;
            $scope.pendingStatusUpdateTimeoutId = null;
            $scope.agentDashboradLoaderFlag = false; // Ensure loader is cleared
            if (isOnlineDesired() && status !== 'offline') {
                $scope.reconnectingState = true;
                startRecoveryWindow('status-update-timeout');
                captureAgentStatusEvent('status-update-retries-exhausted', { status: status });
                if ($rootScope.socket && $rootScope.socket.readyState === WebSocket.OPEN) {
                    $rootScope.socket.close(4003, 'status-ack-timeout');
                }
                else {
                    scheduleSocketReconnect('status-update-timeout');
                }
            }
            // Process the next item in the queue if any
            processNextQueuedStatusUpdate();
            // Schedule a safe digest; works even if a digest is already in progress
            $scope.$evalAsync();
        }
        // Process the next status update in the queue
        function processNextQueuedStatusUpdate() {
            if ($scope.statusUpdateQueue.length > 0) {
                console.log('Processing next queued status update. Queue size: ' + $scope.statusUpdateQueue.length);
                var nextUpdate = $scope.statusUpdateQueue.shift();
                if (nextUpdate) {
                    sendMessageThroughWebSocket(nextUpdate, false);
                }
            }
        }
        function clearStatusUpdateQueue() {
            if ($scope.statusUpdateQueue.length > 0) {
                console.log('Clear status update queue. Queue size: ' + $scope.statusUpdateQueue.length);
                $scope.statusUpdateQueue = [];
                console.log('Status update queue cleared.');
            }
        }
        // Clean old entries from statusRequests map to prevent memory bloat
        function cleanupStatusHistory() {
            var now = Date.now();
            var cutoffTime = now - STATUS_HISTORY_MAX_AGE;
            var keysToDelete = [];
            // Find old entries to delete
            for (var status in $scope.statusRequests) {
                if ($scope.statusRequests.hasOwnProperty(status)) {
                    var timestamp = $scope.statusRequests[status];
                    if (timestamp < cutoffTime) {
                        keysToDelete.push(status);
                    }
                }
            }
            // Delete old entries
            for (var i = 0; i < keysToDelete.length; i++) {
                delete $scope.statusRequests[keysToDelete[i]];
            }
            if (keysToDelete.length > 0) {
                console.log('Cleaned up ' + keysToDelete.length + ' old status history entries');
            }
        }
        // Start periodic cleanup of status history
        var statusHistoryCleanupInterval = setInterval(function () {
            if ($scope.statusRequests) {
                cleanupStatusHistory();
            }
        }, STATUS_HISTORY_CLEANUP_INTERVAL);
        // step by step
        $scope.showFormStepsPrompt = true;
        $scope.scriptStep = 0;
        $scope.progress = 0;
        $scope.showFormStepOne = false;
        $scope.showFormStepTwo = false;
        $scope.showFormStepThree = false;
        $scope.showFormStepFour = false;
        $scope.salesuserDetails = {};
        //Agent dashboard states ('waiting', 'paused', 'offline', 'incomingcall', 'oncall')
        $scope.agentDashboardStatus = new rxjs_1.BehaviorSubject('offline');
        $scope.statusStartedAt = {
            waiting: Date.now(),
            oncall: Date.now(),
            paused: Date.now(),
        };
        $scope.internetDisconnectedByBrowser = false;
        $scope.internetDisconnectedByApi = false;
        var desiredOnline = localStorage.getItem('switchStatus') === 'true';
        var onlineIntentGeneration = 0;
        $scope.switchStatus = desiredOnline;
        $scope.reconnectTimer = null;
        $scope.reconnectTimeLimit = 5 * 60 * 1000;
        var impersonationRole = localStorage.getItem('impersonation_role');
        if (impersonationRole) {
            $scope.isImpersonating = true;
            $scope.impersonateRole = impersonationRole;
        }
        // object if the screen wake lock is granted, else is undefined
        $scope.wakeLockSentinel = undefined;
        function initWakeLock() {
            wakeLockService.init().then((wakeLockSentinel) => {
                $scope.wakeLockSentinel = wakeLockSentinel;
            });
        }
        initWakeLock();
        $scope.sendEventToSentry = function (flag, object) {
            var objToExtraData = function (obj) {
                var result = {};
                for (var p in obj) {
                    if (typeof obj[p] !== "function" && typeof obj[p] !== "object") {
                        result[p] = obj[p];
                    }
                }
                return result;
            };
            var enrichWithData = function (obj) {
                obj['Wake Lock is granted'] = !!$scope.wakeLockSentinel;
                return obj;
            };
            var logMessage;
            switch (flag) {
                case 'abnormal-socket-close':
                    logMessage = "Event: Socket Closed Abnormally";
                    break;
                case 'socket-error':
                    logMessage = "Event: Socket Error";
                    break;
                default:
                    logMessage = "";
                    break;
            }
            var additionalData = {
                agentId: userId,
                agentName: $scope.username_firstName + " " + $scope.username_lastName,
                timestamp: new Date().toLocaleString('en-US', { timeZone: 'UTC', hour12: false })
            };
            var extraData = enrichWithData(objToExtraData(additionalData));
            Object.assign(extraData, additionalData);
            Sentry.captureMessage(logMessage, {
                level: "log",
                fingerprint: [logMessage],
                extra: extraData,
            });
        };
        $scope.sendMessageToSentry = function (flag, extraData) {
            var logMessage;
            switch (flag) {
                case 'incoming-call-while-paused':
                    logMessage = "Event: Incoming Call While Paused";
                    break;
                case 'socket-message-timeout':
                    logMessage = "Event: Status Update Timeout (>3s)";
                    break;
                case 'status-desync':
                    logMessage = "Event: Agent Status Desync (frontend vs backend)";
                    break;
                default:
                    logMessage = "";
                    break;
            }
            if (logMessage) {
                Sentry.captureMessage(logMessage, {
                    level: "log",
                    fingerprint: [logMessage],
                    extra: extraData,
                });
            }
        };
        function isOnlineDesired() {
            return desiredOnline;
        }
        function setDesiredOnline(online) {
            if (desiredOnline !== online) {
                onlineIntentGeneration++;
            }
            desiredOnline = online;
            $scope.switchStatus = online;
            $scope.statusValue = online ? 'online' : 'offline';
            localStorage.setItem('switchStatus', String(online));
            localStorage.setItem('statusValue', online ? 'online' : 'offline');
        }
        function setAgentDashboardStatus(status) {
            console.log('setAgentDashboardStatus', status);
            var previousStatus = $scope.agentDashboardStatus.value;
            if (previousStatus !== status && status !== 'offline' && status !== 'incomingcall') {
                $scope.statusStartedAt[status] = Date.now();
            }
            $scope.agentDashboardStatus.next(status);
            // Mirror to $rootScope so RushOpportunitiesCtrl can access it for notification gating
            $rootScope.currentDashboardStatus = status;
            // Reset mute state when not actively on a call
            if (status !== 'oncall' && $scope.isMuted) {
                $scope.isMuted = false;
                $scope.updateMicrophoneSignal('appMuted', false);
            }
        }
        // start websockets connection form here
        $rootScope.socket = null;
        // True while the app itself is deliberately closing the socket (toggle
        // offline, hard restart, logout). Client-initiated closes can surface with
        // close codes other than 1000 (e.g. 1005 "no status"), which would
        // otherwise be treated as abnormal closures and trigger an unwanted
        // auto-reconnect that fights the user's intent.
        var intentionalSocketDisconnect = false;
        var socketReconnectTimer;
        var socketReconnectAttempt = 0;
        var lastStatusAnnouncementSocket = null;
        var lastStatusConfirmationSocket = null;
        // Clear all status-messaging bookkeeping tied to the previous socket.
        // Stale race-guard state (lastSentStatus, pending retries, queued updates)
        // must not be able to reject or reorder confirmations that belong to a
        // fresh connection.
        function resetStatusMessagingState() {
            if ($scope.pendingStatusUpdateTimeoutId) {
                clearTimeout($scope.pendingStatusUpdateTimeoutId);
            }
            $scope.pendingStatusUpdate = null;
            $scope.pendingStatusUpdateTimeoutId = null;
            $scope.statusUpdateQueue = [];
            $scope.statusRequests = {};
            $scope.lastStatusRequest = null;
            $scope.lastSentStatus = null;
        }
        var plivoLoginInFlight = false;
        var plivoLoginAttemptTimer;
        var plivoRecoveryTimer;
        var plivoReconnectAttempt = 0;
        var statusAnnouncementTimer;
        var foregroundHeartbeatTimer;
        function getPlivoCallUUID() {
            try {
                var client = $rootScope.plivoWebSdk && $rootScope.plivoWebSdk.client;
                return client && typeof client.getCallUUID === 'function' ? client.getCallUUID() : null;
            }
            catch (_) {
                return null;
            }
        }
        function hasActiveCall() {
            var status = $scope.agentDashboardStatus && $scope.agentDashboardStatus.value;
            return !!getPlivoCallUUID() || status === 'oncall' || status === 'incomingcall';
        }
        function isPlivoRegistered() {
            try {
                var client = $rootScope.plivoWebSdk && $rootScope.plivoWebSdk.client;
                if (!client)
                    return false;
                if (typeof client.isRegistered === 'function')
                    return client.isRegistered() === true;
                return client.isLoggedIn === true || (typeof client.isConnected === 'function' && client.isConnected() === true);
            }
            catch (_) {
                return false;
            }
        }
        function isPlivoConnecting() {
            try {
                var client = $rootScope.plivoWebSdk && $rootScope.plivoWebSdk.client;
                return !!client && typeof client.isConnecting === 'function' && client.isConnecting() === true;
            }
            catch (_) {
                return false;
            }
        }
        function transportsHealthy() {
            var statusSocketOpen = !!$rootScope.socket && $rootScope.socket.readyState === WebSocket.OPEN;
            var statusConfirmed = !isOnlineDesired() || lastStatusConfirmationSocket === $rootScope.socket;
            var heartbeatRecent = statusSocketOpen
                && Date.now() - webSocketKeepAliveBrokerService.getLastAckAt($rootScope.socket) < 30000;
            return navigator.onLine && statusSocketOpen && heartbeatRecent && statusConfirmed && isPlivoRegistered();
        }
        function clearRecoveryIfHealthy() {
            if (!transportsHealthy())
                return;
            if ($scope.reconnectTimer) {
                $timeout.cancel($scope.reconnectTimer);
                $scope.reconnectTimer = null;
            }
            cancelSocketReconnect();
            if (plivoRecoveryTimer) {
                $timeout.cancel(plivoRecoveryTimer);
                plivoRecoveryTimer = null;
            }
            plivoReconnectAttempt = 0;
            $scope.reconnectingState = false;
            $scope.isToggleDisabled = false;
            $scope.internetDisconnectedByApi = false;
            $scope.internetDisconnectedByBrowser = false;
        }
        function startRecoveryWindow(reason) {
            if (!isOnlineDesired() || $scope.duplicateTab || $scope.reconnectTimer)
                return;
            var intentGeneration = onlineIntentGeneration;
            console.warn('[Recovery] Window started', { reason: reason, timeout: $scope.reconnectTimeLimit });
            captureAgentStatusEvent('transport-recovery-started', { reason: reason });
            $scope.reconnectTimer = $timeout(function () {
                $scope.reconnectTimer = null;
                if (!isOnlineDesired() || intentGeneration !== onlineIntentGeneration || transportsHealthy()) {
                    clearRecoveryIfHealthy();
                    return;
                }
                if (hasActiveCall()) {
                    startRecoveryWindow('active-call-deferred-timeout');
                    scheduleSocketReconnect('active-call-deferred-timeout');
                    return;
                }
                console.error('[Recovery] Window exhausted; transitioning Offline');
                captureAgentStatusEvent('transport-recovery-exhausted', { reason: reason });
                setDesiredOnline(false);
                cancelSocketReconnect();
                $scope.reconnectingState = false;
                $scope.agentDashboradLoaderFlag = false;
                $scope.isToggleDisabled = false;
                setAgentDashboardStatus('offline');
                $scope.stopMicrophoneMonitor(true);
                $scope.logoutPlivo();
                $scope.disconnectWebSocket();
            }, $scope.reconnectTimeLimit);
        }
        function clearPlivoLoginGuard() {
            plivoLoginInFlight = false;
            if (plivoLoginAttemptTimer) {
                $timeout.cancel(plivoLoginAttemptTimer);
                plivoLoginAttemptTimer = null;
            }
        }
        function armPlivoLoginGuard(reason) {
            plivoLoginInFlight = true;
            if (plivoLoginAttemptTimer) {
                $timeout.cancel(plivoLoginAttemptTimer);
            }
            plivoLoginAttemptTimer = $timeout(function () {
                plivoLoginAttemptTimer = null;
                plivoLoginInFlight = false;
                if (isOnlineDesired() && !isPlivoRegistered()) {
                    console.warn('[PlivoRecovery] Login attempt timed out', { reason: reason });
                    captureAgentStatusEvent('plivo-registration-timeout', { reason: reason });
                    schedulePlivoRecovery(reason);
                }
            }, 10000);
        }
        function recoverPlivoRegistration(reason) {
            if (!isOnlineDesired() || $scope.duplicateTab || !navigator.onLine || getPlivoCallUUID() || isPlivoRegistered() || isPlivoConnecting() || plivoLoginInFlight) {
                clearRecoveryIfHealthy();
                return;
            }
            if (!$rootScope.plivoWebSdk) {
                $scope.initPhone();
            }
            if ($rootScope.plivoWebSdk && !isPlivoRegistered() && !isPlivoConnecting()) {
                console.warn('[PlivoRecovery] Registering', { reason: reason });
                captureAgentStatusEvent('plivo-registration-retry', { reason: reason });
                onLogin();
            }
        }
        function schedulePlivoRecovery(reason) {
            if (!isOnlineDesired() || $scope.duplicateTab || plivoRecoveryTimer)
                return;
            var delay = Math.min(15000, Math.pow(2, plivoReconnectAttempt) * 1000);
            delay += Math.floor(Math.random() * Math.min(1000, delay * 0.25));
            plivoReconnectAttempt++;
            plivoRecoveryTimer = $timeout(function () {
                plivoRecoveryTimer = null;
                recoverPlivoRegistration(reason);
                if (isOnlineDesired() && !isPlivoRegistered()) {
                    schedulePlivoRecovery(reason);
                }
                else {
                    plivoReconnectAttempt = 0;
                    clearRecoveryIfHealthy();
                }
            }, delay);
        }
        function announceStatusWhenReady(reason) {
            var socket = $rootScope.socket;
            if ($scope.duplicateTab || !socket || socket.readyState !== WebSocket.OPEN || !isOnlineDesired() || lastStatusAnnouncementSocket === socket) {
                return;
            }
            if (!isPlivoRegistered() && !getPlivoCallUUID()) {
                recoverPlivoRegistration(reason);
                if (!statusAnnouncementTimer) {
                    statusAnnouncementTimer = $timeout(function () {
                        statusAnnouncementTimer = null;
                        if ($rootScope.socket === socket) {
                            announceStatusWhenReady(reason);
                        }
                    }, 500);
                }
                return;
            }
            var callUUID = getPlivoCallUUID();
            var currentStatus = $scope.agentDashboardStatus.value;
            var statusToAnnounce = callUUID
                ? 'oncall'
                : ((currentStatus === 'oncall' || currentStatus === 'incomingcall' || currentStatus === 'paused') ? currentStatus : 'waiting');
            lastStatusAnnouncementSocket = socket;
            console.log('[AgentStatusWS] Announcing status after transports are ready', { reason: reason, status: statusToAnnounce });
            captureAgentStatusEvent('agent-status-announced', { reason: reason, status: statusToAnnounce });
            $scope.setCallStatus(statusToAnnounce, true);
            clearRecoveryIfHealthy();
        }
        function captureAgentStatusEvent(name, extra) {
            Sentry.captureMessage('Event: ' + name, {
                level: 'log',
                fingerprint: [name],
                extra: Object.assign({
                    agentId: userId,
                    socketUrl: $rootScope.socket ? $rootScope.socket.url : environment_1.environment.socketUrl,
                    desiredOnline: isOnlineDesired(),
                    dashboardStatus: $scope.agentDashboardStatus.value,
                    browserOnline: navigator.onLine,
                    visibilityState: document.visibilityState,
                    plivoRegistered: isPlivoRegistered(),
                    hasCallUUID: !!getPlivoCallUUID(),
                    retryAttempt: socketReconnectAttempt,
                }, extra || {}),
            });
        }
        function cancelSocketReconnect() {
            if (socketReconnectTimer) {
                $timeout.cancel(socketReconnectTimer);
                socketReconnectTimer = null;
            }
        }
        function scheduleSocketReconnect(reason) {
            if (!isOnlineDesired() || $scope.duplicateTab || $scope.$$destroyed || !navigator.onLine || socketReconnectTimer) {
                return;
            }
            var delay = Math.min(15000, Math.pow(2, socketReconnectAttempt) * 1000);
            delay += Math.floor(Math.random() * Math.min(1000, delay * 0.25));
            socketReconnectAttempt++;
            console.warn('[AgentStatusWS] Reconnect scheduled', { reason: reason, attempt: socketReconnectAttempt, delay: delay });
            captureAgentStatusEvent('agent-status-retry-scheduled', { reason: reason, delay: delay });
            socketReconnectTimer = $timeout(function () {
                socketReconnectTimer = null;
                if (!isOnlineDesired() || !navigator.onLine) {
                    return;
                }
                $scope.connectWebSocketConnection(userId, true);
            }, delay);
        }
        $scope.connectWebSocketConnection = function (agentId, isReconnected) {
            if ($scope.duplicateTab || !isOnlineDesired() || !navigator.onLine)
                return;
            console.log('[AgentStatusWS] Connecting', { isReconnected: isReconnected, attempt: socketReconnectAttempt });
            // If a socket is already OPEN, webSocketService.connect() silently
            // no-ops and onopen never fires, so the backend would get no status
            // announce (and the loader could hang). Re-run the announce logic on the
            // existing socket instead. If that socket is actually a zombie, the
            // keep-alive watchdog closes it shortly and the reconnect path will
            // announce again on the fresh connection.
            if ($rootScope.socket && $rootScope.socket.readyState === WebSocket.OPEN) {
                announceStatusWhenReady('existing-socket');
                return;
            }
            try {
                webSocketService.connect(agentId, $scope.username_firstName, $scope.username_lastName, () => handleSocketOpen(isReconnected), handleSocketMessage, handleSocketError, handleSocketClose);
            }
            catch (error) {
                console.error('[AgentStatusWS] Connection construction failed', error);
                $scope.agentDashboradLoaderFlag = false;
                $scope.reconnectingState = true;
                startRecoveryWindow('agent-status-connect-error');
                captureAgentStatusEvent('agent-status-connect-error', { error: String(error) });
                scheduleSocketReconnect('agent-status-connect-error');
            }
        };
        function handleSocketOpen(isReconnected) {
            console.log('[AgentStatusWS] Open', { isReconnected: isReconnected, url: $rootScope.socket && $rootScope.socket.url });
            if ($scope.duplicateTab) {
                webSocketService.discard();
                return;
            }
            intentionalSocketDisconnect = false;
            cancelSocketReconnect();
            socketReconnectAttempt = 0;
            resetStatusMessagingState();
            lastStatusConfirmationSocket = null;
            $scope.internetDisconnectedByBrowser = false;
            $scope.internetDisconnectedByApi = false;
            announceStatusWhenReady(isReconnected ? 'socket-reconnected' : 'socket-opened');
            captureAgentStatusEvent('agent-status-open', { isReconnected: isReconnected });
        }
        function handleSocketMessage(event) {
            if (event.data) {
                const type = webSocketService.messageType(event.data);
                switch (type) {
                    case 'keep-alive':
                        webSocketKeepAliveBrokerService.acknowledge(event.target);
                        clearRecoveryIfHealthy();
                        break;
                    case 'status':
                        processSocketStatusMessage(event.data);
                        break;
                    default:
                        $scope.sendMessageToSentry('Invalid message format', { 'invalid-message': event.data });
                }
            }
        }
        function handleSocketError(error) {
            console.error('[AgentStatusWS] Error', error);
            var errorData = {
                agentId: userId,
                agentName: $scope.username_firstName + " " + $scope.username_lastName,
                timestamp: new Date().toLocaleString('en-US', { timeZone: 'UTC', hour12: false })
            };
            $scope.sendEventToSentry('socket-error', errorData);
            if (!isOnlineDesired() || $scope.duplicateTab)
                return;
            $scope.agentDashboradLoaderFlag = false;
            $scope.reconnectingState = true;
            startRecoveryWindow('agent-status-error');
            var socket = error && error.target;
            if (socket && socket === $rootScope.socket
                && (socket.readyState === WebSocket.OPEN || socket.readyState === WebSocket.CONNECTING)) {
                try {
                    socket.close(4004, 'socket-error');
                }
                catch (_) {
                    scheduleSocketReconnect('agent-status-error');
                }
            }
            else {
                scheduleSocketReconnect('agent-status-error');
            }
        }
        function handleSocketClose(event) {
            console.log('[AgentStatusWS] Closed', {
                code: event.code,
                reason: event.reason,
                wasClean: event.wasClean,
                desiredOnline: isOnlineDesired(),
                watchdogInitiated: webSocketKeepAliveBrokerService.wasWatchdogInitiated(event.target),
            });
            // The dashboard scope may already be gone (logout / navigation). Never
            // run reconnect logic for a dead scope: it would spawn an orphan socket.
            if ($scope.$$destroyed) {
                console.log('Scope destroyed — ignoring socket close event');
                return;
            }
            // Ignore close events coming from a stale socket: connect() may have
            // already replaced $rootScope.socket with a live connection, and
            // mutating state (or nulling the reference) here would clobber it.
            if ($rootScope.socket && event.target !== $rootScope.socket) {
                console.log('Stale socket close event ignored');
                return;
            }
            handleReconnection(event);
        }
        function handleReconnection(event) {
            var intentional = intentionalSocketDisconnect || !isOnlineDesired() || $scope.duplicateTab;
            intentionalSocketDisconnect = false;
            $rootScope.socket = null;
            lastStatusAnnouncementSocket = null;
            lastStatusConfirmationSocket = null;
            resetStatusMessagingState();
            captureAgentStatusEvent('agent-status-close', {
                code: event.code,
                reason: event.reason,
                wasClean: event.wasClean,
                intentional: intentional,
                watchdogInitiated: webSocketKeepAliveBrokerService.wasWatchdogInitiated(event.target),
                socketUrl: event.target.url,
            });
            if (intentional) {
                console.log('Normal socket closure. code:', event.code, 'intentional:', intentional);
                cancelSocketReconnect();
                socketReconnectAttempt = 0;
                $scope.agentDashboradLoaderFlag = false;
                $scope.reconnectingState = false;
                $scope.isToggleDisabled = false;
                if (!isOnlineDesired()) {
                    setAgentDashboardStatus('offline');
                }
                return;
            }
            console.warn('[AgentStatusWS] Recovering after close', { code: event.code, reason: event.reason });
            $scope.agentDashboradLoaderFlag = false;
            $scope.reconnectingState = true;
            $scope.isToggleDisabled = false;
            startRecoveryWindow('agent-status-close');
            // Cancel any previously scheduled attempt so multiple close events
            // can't stack reconnect timers.
            cancelSocketReconnect();
            scheduleSocketReconnect('close-' + event.code);
        }
        function sendMessageThroughWebSocket(message, isRetry) {
            // Store status update requests with timestamps locally
            if (message && message.status) {
                var timestamp = Date.now();
                // We'll store status updates in a map keyed by status
                $scope.statusRequests = $scope.statusRequests || {};
                // Save this request with its timestamp
                $scope.statusRequests[message.status] = timestamp;
                // Also track the most recent request overall
                $scope.lastStatusRequest = {
                    timestamp: timestamp,
                    status: message.status
                };
                // Track the last sent status to handle race conditions
                $scope.lastSentStatus = message.status;
                console.log('Status update request for ' + message.status + ' at time: ' + timestamp + (isRetry ? ' (Retry)' : ''));
                // If this is not a retry attempt, it's a fresh status update request from the UI
                if (!isRetry) {
                    // If there's a pending update being retried, we should cancel it and prioritize this new request
                    if ($scope.pendingStatusUpdate) {
                        if ($scope.pendingStatusUpdate.retryCount > 0) {
                            // There's an ongoing retry for an older status request, cancel it
                            console.log('Cancelling retries for ' + $scope.pendingStatusUpdate.message.status + ' due to newer status update: ' + message.status);
                            if ($scope.pendingStatusUpdateTimeoutId) {
                                clearTimeout($scope.pendingStatusUpdateTimeoutId);
                                $scope.pendingStatusUpdateTimeoutId = null;
                            }
                            // Clear the pending state as the new status takes priority
                            $scope.pendingStatusUpdate = null;
                        }
                        // If the pending update is not yet in retry mode, queue this new one
                        else {
                            // Only queue if it's not the same as current pending status to avoid duplicates
                            if ($scope.pendingStatusUpdate.message.status !== message.status) {
                                // Check if this status is already in the queue
                                var isDuplicate = false;
                                for (var i = 0; i < $scope.statusUpdateQueue.length; i++) {
                                    if ($scope.statusUpdateQueue[i].status === message.status) {
                                        isDuplicate = true;
                                        break;
                                    }
                                }
                                // Only add if not a duplicate
                                if (!isDuplicate) {
                                    $scope.statusUpdateQueue.push(message);
                                }
                            }
                            return; // Exit early, we'll process this message later when current request completes
                        }
                    }
                }
                // Clear any existing timeout before sending a new request
                if ($scope.pendingStatusUpdateTimeoutId) {
                    clearTimeout($scope.pendingStatusUpdateTimeoutId);
                }
                // Set the pending status update object
                if (!isRetry) {
                    $scope.pendingStatusUpdate = {
                        message: message,
                        retryCount: 0,
                        timestamp: timestamp // Timestamp of the initial request
                    };
                }
                else {
                    // For retries, update the timestamp of the retry attempt
                    $scope.pendingStatusUpdate.timestamp = timestamp;
                }
                $scope.pendingStatusUpdateTimeoutId = window.setTimeout(function () {
                    handleStatusUpdateTimeout(); // No need to pass status, it's in pendingStatusUpdate
                }, STATUS_UPDATE_TIMEOUT);
            }
            if ($rootScope.socket && $rootScope.socket.readyState == WebSocket.OPEN) {
                $scope.socketStatusSentTime = performance.now(); // Capture the time before sending the message
                try {
                    $rootScope.socket.send(JSON.stringify(message));
                }
                catch (error) {
                    console.error('WebSocket status send failed', error);
                    failPendingStatusUpdate(message.status);
                }
            }
            else {
                console.error('WebSocket is not connected');
                // If WebSocket is not connected, the request won't even be sent, so clear pending state
                if ($scope.pendingStatusUpdateTimeoutId) {
                    clearTimeout($scope.pendingStatusUpdateTimeoutId);
                }
                $scope.pendingStatusUpdate = null;
                $scope.pendingStatusUpdateTimeoutId = null;
                $scope.agentDashboradLoaderFlag = false; // Clear loader if not connected
                if (isOnlineDesired() && message.status !== 'offline') {
                    $scope.reconnectingState = true;
                    startRecoveryWindow('status-send-without-socket');
                    scheduleSocketReconnect('status-send-without-socket');
                }
                // toaster.pop('error', 'Connection Error', 'WebSocket is not connected. Could not send status update.');
                // Process the next queued update if any
                processNextQueuedStatusUpdate();
            }
        }
        function processSocketStatusMessage(message) {
            // Split the message by comma to separate AgentId and Status
            var oldStatus = $scope.agentDashboardStatus.value;
            var messageParts = message.split(",");
            var statusPart = null;
            var updateStatusPart = null;
            // Use traditional loops for ES5 compatibility
            for (var i = 0; i < messageParts.length; i++) {
                var part = messageParts[i];
                if (part.indexOf("Status=") === 0) {
                    statusPart = part;
                }
                else if (part.indexOf("updateStatus=") === 0) {
                    updateStatusPart = part;
                }
            }
            $scope.socketStatusRecievedTime = performance.now() - $scope.socketStatusSentTime; // Capture the time when the message is received
            $scope.socketStatusRecievedTime = $scope.socketStatusRecievedTime.toFixed(2); // Round to 2 decimal places
            var status = statusPart ? statusPart.split("=")[1] : null;
            var updateStatus = updateStatusPart ? updateStatusPart.split("=")[1] : null;
            if (status === "dispatchcall") {
                console.log('Ignoring dispatchcall status update');
                return;
            }
            if ($scope.socketStatusRecievedTime > 3000) {
                var timeoutData = {
                    agentId: userId,
                    agentName: $scope.username_firstName + " " + $scope.username_lastName,
                    fromStatus: oldStatus,
                    toStatus: status,
                    socketStatusRecievedTime: $scope.socketStatusRecievedTime,
                    timestamp: new Date().toLocaleString('en-US', { timeZone: 'UTC', hour12: false })
                };
                $scope.sendMessageToSentry('socket-message-timeout', timeoutData);
            }
            if (updateStatus == "Success") {
                // Only apply status update if there's no newer request or this is the latest request
                var shouldApplyUpdate = true;
                // Server-authoritative offline push: the backend only sends an
                // unsolicited 'offline' when it has already marked this agent offline
                // (missed keep-alives, admin action, state reset). Discarding it as a
                // race condition would leave the UI showing online while the backend
                // considers the agent offline.
                var isUnsolicitedOffline = status === 'offline' &&
                    $scope.lastSentStatus !== 'offline' &&
                    (!$scope.pendingStatusUpdate || $scope.pendingStatusUpdate.message.status !== 'offline');
                // Check for possible race conditions against last sent status
                // Check if the confirmed status is different from the last sent status
                // This prevents race conditions where an older status confirmation arrives after a newer status was sent
                if (isUnsolicitedOffline) {
                    console.warn('Server pushed unsolicited offline — applying it (backend is authoritative)');
                }
                else if ($scope.lastSentStatus && status !== $scope.lastSentStatus) {
                    // If the confirmed status doesn't match what we last sent, it's a race condition - reject it
                    console.log('Race condition detected: Server confirmed ' + status +
                        ' but our last sent status was ' + $scope.lastSentStatus + '. Using last sent status.');
                    console.log('Current agentDashboardStatus:', $scope.agentDashboardStatus.value);
                    shouldApplyUpdate = false;
                }
                // If status matches what we last sent, allow it (shouldApplyUpdate remains true)
                else if ($scope.lastSentStatus && status === $scope.lastSentStatus) {
                    console.log('Status confirmation matches last sent status:', status, '- allowing update');
                }
                // As a backup, also check timestamp-based approach
                if (shouldApplyUpdate && !isUnsolicitedOffline && $scope.lastStatusRequest) {
                    // Check if we've made a newer request for a different status
                    var statusTimestamp = $scope.statusRequests && $scope.statusRequests[status];
                    if (statusTimestamp && $scope.lastStatusRequest.timestamp > statusTimestamp &&
                        $scope.lastStatusRequest.status !== status) {
                        console.log('Ignoring outdated status update confirmation: ' + status + ' Current requested status: ' + $scope.lastStatusRequest.status);
                        shouldApplyUpdate = false;
                    }
                }
                if (shouldApplyUpdate) {
                    if (isUnsolicitedOffline && isOnlineDesired()) {
                        console.warn('[AgentStatusWS] Backend marked Online-intent agent Offline; reopening status transport');
                        $scope.reconnectingState = true;
                        $scope.agentDashboradLoaderFlag = false;
                        startRecoveryWindow('server-unsolicited-offline');
                        captureAgentStatusEvent('server-unsolicited-offline');
                        if ($rootScope.socket && $rootScope.socket.readyState === WebSocket.OPEN) {
                            $rootScope.socket.close(4002, 'server-offline');
                        }
                        return;
                    }
                    if (getPlivoCallUUID() && status != 'oncall') {
                        console.log('Success: updating agent status and call uuid is present');
                        $scope.agentDashboradLoaderFlag = false;
                        if (!$scope.salesLayout) {
                            $scope.salesLayout = true;
                            $scope.scriptStep = 0;
                            $scope.showFormStepOne = true;
                            $scope.staticQuestionsLayout = true;
                        }
                        setAgentDashboardStatus('oncall');
                        sendMessageThroughWebSocket({ status: 'oncall', agentId: userId });
                    }
                    else {
                        lastStatusConfirmationSocket = $rootScope.socket;
                        console.log('Success: updating agent status to', status);
                        if (status === 'paused') {
                            console.log('Processing paused status confirmation after call termination');
                        }
                        setAgentDashboardStatus(status);
                        $scope.agentDashboradLoaderFlag = false;
                        // Clear timeout and pending state if a successful update is applied
                        if ($scope.pendingStatusUpdateTimeoutId) {
                            clearTimeout($scope.pendingStatusUpdateTimeoutId);
                        }
                        $scope.pendingStatusUpdate = null;
                        $scope.pendingStatusUpdateTimeoutId = null;
                        clearRecoveryIfHealthy();
                        // Process the next item in the queue if any
                        processNextQueuedStatusUpdate();
                    }
                }
                else {
                    // If update is ignored (outdated), still clear loader
                    $scope.agentDashboradLoaderFlag = false;
                    // If an update is ignored because it's outdated, we should still clear its pending state
                    // if it matches the currently pending update. This prevents retrying an update
                    // that has already been superseded.
                    if ($scope.pendingStatusUpdate && $scope.pendingStatusUpdate.message.status === status) {
                        console.log('Clearing pending state for ignored outdated status: ' + status);
                        if ($scope.pendingStatusUpdateTimeoutId) {
                            clearTimeout($scope.pendingStatusUpdateTimeoutId);
                        }
                        $scope.pendingStatusUpdate = null;
                        $scope.pendingStatusUpdateTimeoutId = null;
                    }
                }
            }
            else {
                console.error('Status update failed for ' + status + '. Server returned error.');
                // Clear timeout and pending state on explicit error
                if ($scope.pendingStatusUpdateTimeoutId) {
                    clearTimeout($scope.pendingStatusUpdateTimeoutId);
                }
                $scope.pendingStatusUpdate = null;
                $scope.pendingStatusUpdateTimeoutId = null;
                $scope.agentDashboradLoaderFlag = false;
                if (isOnlineDesired() && status !== 'offline') {
                    $scope.reconnectingState = true;
                    startRecoveryWindow('status-update-rejected');
                    captureAgentStatusEvent('status-update-rejected', { status: status });
                    if ($rootScope.socket && $rootScope.socket.readyState === WebSocket.OPEN) {
                        $rootScope.socket.close(4003, 'status-update-rejected');
                    }
                    else {
                        scheduleSocketReconnect('status-update-rejected');
                    }
                }
                else {
                    $scope.reconnectingState = false;
                }
                // toaster.pop('error', 'Status Update Failed', 'Server rejected status update to ' + status + '.');
            }
        }
        // webSocket connection ends here
        // Function to set the specified state to true and others to false
        $scope.setCallStatus = function (status, force) {
            if (force || $scope.agentDashboardStatus.value !== status) {
                $scope.agentDashboradLoaderFlag = true;
                console.log('---- setCallStatus --->', status, force ? '(forced announce)' : '');
                sendMessageThroughWebSocket({ status: status, agentId: userId });
            }
            else {
                console.log('Status already ' + status + ', ignoring duplicate request');
            }
        };
        $scope.frwdOfferData = {}; //added
        $scope.validateCount = 0; //added
        $scope.tableContentLoading = false; //added
        $scope.optionsArrCreate = [];
        $scope.forwardflag = false;
        $scope.rightblock = false;
        var timer, timerInter;
        $scope.sidecondition = false;
        //document.getElementsByClassName("leadDisable").style.disabled=true;
        $scope.staticCustomerDetails = {
            first_name: "",
            last_name: "",
            gender: null,
            email: null,
            street1: "",
            street2: "",
            zip_code: null,
            city: '',
            state: '',
            dobDay: "",
            dobMonth: "",
            dobYear: "",
            age: "",
            dob: "",
            // secondaryCallerId: '',
            // bankAccountMode:null,
            secondary_phone_number: '',
            opt_in_sms: '',
            bank_accountmode: '',
            // bank_account:'',
            social_security_or_disability: null,
            coverage_type: null,
            height_feet: "",
            height_inches: "",
            weight: "",
            tobacco_user: null,
            medications: " ",
            // face_value: "",
            beneficiary_first_name: "",
            beneficiary_last_name: "",
            price_aware: null,
        };
        $scope.notes = '';
        $scope.staticPriorityDetails = [];
        $scope.bank_account_list = [
            'Local Bank',
            'Credit Union',
            'Direct Express Card'
        ];
        $scope.heightArray = ['5 feet 10 inches', '5 feet 11 inches'];
        //  $scope.diseasesList = ['Cancer', 'Diabetes', 'Anxiety /Depression /Bipolar','Heart Disorder', 'Chronic Pain',' Respiratory Disorder', 'Other Medical conditions','I have no medical conditions'];
        $scope.diseasesList = [
            'Lung Disease, COPD, Emphysema, Asthma, Oxygen, or Inhalers?',
            'Heart attack, stroke, TIA, or stents?',
            'Have you ever been diagnosed with CHF?',
            'Blood clots?',
            'Any cancers?',
            'Diabetes or neuropathy or Amputation? (Pills and/or insulin?)',
            'High blood pressure or high cholesterol?',
            'Kidney or liver problems?',
            'Thyroid disease?',
            'Any treatment for anxiety or depression?',
            'Treatment needed for alcohol or drug abuse?',
            'Walking or oxygen equipment?',
            "Alzheimer's or dementia?",
            'Any hospitalizations that resulted in a stay for over 24 hours within the past year?',
            'Are you currently confined to a nursing home or skilled nursing facility?',
            'Any other medications?',
            '(If Applicable) Within the last 5 years have you had your license suspended or Revoked? DUI, DWI etc. or have had any felonies?',
            'None'
        ];
        // Selected fruits
        $scope.medications = " ";
        $scope.staticQuestionsLayout = false;
        $scope.staticPriorityLayout = false;
        $scope.salesDisposition = false;
        $scope.editingFaceValue = false;
        $scope.editFaceValue = {};
        $scope.salesEndDisposition = false;
        $scope.loading = false;
        $scope.showNoOffersMessage = false;
        $scope.editSalesScript = false;
        $scope.editData = {};
        $scope.toggleSelection = function (val) {
            var diseases = $scope.staticCustomerDetails.medications.split(',').map(function (item) {
                return item.trim();
            });
            var idx = diseases.indexOf(val.trim());
            if (idx > -1) {
                diseases = diseases.filter(function (disease) {
                    return disease !== val.trim();
                });
            }
            else {
                diseases.push(val.trim());
            }
            diseases = diseases.filter(function (disease) {
                return disease !== '';
            });
            $scope.staticCustomerDetails.medications = diseases.join(', ');
            // console.log($scope.staticCustomerDetails.medications, "form -------------------------------");
        };
        $scope.toggleEditSelection = function (val) {
            // console.log(val, "editing ----------------------")
            var diseases = $scope.editData.medications.split(',').map(function (item) {
                return item.trim();
            });
            var idx = diseases.indexOf(val.trim());
            if (idx > -1) {
                diseases = diseases.filter(function (disease) {
                    return disease !== val.trim();
                });
                // diseases.splice(idx, 1);
            }
            else {
                diseases.push(val.trim());
            }
            // Join the selected diseases into a string with commas
            $scope.editData.medications = diseases.join(', ');
            // console.log($scope.editData.medications, "edit -------------------- ")
        };
        $scope.isAtLeastOneDiseaseSelected = function () {
            if ($scope.staticCustomerDetails.medications) {
                var diseasesArray = $scope.staticCustomerDetails.medications.split(',');
                return diseasesArray.some(function (disease) {
                    return disease.trim() !== '';
                });
            }
            return false;
        };
        // validate facevalue to enter only numbers
        $scope.validateNumeric = function (event) {
            // console.log(event)
            var charCode = (event.which) ? event.which : event.keyCode;
            if (charCode < 48 || charCode > 57) {
                event.preventDefault();
            }
        };
        $scope.validatePhoneNumber = function (event) {
            var keyCode = event.which || event.keyCode;
            var isControlKey = [8, 9, 13, 27, 37, 38, 39, 40, 46].indexOf(keyCode) !== -1;
            var isNumber = keyCode >= 48 && keyCode <= 57;
            if (!isControlKey && !isNumber) {
                event.preventDefault();
            }
        };
        $scope.months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        $scope.years = [];
        var currentYear = new Date().getFullYear();
        var minYear = currentYear - 100; // Minimum selectable year
        for (var year = minYear; year <= currentYear; year++) {
            $scope.years.push(year);
        }
        $scope.faceValues = [10000, 15000, 20000, 25000, 30000, 35000, 40000, 45000, 50000];
        $scope.updateDays = function () {
            var selectedYear = parseInt($scope.staticCustomerDetails.dobYear);
            var selectedMonth = parseInt($scope.staticCustomerDetails.dobMonth);
            var maxDays;
            switch (selectedMonth) {
                case 2:
                    var selectedYear = parseInt($scope.staticCustomerDetails.dobYear);
                    maxDays = (selectedYear % 4 === 0 && (selectedYear % 100 !== 0 || selectedYear % 400 === 0)) ? 29 : 28; // Leap year calculation
                    break;
                case 4:
                case 6:
                case 9:
                case 11:
                    maxDays = 30;
                    break;
                default:
                    maxDays = 31;
            }
            $scope.maxDays = maxDays;
            $scope.days = [];
            for (var i = 1; i <= maxDays; i++) {
                $scope.days.push(i);
            }
            $scope.calculateAge();
        };
        //DOB Field start
        $scope.updateDOB = function () {
            if ($scope.staticCustomerDetails.dobDay && $scope.staticCustomerDetails.dobMonth && $scope.staticCustomerDetails.dobYear) {
                $scope.staticCustomerDetails.dob = $scope.staticCustomerDetails.dobDay + '/' + $scope.staticCustomerDetails.dobMonth + '/' + $scope.staticCustomerDetails.dobYear;
            }
            else {
                $scope.staticCustomerDetails.dob = "";
            }
        };
        //DOB field end
        $scope.calculateAge = function () {
            // Check if all fields are selected
            if (!$scope.staticCustomerDetails.dobYear || !$scope.staticCustomerDetails.dobMonth || !$scope.staticCustomerDetails.dobDay) {
                $scope.staticCustomerDetails.age = ''; // Clear the age if not all fields are filled
                return;
            }
            // Create a birthdate object using selected year, month, and day
            var birthDate = new Date($scope.staticCustomerDetails.dobYear, $scope.staticCustomerDetails.dobMonth - 1, $scope.staticCustomerDetails.dobDay);
            var currentDate = new Date();
            // Calculate the age
            var age = currentDate.getFullYear() - birthDate.getFullYear();
            // Adjust the age if the birthday hasn't occurred yet this year
            if (currentDate.getMonth() < birthDate.getMonth() ||
                (currentDate.getMonth() === birthDate.getMonth() && currentDate.getDate() < birthDate.getDate())) {
                age--;
            }
            // Set the calculated age
            $scope.staticCustomerDetails.age = age;
        };
        $scope.calculateEditAge = function () {
            if (!$scope.editData || !$scope.editData.dobYear || !$scope.editData.dobMonth || !$scope.editData.dobDay) {
                // Do nothing if any field is missing
                $scope.editData.age = null;
                return;
            }
            // Create a birthdate using the selected values
            var birthDate = new Date($scope.editData.dobYear, $scope.editData.dobMonth - 1, $scope.editData.dobDay);
            var currentDate = new Date();
            // Calculate the age
            var age = currentDate.getFullYear() - birthDate.getFullYear();
            // Adjust if the birthday hasn't occurred this year
            if (currentDate.getMonth() < birthDate.getMonth() ||
                (currentDate.getMonth() === birthDate.getMonth() && currentDate.getDate() < birthDate.getDate())) {
                age--;
            }
            $scope.editData.age = age;
        };
        $scope.showFormStep = function (scriptStep) {
            // Initialize all form steps to false
            $scope.showFormStepOne = false;
            $scope.showFormStepTwo = false;
            $scope.showFormStepThree = false;
            $scope.showFormStepFour = false;
            // Show the correct step based on the step value
            if (scriptStep === 0) {
                $scope.showFormStepOne = true;
            }
            else if (scriptStep === 1) {
                $scope.showFormStepTwo = true;
                // $scope.showFormStepOne = false;
            }
            else if (scriptStep === 2) {
                // $scope.staticPriorityLayout = false;
                $scope.showFormStepThree = true;
            }
            else if (scriptStep === 3) {
                // $scope.staticPriorityLayout = true;
                $scope.showFormStepFour = true;
                // $scope.loading = true;
            }
            // Add more steps here if necessary
        };
        $scope.validateStep = function (scriptStep) {
            if (scriptStep === 0) {
                // Validation for Step 1
                if (!$scope.staticCustomerDetails.first_name || !$scope.staticCustomerDetails.last_name) {
                    toaster.pop('error', 'Error', "Name is required.", 2000);
                    return false;
                }
                if (!$scope.staticCustomerDetails.gender) {
                    toaster.pop('error', 'Error', "Gender is required.", 2000);
                    return false;
                }
                if (!$scope.staticCustomerDetails.zip_code) {
                    toaster.pop('error', 'Error', "ZIP Code is required.", 2000);
                    return false;
                }
                if ($scope.staticCustomerDetails.zip_code.length !== 5) {
                    toaster.pop('error', 'Error', "ZIP Code must be 5 digits long.", 2000);
                    return false;
                }
                if (!$scope.staticCustomerDetails.dobMonth || !$scope.staticCustomerDetails.dobDay || !$scope.staticCustomerDetails.dobYear) {
                    toaster.pop('error', 'Error', "Month, Day, and Year is required.", 2000);
                    return false;
                }
                // if ($scope.staticCustomerDetails.secondaryCallerId === undefined || $scope.staticCustomerDetails.secondaryCallerId === null || $scope.staticCustomerDetails.secondaryCallerId === '') {
                //     toaster.pop('error', 'Error', "Contact Number is required.", 2000);
                //     return false;
                // }
            }
            else if (scriptStep === 1) {
                if ($scope.staticCustomerDetails.bank_account_mode === undefined || $scope.staticCustomerDetails.bank_account_mode === null || $scope.staticCustomerDetails.bank_account_mode === '') {
                    toaster.pop('error', 'Error', "Bank Account is required.", 2000);
                    return false;
                }
                if ($scope.staticCustomerDetails.social_security_or_disability === undefined || $scope.staticCustomerDetails.social_security_or_disability === null || $scope.staticCustomerDetails.social_security_or_disability === '') {
                    toaster.pop('error', 'Error', "Social Security or Disability is required.", 2000);
                    return false;
                }
                if ($scope.staticCustomerDetails.coverage_type === undefined || $scope.staticCustomerDetails.coverage_type === null || $scope.staticCustomerDetails.coverage_type === '') {
                    toaster.pop('error', 'Error', "Coverage type is required.", 2000);
                    return false;
                }
            }
            else if (scriptStep === 2) {
                if (!$scope.staticCustomerDetails.height_feet || !$scope.staticCustomerDetails.height_inches) {
                    toaster.pop('error', 'Error', "Height is required.", 2000);
                    return false;
                }
                if (!$scope.staticCustomerDetails.weight) {
                    toaster.pop('error', 'Error', "Weight is required.", 2000);
                    return false;
                }
                if ($scope.staticCustomerDetails.tobacco_user === undefined || $scope.staticCustomerDetails.tobacco_user === null || $scope.staticCustomerDetails.tobacco_user === '') {
                    toaster.pop('error', 'Error', "Tobacco use selection is required.", 2000);
                    return false;
                }
                if (!$scope.isAtLeastOneDiseaseSelected()) {
                    toaster.pop('error', 'Error', "At least one disease must be selected.", 2000);
                    return false;
                }
            }
            else if (scriptStep === 3) {
                if (!$scope.staticCustomerDetails.beneficiary_first_name || !$scope.staticCustomerDetails.beneficiary_last_name) {
                    toaster.pop('error', 'Error', "Benificiary is required.", 2000);
                    return false;
                }
            }
            return true;
        };
        //static question form data start
        $scope.nexQuestion = function () {
            $scope.staticCustomerDetails.email = $scope.salesuserEmail;
            $scope.updateDOB();
            var data = $scope.staticCustomerDetails;
            console.log(data, "get static data");
            $scope.editFaceValue.value = $scope.staticCustomerDetails.face_value;
            data.step = $scope.scriptStep + 1;
            data.agent_id = parseInt(userId);
            data.caller_id = $scope.strNumber;
            $scope.loading = true;
            if (!$scope.validateStep($scope.scriptStep)) {
                $scope.loading = false;
                return;
            }
            if ($scope.scriptStep < 3) {
                $scope.scriptStep++;
                $scope.staticQuestionsLayout = true;
                $scope.loading = false;
            }
            // console.log($scope.scriptStep, "get stepcount")
            $scope.showFormStep($scope.scriptStep);
            var callbacks = {
                success: function (data) {
                    if ($scope.scriptStep === 3) {
                        $scope.showFormStepFour = true;
                        // $scope.loading = true;
                        $scope.staticPriorityDetails = data.data;
                    }
                    else {
                        // $scope.loading = false;
                        // $scope.showNoOffersMessage = false;
                    }
                },
                error: function (data) {
                    toaster.pop('error', 'Error', data.data);
                    $scope.loading = false;
                },
            };
            UserService.postStaticQuestions(data, callbacks);
        };
        $scope.$watch('step', function (newStep, oldStep) {
            // Reset all steps first
            $('.step').each(function (index) {
                var iconSrc = (index < newStep) ? 'img/bluecheck.png' : (index === newStep ? 'img/bluestep.png' : 'img/greystep.png');
                $(this).css({
                    'background-color': 'transparent',
                    'width': '35px',
                    'height': '35px',
                }).empty().append('<img src="' + iconSrc + '" style="width: 35px; height: 35px;">');
            });
            // Set colors for the completed steps
            $('.number').each(function (index) {
                if (index <= newStep) {
                    $(this).css('color', 'white');
                }
                else {
                    $(this).css('color', '#737373');
                }
            });
        });
        $scope.formBackButton = function (backstep) {
            // console.log(step, "get back step ")
            $scope.scriptStep = backstep - 1;
            // console.log($scope.scriptStep)
            // $scope.showFormStepBack($scope.backStep)
            $scope.showFormStep($scope.scriptStep);
        };
        $scope.validateFaceValue = function () {
            var _a;
            if (((_a = $scope.staticCustomerDetails.face_value) !== null && _a !== void 0 ? _a : 0) < 10000) {
                $scope.form.face_value.$setValidity('min', false);
            }
            else {
                $scope.form.face_value.$setValidity('min', true);
            }
        };
        //navigate eapplink to new window start
        $scope.openNewWindow = function (eapplink) {
            // console.log(eapplink, "get url")
            // window.open(eapplink);
            window.open(eapplink, 'NewTab', 'height=400,width=400');
        };
        //updated face value in carrier page start
        $scope.updateFaceValue = function () {
            $scope.loading = true;
            if (!$scope.editingFaceValue) {
                $scope.editingFaceValue = true;
            }
            $scope.staticQuestionsLayout = true;
            // $scope.staticPriorityLayout = true;
            $scope.showFormStepFour = true;
            var updateFaceData = JSON.parse(JSON.stringify($scope.staticCustomerDetails));
            updateFaceData.face_value = $scope.editFaceValue.value;
            var callbacks = {
                success: function (data) {
                    $scope.staticQuestionsLayout = true;
                    // $scope.staticPriorityLayout = true;
                    $scope.showFormStepFour = true;
                    $scope.staticPriorityDetails = data.data;
                    $scope.staticCustomerDetails.face_value = $scope.editFaceValue.value;
                    if ($scope.staticPriorityDetails.length === 0) {
                        $scope.showNoOffersMessage = true;
                        $scope.loading = false;
                    }
                    else {
                        $scope.showNoOffersMessage = false;
                        $scope.loading = false;
                    }
                },
                error: function (data) {
                    toaster.pop('error', 'Error', data.data);
                    $scope.loading = false;
                    $scope.showNoOffersMessage = false;
                }
            };
            UserService.postStaticQuestions(updateFaceData, callbacks);
        };
        $scope.openHangUpModal = function () {
            // Prevent multiple modals on rapid clicks
            if ($scope._hangupModalOpen) {
                return;
            }
            $scope._hangupModalOpen = true;
            var modalInstance = $modal.open({
                templateUrl: 'tpl/blocks/hangup_status.html',
                controller: 'HangupModalCtrl',
                size: 'md',
                windowClass: 'custom-rounded-modal',
                backdrop: 'static',
                resolve: {
                    object: function () {
                        return {
                            // status: status,
                            // firstName:$scope.username_firstName,
                            // lastName:$scope.username_lastName,
                            id: $scope.user_id,
                            role: $scope.role,
                        };
                    }
                }
            });
            $scope._hangupModalInstance = modalInstance;
            modalInstance.result.then(function (selectedItem) {
                $scope.selected = selectedItem;
                $scope._hangupModalOpen = false;
                $scope._hangupModalInstance = null;
                if ($scope.selected === 'ok') {
                    $scope.hangupSalesAgentCall();
                }
                // clear modal guard
            }, function () {
                // clear modal guard on dismiss
                $scope._hangupModalOpen = false;
                $scope._hangupModalInstance = null;
            });
        };
        $scope.endCall = function () {
            $scope.openHangUpModal();
        };
        //edit static question start
        $scope.editsalesPanel = function () {
            $scope.editSalesScript = true;
            $scope.editData = angular.copy($scope.staticCustomerDetails);
            // console.log($scope.editData, "edit ------------ form")
            $scope.editData.dob = $scope.staticCustomerDetails.dob;
            $scope.editData.email = $scope.staticCustomerDetails.email;
        };
        //save static questions start
        $scope.savesalesPanel = function () {
            $scope.editSalesScript = false;
            // console.log($scope.editData.dob, $scope.staticCustomerDetails.dob)
            if ($scope.editData.dobDay && $scope.editData.dobMonth && $scope.editData.dobYear) {
                $scope.editData.dob = $scope.editData.dobDay + '/' + $scope.editData.dobMonth + '/' + $scope.editData.dobYear;
                // console.log($scope.editData.dob,"from form")
            }
            else {
                $scope.editData.dob = "";
            }
            $scope.staticCustomerDetails = angular.copy($scope.editData);
            // console.log( $scope.staticCustomerDetails, "from save panel")
            $scope.editFaceValue.value = $scope.staticCustomerDetails.face_value;
            $scope.calculateAge();
            // $scope.calculateEditAge()
            var existingDisease = $scope.staticCustomerDetails.medications;
            // console.log(existingDisease, "while saving -----------------------------")
            // var newDiseases = Object.entries($scope.editData.selectionDiesases).filter(function(disease) {
            //     return (
            //       $scope.editData.selectionDiesases[disease] &&
            //       !existingDisease.includes(disease)
            //     );
            //   })
            //   console.log(newDiseases, "new -------------")
            //   $scope.staticCustomerDetails.selectionDiesases =  existingDisease.concat(newDiseases).filter(function(disease){
            //     return disease !== undefined;
            //   });
            // console.log("get save details", $scope.staticCustomerDetails);
            var updateData = $scope.staticCustomerDetails;
            if (!updateData.email) {
                updateData.email = '';
            }
            if (!updateData.gender) {
                updateData.gender = '';
            }
            // if(!updateData.face_value) {
            //     updateData.face_value = 0
            // }
            // if(updateData.bank_account == null) {
            //     updateData.bank_account = false;
            // }
            // if(updateData.opt_in_sms == null) {
            //     updateData.opt_in_sms = false;
            // }
            if (updateData.tobacco_user == null) {
                updateData.tobacco_user = false;
            }
            if (updateData.zip_code == null) {
                updateData.zip_code = 0;
            }
            if (!updateData.agent_id) {
                updateData.agent_id = parseInt(userId);
            }
            if (!updateData.caller_id) {
                updateData.caller_id = $scope.strNumber;
            }
            var callbacks = {
                success: function (data) {
                    if ($scope.staticQuestionsLayout == true) {
                        $scope.staticQuestionsLayout = true;
                        // $scope.scriptStep = 0;
                        // $scope.showFormStepOne = true;
                    }
                    // else if($scope.staticPriorityLayout == true){
                    //     $scope.staticPriorityLayout = true;
                    // }
                    else if ($scope.salesDisposition == true) {
                        $scope.salesDisposition = true;
                    }
                    $scope.staticPriorityDetails = data.data;
                    toaster.pop('success', 'Success', 'Details updated successfully', 2000);
                },
                error: function (data) {
                    toaster.pop('error', 'Error', data.data);
                }
            };
            UserService.postStaticQuestions(updateData, callbacks);
        };
        var lastStatsCallTime = 0;
        var STATS_DEBOUNCE_MS = 2000;
        $scope.getsalesAgentStats = function () {
            var now = Date.now();
            if (now - lastStatsCallTime < STATS_DEBOUNCE_MS) {
                return;
            }
            lastStatsCallTime = now;
            var callbacks = {
                success: function (data) {
                    $scope.userStats = data.data;
                    // console.log($scope.userStats,"get salesagent data")
                },
                error: function (data) {
                    toaster.pop('error', 'Error', data.data);
                }
            };
            UserService.getSalesDashboardDetails(userId, $scope.getsalesRole, callbacks);
        };
        $scope.getAgentStats = function () {
            var callbacks = {
                success: function (data) {
                    $scope.userStats = data.data;
                    // console.log($scope.userStats, "get agent details")
                },
                error: function (data) {
                    toaster.pop('error', 'Error', data.data);
                }
            };
            UserService.getDashboardDetails(userId, $scope.getuserRole, callbacks);
        };
        $scope.setAgentFirsAandLastName = function () {
            $scope.username_firstName = window.localStorage.getItem("first_name") || '';
            $scope.username_lastName = window.localStorage.getItem("last_name") || '';
            $scope.user_name = window.localStorage.getItem("user_name") || '';
            $scope.user_id = window.localStorage.getItem("user_id") || '';
            $scope.role = window.localStorage.getItem("role");
            if ($scope.role === 'AGENT') {
                $scope.role = 'salesagent';
            }
            $scope.email = window.localStorage.getItem("email") || '';
            if ($scope.role == 'useragent') {
                $scope.getuserRole = $scope.role;
                $scope.getAgentStats();
            }
            else if ($scope.role == 'salesagent') {
                $scope.getsalesRole = $scope.role;
                $scope.getsalesAgentStats();
            }
        };
        $scope.limitTextLength = function (text) {
            return text.slice(0, 4) + '..';
        };
        $scope.setAgentFirsAandLastName();
        $scope.characterCount = 0;
        $scope.updateCharacterCount = function () {
            $scope.characterCount = $scope.notes.length;
        };
        $scope.handlePaste = function (event) {
            event.preventDefault();
            if (navigator.clipboard) {
                navigator.clipboard.readText().then(function (pastedData) {
                    var newLength = ($scope.notes ? $scope.notes.length : 0) + pastedData.length;
                    if (newLength > 4096) {
                        toaster.pop('error', 'Error', 'You cannot exceed 4096 characters.');
                    }
                    else {
                        $scope.notes += pastedData;
                        $scope.updateCharacterCount();
                    }
                }).catch(function (err) {
                    console.error('Failed to read clipboard contents: ', err);
                });
            }
            else {
            }
        };
        $scope.limitInput = function (event) {
            if ($scope.notes.length >= 4096 && event.key !== "Backspace" && event.key !== "Delete") {
                event.preventDefault();
                toaster.pop('error', 'Error', 'You cannot exceed 4096 characters.');
            }
        };
        $scope.saveNotes = function () {
            // console.log("Notes auto-saved: ", $scope.notes);
            if ($scope.notes.length <= 4096) {
                var callbacks = {
                    success: function (data) {
                        // console.log($scope.notes, "from sucess")
                    },
                    error: function (data) {
                        toaster.pop('error', 'Error', data.data);
                        $scope.loading = false;
                    },
                };
                UserService.notesUpdate($scope.strNumber, $scope.user_id, $scope.notes, callbacks);
            }
        };
        // repeatedly hitting server to check net connectivity -start
        //  window.clearInterval(timerInter);
        //         timerInter = window.setInterval(function(){
        //      if($scope.statusValue=='online' || $scope.statusValue=='offline'){ //added -agent logged in status
        //             $scope.postConnectionDetails();
        //             console.log("connection");
        //     }
        // },30000);
        $scope.getAgentStatus = function () {
            if ($scope.duplicateTab)
                return;
            var callbacks = {
                success: function (data) {
                    // Reconcile the backend-reported agent status with the local one.
                    // A mismatch (typically frontend online / backend offline) is the
                    // desync that breaks call routing: log it to Sentry and re-assert
                    // our status through the socket so the backend re-registers us.
                    try {
                        var backendStatus = data && data.data && data.data.status;
                        if (!backendStatus) {
                            return;
                        }
                        // Skip while a status transition is in flight or a reconnect is
                        // pending: state is expected to disagree briefly during those.
                        if ($scope.pendingStatusUpdate || $scope.agentDashboradLoaderFlag || $scope.reconnectingState) {
                            return;
                        }
                        var localStatus = $scope.agentDashboardStatus.value;
                        var localOnline = isOnlineDesired();
                        var backendOnline = backendStatus !== 'offline';
                        if (localOnline !== backendOnline) {
                            console.warn('Status desync detected. frontend=' + localStatus + ' backend=' + backendStatus);
                            $scope.sendMessageToSentry('status-desync', {
                                agentId: userId,
                                agentName: $scope.username_firstName + ' ' + $scope.username_lastName,
                                frontendStatus: localStatus,
                                backendStatus: backendStatus,
                                socketReadyState: $rootScope.socket ? $rootScope.socket.readyState : 'no-socket',
                                timestamp: new Date().toLocaleString('en-US', { timeZone: 'UTC', hour12: false })
                            });
                            if (localOnline && $rootScope.socket && $rootScope.socket.readyState === WebSocket.OPEN) {
                                var statusToRestore = localStatus === 'offline' ? 'waiting' : localStatus;
                                $scope.setCallStatus(statusToRestore, true);
                            }
                            else if (localOnline) {
                                console.warn('Desync with no OPEN socket — starting reconnect flow');
                                $scope.reconnectingState = true;
                                startRecoveryWindow('backend-status-desync');
                                scheduleSocketReconnect('backend-status-desync');
                            }
                        }
                    }
                    catch (e) {
                        console.error('Status reconciliation failed', e);
                    }
                },
                error: function (data) {
                    // Called periodically — log instead of spamming toasters.
                    console.error('getAgentStatus failed', data && data.data);
                }
            };
            UserService.getAgentStatus(userId, $scope.role, callbacks);
        };
        var timerInter;
        $scope.statusValue = isOnlineDesired() ? 'online' : 'offline'; // Example status value, change as needed
        // Function to start the timeout-based interval
        function startTimeout() {
            // Clear any existing timeout
            if (angular.isDefined(timerInter)) {
                $timeout.cancel(timerInter);
            }
            function executeTimeout() {
                if ($scope.statusValue === 'online' || $scope.statusValue === 'offline') {
                    $scope.postConnectionDetails();
                    // console.log("connection");
                }
                // Periodic frontend/backend status reconciliation. Only relevant
                // while the UI believes the agent is online — that is the direction
                // of the desync that breaks call routing.
                if (isOnlineDesired()) {
                    $scope.getAgentStatus();
                }
                // Schedule the next execution after 20 seconds
                timerInter = $timeout(executeTimeout, 20000);
            }
            // Start the recurring timeout
            executeTimeout();
        }
        // Function to stop the timeout-based interval
        function stopTimeout() {
            if (angular.isDefined(timerInter)) {
                $timeout.cancel(timerInter);
                timerInter = undefined;
            }
        }
        // Example functions to start and stop the interval
        $scope.startConnectionCheck = function () {
            startTimeout();
            $scope.getAgentStatus();
        };
        $scope.stopConnectionCheck = function () {
            console.log('stopped connection timer');
            stopTimeout();
        };
        // Cleanup interval on scope destroy to avoid memory leaks
        $scope.$on('$destroy', function () {
            stopTimeout();
            cancelSocketReconnect();
            if ($scope.reconnectTimer) {
                $timeout.cancel($scope.reconnectTimer);
                $scope.reconnectTimer = null;
            }
            if (plivoRecoveryTimer) {
                $timeout.cancel(plivoRecoveryTimer);
                plivoRecoveryTimer = null;
            }
            if (statusAnnouncementTimer) {
                $timeout.cancel(statusAnnouncementTimer);
                statusAnnouncementTimer = null;
            }
            if (foregroundHeartbeatTimer) {
                $timeout.cancel(foregroundHeartbeatTimer);
                foregroundHeartbeatTimer = null;
            }
            clearPlivoLoginGuard();
            resetStatusMessagingState();
            clearInterval(statusHistoryCleanupInterval);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            window.removeEventListener('focus', handleWindowFocus);
            window.removeEventListener('online', handleBrowserOnline);
            window.removeEventListener('offline', handleBrowserOffline);
            window.removeEventListener('beforeunload', handleBeforeUnload);
            window.removeEventListener('unload', handlePageUnload);
            webSocketService.discard();
        });
        $scope.postConnectionDetails = function () {
            var callbacks = {
                success: function (data, status) {
                    // console.log('postConnectionDetails -->',data,status)
                    if (status == 200) {
                        var apiWasDisconnected = $scope.internetDisconnectedByApi;
                        $scope.internetDisconnectedByApi = false;
                        $scope.netflag = true;
                        if (apiWasDisconnected) {
                            console.log('Connected By API Call — recovering both transports');
                            toaster.pop('success', 'Success', 'Internet connection restored', 3000);
                        }
                        if (isOnlineDesired()) {
                            if (!$rootScope.socket || $rootScope.socket.readyState !== WebSocket.OPEN) {
                                $scope.connectWebSocketConnection(userId, true);
                            }
                            recoverPlivoRegistration('api-connectivity-restored');
                            announceStatusWhenReady('api-connectivity-restored');
                            clearRecoveryIfHealthy();
                        }
                        else if (isPlivoRegistered()) {
                            $scope.logoutPlivo();
                        }
                    }
                    if (status == 502 || status == -1) {
                        console.log('Agent internet check. Failed');
                        $scope.agentDashboradLoaderFlag = false;
                        if (isOnlineDesired()) {
                            if (!$scope.internetDisconnectedByApi) {
                                toaster.pop('error', 'Error', 'Internet disconnected');
                            }
                            $scope.internetDisconnectedByApi = true;
                            $scope.netflag = false;
                            $scope.reconnectingState = true;
                            $scope.isToggleDisabled = false;
                            startRecoveryWindow('api-connectivity-failed');
                            scheduleSocketReconnect('api-connectivity-failed');
                            schedulePlivoRecovery('api-connectivity-failed');
                        }
                    }
                },
                error: function (data) {
                    console.log('Failure..................');
                    if (isOnlineDesired()) {
                        $scope.internetDisconnectedByApi = true;
                        $scope.reconnectingState = true;
                        $scope.agentDashboradLoaderFlag = false;
                        $scope.isToggleDisabled = false;
                        startRecoveryWindow('api-connectivity-error');
                        scheduleSocketReconnect('api-connectivity-error');
                        schedulePlivoRecovery('api-connectivity-error');
                    }
                    $scope.loading = false;
                }
            };
            var role = 'salesagent';
            UserService.postConnectionDetails(userId, role, callbacks);
        };
        //repeatedly hitting server to check net connectivity -end
        // added -agent logged in status - start
        // added -agent logged in status - end
        $scope.getCallerDetails = function (id) {
            var callbacks = {
                success: function (data) {
                    $scope.userDetails = data.data;
                    $scope.userCallId = data.data.id;
                },
                error: function (data) {
                    toaster.pop('error', 'Error', data.data);
                }
            };
            UserService.getUserDetails(id, $scope.getuserRole, callbacks);
        };
        $scope.getsalesCallerDetails = function (id) {
            console.log('-----getsalesCallerDetails----', id);
            // Track retry attempts
            if (!$scope.salesCallerRetryCount) {
                $scope.salesCallerRetryCount = 0;
            }
            var callbacks = {
                success: function (data) {
                    if (data && data.data) {
                        // Clear retry count on success
                        $scope.salesCallerRetryCount = 0;
                        $scope.salesuserDetails = data.data;
                        $scope.salesuserCallId = data.data.id;
                        // console.log('$scope.salesuserDetails,',$scope.salesuserDetails);
                        // console.log('$scope.salesuserCallId',$scope.salesuserCallId);
                        $scope.salesuserEmail = data.data.email;
                        data.data.email = $scope.staticCustomerDetails.email;
                        $scope.staticCustomerDetails.secondary_phone_number = ($scope.salesuserDetails.phone_number || '').slice(-11);
                        // prepopulate the data for the existing customer
                        $scope.staticCustomerDetails.first_name = $scope.salesuserDetails.first_name || "";
                        $scope.staticCustomerDetails.last_name = $scope.salesuserDetails.last_name || "";
                        $scope.staticCustomerDetails.gender = $scope.salesuserDetails.gender || null;
                        $scope.staticCustomerDetails.email = $scope.salesuserDetails.email || '';
                        $scope.staticCustomerDetails.street1 = $scope.salesuserDetails.street1 || "";
                        $scope.staticCustomerDetails.street2 = $scope.salesuserDetails.street2 || "";
                        $scope.staticCustomerDetails.zip_code = $scope.salesuserDetails.zip_code || '';
                        $scope.staticCustomerDetails.city = $scope.salesuserDetails.city || '';
                        $scope.staticCustomerDetails.state = $scope.salesuserDetails.state || '';
                        if ($scope.salesuserDetails.dob && $scope.salesuserDetails.dob !== 'null') {
                            var dob = new Date($scope.salesuserDetails.dob);
                            $scope.staticCustomerDetails.dobMonth = String(dob.getMonth() + 1);
                            $scope.staticCustomerDetails.dobDay = String(dob.getDate());
                            $scope.staticCustomerDetails.dobYear = String(dob.getFullYear());
                            $scope.updateDays();
                        }
                        else {
                            $scope.staticCustomerDetails.dobMonth = '';
                            $scope.staticCustomerDetails.dobDay = '';
                            $scope.staticCustomerDetails.dobYear = '';
                        }
                        $scope.staticCustomerDetails.age = $scope.salesuserDetails.age || "";
                        $scope.staticCustomerDetails.secondary_phone_number = ($scope.salesuserDetails.phone_number || '').slice(-11) || '';
                        // $scope.staticCustomerDetails.opt_in_sms = $scope.salesuserDetails.opt_in_sms || '';
                        $scope.staticCustomerDetails.opt_in_sms = ($scope.salesuserDetails.opt_in_sms === true) ? 1 : ($scope.salesuserDetails.opt_in_sms === false ? 0 : null);
                        $scope.staticCustomerDetails.bank_account_mode = $scope.salesuserDetails.bank_account_mode || '';
                        // $scope.staticCustomerDetails.social_security_or_disability = $scope.salesuserDetails.social_security_or_disability || null;
                        $scope.staticCustomerDetails.social_security_or_disability = ($scope.salesuserDetails.social_security_or_disability === true) ? 1 : ($scope.salesuserDetails.social_security_or_disability === false ? 0 : null);
                        $scope.staticCustomerDetails.coverage_type = $scope.salesuserDetails.coverage_type || null;
                        $scope.staticCustomerDetails.height_feet = $scope.salesuserDetails.height_feet || "";
                        $scope.staticCustomerDetails.height_inches = $scope.salesuserDetails.height_inches || "";
                        $scope.staticCustomerDetails.weight = $scope.salesuserDetails.weight || "";
                        // $scope.staticCustomerDetails.tobacco_user = $scope.salesuserDetails.tobacco_user || null;
                        $scope.staticCustomerDetails.tobacco_user = ($scope.salesuserDetails.tobacco_user === true) ? 1 : ($scope.salesuserDetails.tobacco_user === false ? 0 : null);
                        $scope.staticCustomerDetails.medications = $scope.salesuserDetails.medications || " ";
                        $scope.staticCustomerDetails.beneficiary_first_name = $scope.salesuserDetails.beneficiary_first_name || "";
                        $scope.staticCustomerDetails.beneficiary_last_name = $scope.salesuserDetails.beneficiary_last_name || "";
                    }
                    else {
                        console.log("Data not available, retrying getsalesCallerDetails. Attempt:", $scope.salesCallerRetryCount + 1);
                        if ($scope.salesCallerRetryCount < 10) {
                            $scope.salesCallerRetryCount++;
                            $scope.getsalesCallerDetails(id);
                        }
                        else {
                            console.log("Failed to get data after retries");
                            $scope.salesCallerRetryCount = 0; // Clear retry count
                            toaster.pop('error', 'Error', 'Failed to load caller details after retries');
                        }
                    }
                },
                error: function (data) {
                    console.log("Error fetching data, retrying getsalesCallerDetails. Attempt:", $scope.salesCallerRetryCount + 1);
                    if ($scope.salesCallerRetryCount < 10) {
                        $scope.salesCallerRetryCount++;
                        $scope.getsalesCallerDetails(id);
                    }
                    else {
                        $scope.salesCallerRetryCount = 0; // Clear retry count
                        toaster.pop('error', 'Error', data.data);
                    }
                }
            };
            UserService.getSalesUserDetails(id, userId, callbacks);
        };
        $scope.getIVRDetails = function (id) {
            // console.log("get IVR details",id)
            $scope.forwardflag = false;
            $scope.rightblock = false;
            $scope.filterobj = {};
            $scope.sidecondition = false;
            $scope.scriptDetails = {};
            var callbacks = {
                success: function (data) {
                    $scope.scriptResponse = data.data; //added
                    $scope.scriptDetails = data.data.headers;
                    // console.log($scope.scriptDetails,"get total data ")
                    $scope.scriptCallId = data.data.call_id;
                    // console.log("get script CALL ID",$scope.scriptCallId);
                    for (var i = 0; i <= $scope.scriptDetails.length; i++) {
                        if ($scope.scriptDetails[i]) {
                            if ($scope.scriptDetails[i].header_type.code == 'askseriesofquestions') {
                                $scope.seriesQuestionsObject = $scope.scriptDetails[i].questions;
                            }
                        }
                    }
                },
                error: function (data) {
                    toaster.pop('error', 'Error', data.data);
                }
            };
            UserService.getIVRDetails(id, userId, callbacks);
        };
        $scope.meal_index = 0;
        $scope.meal_index_1 = 0;
        $scope.meal = {};
        $scope.nextQuestion = function () {
            if ($scope.meal_index >= $scope.scriptDetails.length - 1) {
                $scope.meal_index = 0;
            }
            else {
                $scope.meal_index++;
            }
            if ($scope.meal_index + 1 == $scope.scriptDetails.length) {
                //console.log("equaled")
            }
        };
        $scope.back = function () {
            if ($scope.meal_index <= $scope.scriptDetails.length + 1) {
                $scope.meal_index = 0;
            }
            else {
                $scope.meal_index--;
            }
            if ($scope.meal_index == $scope.scriptDetails.length) {
                //console.log("no back")
            }
        };
        $scope.next_1 = function () {
            if ($scope.meal_index_1 >= $scope.seriesQuestionsObject.length - 1) {
                $scope.meal_index_1 = 0;
            }
            else {
                $scope.meal_index_1++;
            }
            if ($scope.meal_index_1 + 1 == $scope.seriesQuestionsObject.length) {
                //console.log("equaled")
            }
        };
        $scope.back_1 = function () {
            if ($scope.meal_index_1 <= $scope.seriesQuestionsObject.length + 1) {
                $scope.meal_index_1 = 0;
            }
            else {
                $scope.meal_index_1--;
            }
            if ($scope.meal_index_1 == $scope.seriesQuestionsObject.length) {
                //console.log("no back")
            }
        };
        $scope.getButton = function (lead_fieldCode, txt) {
            if (lead_fieldCode === 'zipcode') {
                var user_zipcode = txt.responseTextInputSeries;
                if (user_zipcode && user_zipcode.length === 5) {
                    var callbacks = {
                        success: function (data) {
                            if (data.data) {
                                $scope.location = data.data;
                            }
                        },
                        error: function (data) {
                            toaster.pop('error', 'Error', data.data);
                            $scope.location = {};
                        }
                    };
                    UserService.getStateCity(user_zipcode, callbacks);
                }
                else {
                    $scope.location = {};
                }
            }
            var bt = document.getElementById('btSubmit');
            if (lead_fieldCode === 'email') {
                if (txt.responseTextInputSeries === null || txt.responseTextInputSeries != '') {
                    bt.disabled = false;
                    bt.style.background = "#2196f3";
                    bt.style.color = "white";
                }
            }
            else {
                if (txt.responseTextInputSeries != '') {
                    bt.disabled = false;
                    bt.style.background = "#2196f3";
                    bt.style.color = "white";
                }
                else {
                    bt.disabled = true;
                    bt.style.background = "grey";
                    bt.style.color = "white";
                }
            }
        };
        $scope.getButton1 = function (txt) {
            var bt1 = document.getElementById('btSubmit1');
            if (txt.responseTextInputSingle != '') {
                bt1.disabled = false;
                bt1.style.background = "#2196f3";
                bt1.style.color = "white";
            }
            else {
                bt1.disabled = true;
                bt1.style.background = "grey";
                bt1.style.color = "white";
            }
        };
        $scope.getButton2 = function (txt) {
            var bt2 = document.getElementById('btSubmit2');
            if (txt.responseTextInputVerify != '') {
                bt2.disabled = false;
                bt2.style.background = "#2196f3";
                bt2.style.color = "white";
            }
            else {
                bt2.disabled = true;
                bt2.style.background = "grey";
                bt2.style.color = "white";
            }
        };
        // $scope.postAnswerAgentStatus = function(){
        //     console.log("entered answered")
        //         var callbacks = {
        //             success: function(data) {
        //             },
        //             error: function(data) {
        //                 toaster.pop('error', 'Error', data.data);
        //             }
        //         };
        //     UserService.postAgentAvailable({"answered":true},userId,callbacks);
        // }
        $scope.postAgentBusyStatus = function () {
            var callbacks = {
                success: function (data) {
                    $scope.agstatus = 'busy'; //added
                },
                error: function (data) {
                    toaster.pop('error', 'Error', data.data);
                }
            };
            UserService.postAgentStatusUpdate({ "status": 'busy' }, userId, $scope.role, callbacks);
        };
        $scope.postAgentAvailableStatus = function () {
            var callbacks = {
                success: function (data) {
                    $scope.agstatus = 'available';
                    if ($scope.role == 'useragent') {
                        $scope.getAgentStats();
                    }
                    else if ($scope.role == 'salesagent') {
                        $scope.getsalesAgentStats();
                    }
                },
                error: function (data) {
                    toaster.pop('error', 'Error', data.data);
                }
            };
            UserService.postAgentStatusUpdate({ "status": 'available' }, userId, $scope.role, callbacks);
        };
        $scope.checkZipcode = function () {
            var edit_zipcode = $scope.editData && $scope.editData.zip_code;
            var static_zipcode = $scope.staticCustomerDetails && $scope.staticCustomerDetails.zip_code;
            var check_zipcode = edit_zipcode !== undefined && edit_zipcode !== null ? edit_zipcode : $scope.staticCustomerDetails.zip_code;
            if (check_zipcode && check_zipcode.length === 5) {
                var callbacks = {
                    success: function (data) {
                        if (data.data) {
                            $scope.location = data.data;
                            // console.log($scope.location, "location api")
                            if (edit_zipcode !== undefined && edit_zipcode !== null) {
                                $scope.editData.city = $scope.location.city;
                                $scope.editData.state = $scope.location.state;
                            }
                            else {
                                $scope.staticCustomerDetails.city = $scope.location.city;
                                $scope.staticCustomerDetails.state = $scope.location.state;
                            }
                        }
                    },
                    error: function (data) {
                        toaster.pop('error', 'Error', data.data);
                        $scope.location = {};
                        $scope.staticCustomerDetails.city = '';
                        $scope.staticCustomerDetails.state = '';
                        $scope.editData.city = '';
                        $scope.editData.state = '';
                    }
                };
                UserService.getStateCity(check_zipcode, callbacks);
            }
            else {
                $scope.location = {};
                $scope.staticCustomerDetails.city = '';
                $scope.staticCustomerDetails.state = '';
                $scope.editData.city = '';
                $scope.editData.state = '';
            }
        };
        $scope.putTransferAgentStatus = function () {
            var callbacks = {
                success: function (data) {
                    if ($scope.role == 'useragent') {
                        $scope.getAgentStats();
                    }
                    else if ($scope.role == 'salesagent') {
                        $scope.getsalesAgentStats();
                    }
                },
                error: function (data) {
                    toaster.pop('error', 'Error', data.data);
                }
            };
            //UserService.putAgentTransferStatus(userId,callbacks);
            UserService.putAgentTransferStatus(userId, $scope.scriptCallId, callbacks);
        };
        $scope.dataNew = {};
        $scope.dataNew.emptyObject = "";
        $scope.updateLeadFields = function (code, answer) {
            //console.log(code,answer,"called in updateLeadFields")
            var callbacks = {
                success: function (data) {
                    $scope.modifyPhoneNumberUser($scope.phoneNumberIncoming);
                },
                error: function (data) {
                    toaster.pop('error', 'Error', data.data);
                }
            };
            UserService.updateLeadField({ "id": $scope.userCallId, "macros": [{ "key": code, "value": answer }] }, callbacks);
        };
        $scope.disableEdit = function () {
            $("#sideLeadfield input").prop("disabled", true);
            $("#sideLeadfield select").prop("disabled", true);
            $("#edit_right").prop("disabled", true);
            $("#save_right").prop("disabled", true);
        };
        $scope.displayOffersTable = function (data) {
            if (data.data) {
                $scope.offerErrorCode = data.statusCode;
                $scope.offerErrorMsg = data.message;
                $scope.frwdOfferData = data.data;
                $scope.frwdOfferData2 = $scope.frwdOfferData;
                $scope.disableEdit();
                if (data.statusCode == 200) {
                    document.getElementById("offerListFrwd").style.display = 'table';
                    //document.getElementById("offerStmt").style.display='block';
                    document.getElementById("offerStmt").style.visibility = 'visible';
                    var modal = document.getElementById("myModal5");
                    if (modal) {
                        modal.style.display = "none";
                    }
                    //added
                    if ($scope.forwardData.read_data != null) {
                        if (($scope.forwardData.read_data).includes("{offer_display_name}")) {
                            $scope.forwardData.read_data = ($scope.forwardData.read_data).replace(/{offer_display_name}/g, $scope.frwdOfferData[0].offer_name);
                        }
                        document.getElementById("myModal1").style.display = 'block';
                        document.getElementById("myModal1").style.opacity = 1;
                        document.getElementById("myModal1").style.backgroundColor = 'rgb(' + 0 + ',' + 0 + ',' + 0 + ',' + 0.34 + ')';
                    }
                }
            }
        };
        $scope.modifyPhoneNumberUser = function (id) {
            console.log("enter phone number block", id);
            $scope.phoneNumberPlivo = id.split('@');
            $scope.strNumber = $scope.phoneNumberPlivo[0].substring(1);
            // console.log($scope.strNumber, "$scope.strnumber");
            if ($scope.role == 'useragent') {
                $scope.getCallerDetails($scope.strNumber);
            }
            else if ($scope.role == 'salesagent') {
                $scope.getsalesCallerDetails($scope.strNumber);
            }
        };
        $scope.modifyPhoneNumberIVR = function (id) {
            $scope.phoneNumberPlivo = id.split('@');
            $scope.strNumber = $scope.phoneNumberPlivo[0].substring(1);
            $scope.getIVRDetails($scope.strNumber);
        };
        // Custom audio for incoming calls (replaces Plivo ringtone)
        var incomingCallAudio = null;
        var isIncomingCallInProgress = false; // Flag to prevent duplicate audio plays
        var incomingCallAudioTimeout = null;
        var isPageVisible = true;
        function recoverOnForeground(reason) {
            if (!isOnlineDesired() || $scope.duplicateTab || !navigator.onLine)
                return;
            var socket = $rootScope.socket;
            if (socket && socket.readyState === WebSocket.OPEN
                && Date.now() - webSocketKeepAliveBrokerService.getLastAckAt(socket) >= 30000) {
                if (webSocketKeepAliveBrokerService.isAwaitingAck(socket)) {
                    console.warn('[AgentStatusWS] Foreground check found stale heartbeat');
                    webSocketKeepAliveBrokerService.markWatchdogInitiated(socket);
                    socket.close(4000, 'foreground-keep-alive-timeout');
                    return;
                }
                try {
                    var foregroundProbeSentAt = Date.now();
                    webSocketKeepAliveBrokerService.markAwaitingAck(socket);
                    socket.send(JSON.stringify({ agentId: userId, reason: 'keep-alive' }));
                    if (foregroundHeartbeatTimer) {
                        $timeout.cancel(foregroundHeartbeatTimer);
                    }
                    foregroundHeartbeatTimer = $timeout(function () {
                        foregroundHeartbeatTimer = null;
                        if ($rootScope.socket === socket
                            && socket.readyState === WebSocket.OPEN
                            && webSocketKeepAliveBrokerService.getLastAckAt(socket) < foregroundProbeSentAt) {
                            console.warn('[AgentStatusWS] Foreground heartbeat probe timed out');
                            webSocketKeepAliveBrokerService.markWatchdogInitiated(socket);
                            socket.close(4000, 'foreground-keep-alive-timeout');
                        }
                    }, 5000);
                }
                catch (e) {
                    console.error('[AgentStatusWS] Foreground heartbeat probe failed', e);
                    socket.close(4000, 'foreground-keep-alive-failed');
                }
            }
            if (!socket || socket.readyState !== WebSocket.OPEN) {
                $scope.reconnectingState = true;
                startRecoveryWindow(reason);
                scheduleSocketReconnect(reason);
            }
            recoverPlivoRegistration(reason);
            schedulePlivoRecovery(reason);
            announceStatusWhenReady(reason);
            clearRecoveryIfHealthy();
        }
        function handleVisibilityChange() {
            isPageVisible = !document.hidden;
            console.log('Page visibility changed:', isPageVisible ? 'visible' : 'hidden');
            if (isPageVisible) {
                recoverOnForeground('visibility-visible');
            }
        }
        function handleWindowFocus() {
            recoverOnForeground('window-focus');
        }
        document.addEventListener('visibilitychange', handleVisibilityChange);
        window.addEventListener('focus', handleWindowFocus);
        $scope.playIncomingCallAudio = function () {
            try {
                // Prevent duplicate audio plays
                if (isIncomingCallInProgress) {
                    console.log('Incoming call audio already playing, skipping duplicate play');
                    return;
                }
                if (!incomingCallAudio) {
                    incomingCallAudio = new Audio('img/count-down.mp3');
                    incomingCallAudio.loop = false; // Loop the ringtone
                    console.log('Incoming call audio object created');
                }
                else {
                    incomingCallAudio.pause();
                    incomingCallAudio.currentTime = 0;
                    console.log('Incoming call audio object reset for reuse');
                }
                incomingCallAudio.volume = 1.0;
                isIncomingCallInProgress = true; // Set flag before attempting to play
                if (incomingCallAudioTimeout) {
                    clearTimeout(incomingCallAudioTimeout);
                }
                incomingCallAudioTimeout = setTimeout(function () {
                    if (isIncomingCallInProgress) {
                        console.warn('Audio flag auto-reset after 5 seconds - possible stuck state');
                        isIncomingCallInProgress = false;
                    }
                }, 5000);
                // Play audio with user interaction
                var handleIncomingCallAudioError = function (error) {
                    console.error('Audio play failed:', error);
                    isIncomingCallInProgress = false; // Reset flag on failure
                    $scope.flashWindowTitle('INCOMING CALL');
                    if (incomingCallAudioTimeout) {
                        clearTimeout(incomingCallAudioTimeout);
                        incomingCallAudioTimeout = null;
                    }
                };
                var startIncomingCallAudioPlayback = function () {
                    if (!isIncomingCallInProgress) {
                        return;
                    }
                    var playPromise = incomingCallAudio.play();
                    if (playPromise !== undefined) {
                        playPromise.then(function () {
                            console.log('Incoming call audio playing successfully');
                            if (!isPageVisible) {
                                console.warn('Page not visible - incoming call audio may be throttled by browser');
                                $scope.flashWindowTitle('INCOMING CALL');
                            }
                        }).catch(handleIncomingCallAudioError);
                    }
                };
                var routedIncomingCallAudio = incomingCallAudio;
                var incomingCallSinkId = $scope.selectedAudioOutputDeviceId === 'default'
                    ? ''
                    : ($scope.selectedAudioOutputDeviceId || '');
                if (routedIncomingCallAudio.setSinkId) {
                    routedIncomingCallAudio.setSinkId(incomingCallSinkId)
                        .then(startIncomingCallAudioPlayback)
                        .catch(function (error) {
                        console.error('Failed to route incoming call audio output', error);
                        startIncomingCallAudioPlayback();
                    });
                }
                else {
                    startIncomingCallAudioPlayback();
                }
            }
            catch (error) {
                console.error('Error in playIncomingCallAudio:', error);
                isIncomingCallInProgress = false; // Reset flag on error
                if (incomingCallAudioTimeout) {
                    clearTimeout(incomingCallAudioTimeout);
                    incomingCallAudioTimeout = null;
                }
                $scope.flashWindowTitle('INCOMING CALL');
            }
        };
        $scope.stopIncomingCallAudio = function () {
            try {
                if (incomingCallAudio) {
                    incomingCallAudio.pause();
                    incomingCallAudio.currentTime = 0;
                    console.log('Incoming call audio stopped');
                }
                isIncomingCallInProgress = false;
                if (incomingCallAudioTimeout) {
                    clearTimeout(incomingCallAudioTimeout);
                    incomingCallAudioTimeout = null;
                }
                $scope.stopFlashingTitle();
            }
            catch (error) {
                console.error('Error stopping audio:', error);
                isIncomingCallInProgress = false; // Reset flag on error
                if (incomingCallAudioTimeout) {
                    clearTimeout(incomingCallAudioTimeout);
                    incomingCallAudioTimeout = null;
                }
            }
        };
        var titleFlashInterval = null;
        var originalTitle = document.title;
        $scope.flashWindowTitle = function (message) {
            if (titleFlashInterval) {
                return;
            }
            originalTitle = document.title;
            var isFlashed = false;
            titleFlashInterval = setInterval(function () {
                document.title = isFlashed ? originalTitle : ('📞 ' + message);
                isFlashed = !isFlashed;
            }, 1000);
            console.log('Window title flashing started:', message);
        };
        $scope.stopFlashingTitle = function () {
            if (titleFlashInterval) {
                clearInterval(titleFlashInterval);
                titleFlashInterval = null;
                document.title = originalTitle;
                console.log('Window title flashing stopped');
            }
        };
        $scope.answerW = function () {
            console.log("Call answering...", $scope.callUUID);
            $scope.stopIncomingCallAudio(); // Stop ringtone when answering
            $('#status_txt').text('Answering....');
            $rootScope.plivoWebSdk.client.answer($scope.callUUID, 'reject');
            console.log('agentDashboardStatus =========>', $scope.agentDashboardStatus.value);
            if ($rootScope.plivoWebSdk.client.getCallUUID()) {
                $scope.setCallStatus('oncall');
            }
            else if ($scope.agentDashboardStatus.value !== 'paused') {
                settingOnEndCallLayout();
            }
            $('#status_txt').text('Answered the Call');
            $('#btn-container').show();
            $('#incoming_callbox').hide();
            $scope.postAgentBusyStatus();
            // Unmask the phone number after the provided duration header (seconds), default 5s
            try {
                if ($scope.unmaskTimer) {
                    $timeout.cancel($scope.unmaskTimer);
                }
            }
            catch (_) { }
            var unmaskAfterSec = (typeof $scope.unmaskAfterSeconds === 'number' && $scope.unmaskAfterSeconds > 0) ? $scope.unmaskAfterSeconds : 5;
            $scope.unmaskTimer = $timeout(function () {
                $scope.isPhoneMasked = false;
                $scope.unmaskedByDuration = true;
            }, unmaskAfterSec * 1000);
        };
        $scope.formatPhoneNumber = function (phoneNumber) {
            phoneNumber = phoneNumber.replace(/^1|^91/, '');
            var formattedPhoneNumber = phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
            return formattedPhoneNumber;
        };
        $scope.getDisplayedPhoneNumber = function (phoneNumber) {
            if (!phoneNumber)
                return 'N/A';
            var formatted = $scope.formatPhoneNumber(phoneNumber);
            if ($scope.isPhoneMasked) {
                // Mask the last 4 digits
                return formatted.replace(/\d{4}$/, 'XXXX');
            }
            else {
                return formatted;
            }
        };
        $scope.resetSalesPages = function () {
            $scope.staticCustomerDetails = {
                first_name: '',
                last_name: '',
                gender: null,
                email: null,
                zip_code: null,
                city: '',
                state: '',
                street1: '',
                street2: '',
                dobMonth: '',
                dobDay: '',
                dobYear: '',
                secondary_phone_number: "",
                opt_in_sms: '',
                bank_account_mode: '',
                social_security_or_disability: null,
                coverage_type: null,
                height_feet: '',
                height_inches: '',
                weight: '',
                // face_value: '',
                tobacco_user: null,
                medications: "",
                beneficiary_first_name: "",
                beneficiary_last_name: " ",
                price_aware: false,
            };
            $scope.notes = '',
                $scope.location = {};
            $scope.editFaceValue = {};
            $scope.editingFaceValue = false;
            $scope.showNoOffersMessage = false;
            $scope.editData = {};
            $scope.scriptStep = 0;
            $scope.showFormStepOne = false;
            $scope.showFormStepTwo = false;
            $scope.showFormStepThree = false;
            $scope.showFormStepFour = false;
            $scope.staticQuestionsLayout = false;
            $scope.staticPriorityLayout = false;
            $scope.salesLayout = false;
            $scope.salesDisposition = false;
            $scope.salesEndDisposition = false;
            $scope.isPhoneMasked = true; // Reset masking to true
            $scope.unmaskedByDuration = false;
        };
        // Customer service call section state
        $scope.showCustomerServiceSection = false;
        $scope.customerServiceChannel = null;
        $scope.customerServiceSource = null;
        $scope.customerServiceCallType = null;
        $scope.campaignVerticalName = null;
        $scope.customerServiceCountdown = 0;
        $scope.countdownInterval = null;
        $scope.isFEScript = true;
        $scope.startCustomerServiceCountdown = function () {
            $scope.customerServiceCountdown = 1;
            if ($scope.countdownInterval) {
                clearInterval($scope.countdownInterval);
            }
            $scope.countdownInterval = window.setInterval(function () {
                $scope.$apply(function () {
                    $scope.customerServiceCountdown--;
                    if ($scope.customerServiceCountdown <= 0) {
                        $scope.showCustomerServiceSection = false;
                        if ($scope.countdownInterval) {
                            clearInterval($scope.countdownInterval);
                            $scope.countdownInterval = null;
                        }
                    }
                });
            }, 1000);
        };
        $scope.salesIncomingCall = function (callerName, extraHeaders) {
            var _a, _b;
            console.log('-------- salesIncomingCall call -------', callerName, extraHeaders);
            $scope.isPhoneMasked = true; // Initially mask the phone number
            $scope.unmaskAfterSeconds = null; // will be set from headers if provided
            $scope.unmaskedByDuration = false;
            if ($scope.lastRecievedCaller !== callerName) {
                $scope.lastRecievedCaller = callerName;
                console.log('-------- here 1 -------');
                $scope.setCallStatus('incomingcall');
                $scope.phoneNumberIncoming = callerName;
                console.log('-------- here 2 -------');
                console.log('SIP HEADERS:', extraHeaders);
                // Open the Customer Service info section with channel and source whenever extra headers are present
                if (extraHeaders) {
                    $scope.customerServiceChannel = decodeURIComponent(extraHeaders['X-Ph-X-Channel'] || extraHeaders.XPhXChannel || '');
                    $scope.customerServiceSource = extraHeaders['X-Ph-X-Source'] || extraHeaders.XPhXSource || 'Unknown source';
                    $scope.customerServiceCallType = extraHeaders['X-Ph-X-CallType'] || extraHeaders.XPhXCallType || 'Unknown call type';
                    var rawVertical = (extraHeaders['X-Ph-X-Verticalname'] || extraHeaders.XPhXVerticalname || 'Final').replace(/%20/g, ' ');
                    $scope.campaignVerticalName = (rawVertical === 'Final') ? 'Final Expense' :
                        (rawVertical === 'Mortgage') ? 'Mortgage Protection' :
                            rawVertical;
                    $scope.isFEScript = (rawVertical === 'Final' || rawVertical === 'FE');
                    console.log('-------- here 2.0 vertical name -------', $scope.campaignVerticalName);
                    // Also check alternate header 'X-Ph-X-Calltype' specifically
                    var altCalltype = extraHeaders['X-Ph-X-Calltype'] || extraHeaders.XPhXCalltype;
                    var normalizedAlt = (altCalltype !== null && altCalltype !== void 0 ? altCalltype : 'normal').toString().trim().toLowerCase();
                    if (normalizedAlt === 'normal') {
                        console.log('CS CallType from X-Ph-X-Calltype indicates Normal; hiding CS UI ');
                        $scope.isCustomerServiceCall = false;
                        $scope.showCustomerServiceSection = false;
                    }
                    else {
                        console.log('-------- here 2.1 source and channel -------', $scope.customerServiceChannel, $scope.customerServiceSource, $scope.customerServiceCallType, $scope.campaignVerticalName);
                        $scope.isCustomerServiceCall = true;
                        $scope.showCustomerServiceSection = true;
                        $scope.startCustomerServiceCountdown();
                    }
                    // Parse unmask duration header (seconds)
                    try {
                        var rawDur = (_b = ((_a = extraHeaders['X-Ph-X-Duration']) !== null && _a !== void 0 ? _a : extraHeaders.XPhXDuration)) !== null && _b !== void 0 ? _b : '90';
                        var parsedDur = parseInt(rawDur, 10);
                        if (!isNaN(parsedDur) && parsedDur > 0) {
                            $scope.unmaskAfterSeconds = parsedDur;
                        }
                    }
                    catch (e) { }
                }
                // $scope.resetSalesPages()
                // $scope.salesLayout = true;
                // $scope.staticQuestionsLayout = true;
                $scope.getsalesAgentStats();
                console.log('-------- here 3 -------');
                // $scope.getsalesCallerDetails();
                $scope.modifyPhoneNumberUser(callerName);
                console.log('-------- here 4 -------');
                // $scope.modifyPhoneNumberIVR(callerName);
                // for (var key in extraHeaders) {
                //     // console.log("key="+key+".val="+extraHeaders[key]);
                // }
                // $('#status_txt').text('Incoming Call');
                // $('#incoming_callbox').show('slow');
                // $('#btn-container').hide();
                // Play custom ringtone for incoming call
                $scope.playIncomingCallAudio();
                var delayedFunction2 = function () {
                    $scope.lastRecievedCaller = null;
                };
                $timeout(delayedFunction2, 3000);
                var delayedFunction = function () {
                    console.log('$rootScope.plivoWebSdk', $rootScope.plivoWebSdk);
                    console.log('getCallUUID', $rootScope.plivoWebSdk.client.getCallUUID());
                    // if ($rootScope.plivoWebSdk.client.getCallUUID()) {
                    $scope.answerW();
                    // Automatically close the Customer Service section once the call is answered
                    $scope.showCustomerServiceSection = false;
                    // $scope.playAudio();
                    // $scope.salesLayout = true;
                    // $scope.scriptStep = 0;
                    // $scope.showFormStepOne = true;
                    // $scope.staticQuestionsLayout = true;
                    // }
                };
                $timeout(delayedFunction, 1000);
            }
        };
        function onIncomingCall(callerName, extraHeaders, callInfo) {
            console.log('------ onIncomingCall -------');
            console.log('------ extraHeaders -------', extraHeaders);
            console.log('------ callInfo -------', callInfo);
            // Reset end-of-call dedup flags for the new leg. settingOnEndCallLayout
            // intentionally leaves them set (so the duplicate hangup/onCallTerminated
            // event for the previous call is ignored); we MUST clear them here so the
            // next call's end is processed normally — even if the new call is never
            // answered (in which case onCallAnswered, the other reset point, never runs).
            $scope._endCallLayoutProcessed = false;
            $scope.callWasAnswered = false;
            // Check if status is paused and we're getting another call - log to Sentry
            console.log('isInDispositionPage', $scope.isInDispositionPage);
            if ($scope.isInDispositionPage && callInfo && callInfo.callUUID) {
                var callerId = $scope.staticCustomerDetails && $scope.staticCustomerDetails.caller_id ? $scope.staticCustomerDetails.caller_id : 'Unknown';
                $scope.sendMessageToSentry('incoming-call-while-paused', {
                    agentId: userId,
                    currentStatus: $scope.agentDashboardStatus.value,
                    callUUID: callInfo.callUUID,
                    previousCallerId: callerId,
                    incomingCaller: callerName
                });
                console.warn('WARNING: Received incoming call while agent status is paused!', {
                    agentId: userId,
                    currentStatus: $scope.agentDashboardStatus.value,
                    callUUID: callInfo.callUUID,
                    previousCallerId: callerId,
                    incomingCaller: callerName
                });
            }
            if ($scope.role == "salesagent" && !$scope.callUUID) {
                $scope.isToggleDisabled = true;
                $scope.resetSalesPages();
                $scope.salesIncomingCall(callerName, extraHeaders);
                $scope.callUUID = callInfo.callUUID;
            }
        }
        function onConnectionChange(data) {
            console.log('[PlivoRecovery] Connection state changed', data);
            if ($scope.duplicateTab)
                return;
            if (data.state == 'connected') {
                clearPlivoLoginGuard();
                plivoReconnectAttempt = 0;
                clearRecoveryIfHealthy();
                announceStatusWhenReady('plivo-connected');
                return;
            }
            if (data.state == 'disconnected' && isOnlineDesired()) {
                clearPlivoLoginGuard();
                console.warn('[PlivoRecovery] Disconnected while Online is desired', { reason: data.reason });
                $scope.agentDashboradLoaderFlag = false;
                $scope.reconnectingState = true;
                $scope.isToggleDisabled = false;
                startRecoveryWindow('plivo-' + data.reason);
                captureAgentStatusEvent('plivo-disconnected', { reason: data.reason });
                schedulePlivoRecovery('connection-change-' + data.reason);
                if (!$rootScope.socket || $rootScope.socket.readyState !== WebSocket.OPEN) {
                    scheduleSocketReconnect('plivo-connection-change');
                }
            }
        }
        function onLogout() {
            console.log('---- On Plivo logout Event -----');
            clearPlivoLoginGuard();
            if ($scope.duplicateTab)
                return;
            if (isOnlineDesired()) {
                $scope.reconnectingState = true;
                startRecoveryWindow('plivo-logout');
                schedulePlivoRecovery('plivo-logout');
            }
            else if ($scope.agentDashboardStatus.value != 'offline') {
                setAgentDashboardStatus('offline');
            }
        }
        // Guard para evitar loops de retry sobre onLoginFailed.
        var sipRepairAttempted = false;
        function onLogin() {
            if (!isOnlineDesired() || $scope.duplicateTab || plivoLoginInFlight || isPlivoRegistered() || isPlivoConnecting()) {
                return;
            }
            armPlivoLoginGuard('login-request');
            console.log("----- On Plivo Login Event -----");
            // Pide credenciales SIP frescas al backend; el backend repara el endpoint
            // en Plivo si está huérfano (creado en otra cuenta o borrado).
            // Si la llamada falla, hace fallback al comportamiento previo (username del state + password fijo).
            sipRepairAttempted = false; // reset en cada nuevo onLogin
            var fallbackUsername = username_agent;
            var fallbackPassword = 'plivoh';
            var role = $scope.role;
            var endpointPath = role === 'useragent'
                ? '/japi/useragent/sip-credentials/'
                : '/japi/salesagent/sip-credentials/';
            if (!userId) {
                console.warn('[onLogin] sin userId, usando credenciales por defecto');
                if (isOnlineDesired()) {
                    $rootScope.plivoWebSdk.client.login(fallbackUsername, fallbackPassword);
                }
                else {
                    clearPlivoLoginGuard();
                }
                return;
            }
            $http.get(endpointPath + userId)
                .then(function (response) {
                var data = response && response.data && response.data.data;
                if (!isOnlineDesired()) {
                    clearPlivoLoginGuard();
                    return;
                }
                if (data && data.sipUsername && data.sipPassword) {
                    console.log('[onLogin] credenciales SIP obtenidas del backend');
                    $rootScope.plivoWebSdk.client.login(data.sipUsername, data.sipPassword);
                }
                else {
                    console.warn('[onLogin] respuesta sin credenciales, usando fallback');
                    $rootScope.plivoWebSdk.client.login(fallbackUsername, fallbackPassword);
                }
            })
                .catch(function (err) {
                console.error('[onLogin] error obteniendo credenciales SIP, usando fallback', err);
                if (isOnlineDesired()) {
                    $rootScope.plivoWebSdk.client.login(fallbackUsername, fallbackPassword);
                }
                else {
                    clearPlivoLoginGuard();
                }
            });
        }
        function onMediaPermission(result) {
            if (result) {
                console.log("get media permission");
                $scope.applyMicrophoneCheckResult({ ok: true, reason: 'ok' });
                $scope.syncAudioDevices({
                    forcePermission: false,
                    applyToPlivo: true,
                    showWarnings: false,
                    source: 'media-permission',
                }).then(function () {
                    if ($scope.switchStatus) {
                        $scope.startMicrophoneMonitor(false);
                    }
                });
            }
            else {
                $scope.applyMicrophoneCheckResult({ ok: false, reason: 'permission-denied' });
                if ($scope.switchStatus) {
                    turnOffSwitch();
                }
                alert("you don't allow media permission, you will can't make a call until you allow it");
            }
        }
        function webrtcNotSupportedAlert() {
            console.log("heyyyyyyyyyyyyyyy");
            $('#txtStatus').text("");
            alert("Your browser doesn't support WebRTC.Please use latest version of chrome/firefox/opera/IE Edge");
        }
        // function onLogin() {
        //     console.log("onlogin");
        //     $('#status_txt').text('Logged in');
        // }
        function onLoginFailed(data) {
            console.log('on login failed', data);
            clearPlivoLoginGuard();
            if ($scope.duplicateTab)
                return;
            if (data != 'Cannot login when there is an ongoing call' && isOnlineDesired()) {
                $scope.reconnectingState = true;
                $scope.agentDashboradLoaderFlag = false;
                startRecoveryWindow('plivo-login-failed');
                captureAgentStatusEvent('plivo-login-failed', { reason: data });
            }
            $('#status_txt').text("Login Failed");
            // Si el primer login falló, le pedimos al backend que recree el endpoint en Plivo
            // (delete + create) y reintentamos UNA sola vez para evitar loops.
            if (data == 'Cannot login when there is an ongoing call') {
                return; // no es un fallo de credenciales
            }
            if (sipRepairAttempted) {
                console.error('[onLoginFailed] reintento ya hecho, no insistimos');
                return;
            }
            sipRepairAttempted = true;
            if (!userId) {
                console.warn('[onLoginFailed] sin userId, no se puede reparar');
                return;
            }
            var role = $scope.role;
            var endpointPath = role === 'useragent'
                ? '/japi/useragent/sip-credentials/'
                : '/japi/salesagent/sip-credentials/';
            console.warn('[onLoginFailed] solicitando reparación del PlivoEndpoint y reintentando login');
            armPlivoLoginGuard('credential-repair');
            $http.get(endpointPath + userId + '?repair=true')
                .then(function (response) {
                var d = response && response.data && response.data.data;
                if (!isOnlineDesired()) {
                    clearPlivoLoginGuard();
                    return;
                }
                if (d && d.sipUsername && d.sipPassword) {
                    console.log('[onLoginFailed] credenciales reparadas, reintentando login');
                    $rootScope.plivoWebSdk.client.login(d.sipUsername, d.sipPassword);
                }
                else {
                    console.error('[onLoginFailed] backend no devolvió credenciales tras repair');
                }
            })
                .catch(function (err) {
                console.error('[onLoginFailed] error en repair', err);
                clearPlivoLoginGuard();
                schedulePlivoRecovery('repair-failed');
            });
        }
        // function onReady() {
        //     console.log("onReady...");
        //     login();
        // }
        function mute() {
            $rootScope.plivoWebSdk.client.mute();
            $('#linkUnmute').show('slow');
            $('#linkMute').hide('slow');
        }
        function unmute() {
            $rootScope.plivoWebSdk.client.unmute();
            $('#linkUnmute').hide('slow');
            $('#linkMute').show('slow');
        }
        // Expose a toggle to the scope so the template can bind a button
        $scope.toggleMute = function () {
            try {
                if (!$rootScope.plivoWebSdk || !$rootScope.plivoWebSdk.client) {
                    return;
                }
                if ($scope.isMuted) {
                    unmute();
                    $scope.isMuted = false;
                }
                else {
                    mute();
                    $scope.isMuted = true;
                }
                $scope.updateMicrophoneSignal('appMuted', $scope.isMuted);
            }
            catch (e) {
                console.error('toggleMute error:', e);
            }
        };
        $scope.hangupSalesAgentCall = function () {
            console.log("hit hangup ----------");
            if ($rootScope.plivoWebSdk && $rootScope.plivoWebSdk.client) {
                $rootScope.plivoWebSdk.client.hangup();
                if (!$rootScope.plivoWebSdk.client.getCallUUID()) {
                    settingOnEndCallLayout();
                }
            }
            else {
                settingOnEndCallLayout();
            }
            // stopMicAccess();
        };
        function settingOnEndCallLayout() {
            if ($scope._endCallLayoutProcessed) {
                console.log("[settingOnEndCallLayout] already processed, skipping duplicate");
                return;
            }
            $scope._endCallLayoutProcessed = true;
            console.log("trigger on end call --------------------- ", { wasAnswered: $scope.callWasAnswered });
            // Disconnect Deepgram and OpenAI, clear transcriptions so a new call starts empty
            $scope.teardownRealtime();
            (0, OpenAIRealtimeCtrl_1.teardownOpenAIRealtime)();
            $scope.realtimeTranscripts = [];
            $scope.openaiRealtimeResponses = [];
            $scope.rebuttalEntries = [];
            $scope.callCheckLifeInsurance = false;
            $scope.callCheckLegalAge = false;
            $scope.callCheckValidState = false;
            $scope.callCheckPriceAware = false;
            $scope.billableCall = false;
            $scope.smartCheckCount = 0;
            $scope.smartCheckPercent = 0;
            $scope.isMuted = false;
            $scope.updateMicrophoneSignal('appMuted', false);
            // If the call never reached the answered state (failed outbound,
            // no-answer, cancelled incoming, destination barred, etc.) there is
            // nothing to dispose: skip the disposition UI and the auto-pause and
            // return the agent to the waiting/idle state.
            if (!$scope.callWasAnswered) {
                console.log('[settingOnEndCallLayout] call never answered — skipping disposition and pause');
                $scope.callUUID = null;
                $scope.isInDispositionPage = false;
                $scope.resetSalesPages();
                $scope.setCallStatus('waiting');
                // NOTE: do NOT reset $scope._endCallLayoutProcessed or $scope.callWasAnswered here.
                // Both flags are reset in onCallAnswered when the next call begins. Resetting
                // them at the end of this function caused a duplicate end-call event (hangup +
                // onCallTerminated fire back-to-back) to re-enter the function and wipe the
                // disposition that had just been shown.
                return;
            }
            $scope.isInDispositionPage = true;
            // disposition page
            $scope.salesLayout = true;
            $scope.salesDisposition = true;
            $scope.staticQuestionsLayout = false;
            $scope.showFormStepOne = false;
            $scope.showFormStepTwo = false;
            $scope.showFormStepThree = false;
            $scope.showFormStepFour = false;
            $scope.callUUID = null;
            // toggle
            // post questions api
            var data = $scope.staticCustomerDetails;
            data.agent_id = parseInt(userId);
            data.caller_id = $scope.strNumber;
            data.step = $scope.scriptStep + 1;
            console.log('data ))))))))))))', data);
            // Rush callback flow: keep the agent available so the next
            // opportunity can be claimed immediately. Normal inbound flow still
            // pauses for disposition. (`_lastCallWasRush` is set in onCallTerminated
            // before settingOnEndCallLayout runs.)
            console.log('About to set status to paused after call termination');
            $scope.setCallStatus('paused');
            // Defensive local update: if the backend WS doesn't ack the transition
            // (we saw oncall acks fail with 3 retries during Rush flows) the UI
            // would hang indefinitely on the previous status. Force the badge
            // locally so the agent isn't stuck.
            try {
                if ($scope.agentDashboardStatus && typeof $scope.agentDashboardStatus.next === 'function'
                    && $scope.agentDashboardStatus.value !== 'paused') {
                    setAgentDashboardStatus('paused');
                    setDesiredOnline(true);
                }
            }
            catch (_) { }
            console.log('Status update sent for paused after call termination');
            var callbacks = {
                success: function (data) {
                    if ($scope.scriptStep === 3) {
                        $scope.showFormStepFour = true;
                    }
                    else {
                    }
                },
                error: function (data) {
                    toaster.pop('error', 'Error', data.data);
                    $scope.loading = false;
                },
            };
            UserService.postStaticQuestions(data, callbacks);
            // NOTE: do NOT reset $scope._endCallLayoutProcessed or $scope.callWasAnswered
            // here. The hangup() handler and the SDK's onCallTerminated event fire
            // back-to-back for the same call leg; the second invocation must hit the
            // duplicate-guard at the top of this function, otherwise it falls through
            // to the "never answered" branch (because callWasAnswered would be false
            // again) and calls resetSalesPages(), wiping the disposition we just set.
            // Both flags are reset in onCallAnswered when the NEXT call begins.
        }
        function onCallAnswered(callInfo) {
            var sdk = $rootScope.plivoWebSdk;
            var sdkUuid = (sdk && sdk.client && sdk.client.getCallUUID)
                ? sdk.client.getCallUUID()
                : null;
            var answeredUuid = (callInfo && callInfo.callUUID) || sdkUuid || null;
            if (answeredUuid) {
                // Clear the Rush "CONNECTING…" indicator now that the call has connected.
                $rootScope.rushDialing = false;
                // Rush callback: guaranteed shot at the legacy /claim-call endpoint
                // with the real Plivo callUuid. RushOpportunitiesCtrl already fired
                // an early shot via getCallUUID() polling; the backend is idempotent
                // so this second hit is safe. If the early shot already succeeded
                // pendingRushClaim is null and markRushCall is a no-op.
                try {
                    var markFn = $rootScope.markRushCall;
                    if (typeof markFn === 'function') {
                        markFn(answeredUuid);
                    }
                }
                catch (e) {
                    console.error('[Rush] markRushCall from onCallAnswered failed', e);
                }
                // Mark this leg as actually answered so settingOnEndCallLayout knows
                // a real conversation took place and the disposition flow is warranted.
                $scope.callWasAnswered = true;
                // Clear the end-call dedup guard now that a NEW call leg is live.
                // settingOnEndCallLayout intentionally does NOT reset this flag at
                // its own tail (it's the dedup token for the just-ended leg), so the
                // next call must clear it here before its own end fires.
                $scope._endCallLayoutProcessed = false;
                $scope.salesLayout = true;
                $scope.scriptStep = 0;
                $scope.showFormStepOne = true;
                $scope.staticQuestionsLayout = true;
                // Rush callback hydration: when the call was dispatched outbound by
                // RushOpportunitiesCtrl (not by the normal incoming-call path), the
                // dashboard $scope was never armed via salesIncomingCall/answerW —
                // so callUUID, sales call id, contact card, status badge and hangup
                // button are all stale. Mirror what the incoming flow sets so the
                // agent gets a working dashboard during the conversation.
                try {
                    var rsAny = $rootScope;
                    var rushSalesCallId = rsAny.salesuserCallId;
                    var rushCustomer = rsAny.activeRushCustomer;
                    var rushTriggered = rsAny.activeRushTriggeredCall;
                    if (rushTriggered && !$scope.callUUID) {
                        $scope.callUUID = answeredUuid;
                        $scope.callClosed = false;
                        $scope.isInDispositionPage = false;
                        // Force the local UI into 'oncall' immediately. We can NOT wait
                        // for the WebSocket Success ack because the backend state machine
                        // doesn't accept the paused→oncall transition (incoming flow
                        // normally goes paused→incomingcall→oncall). Without this the
                        // status badge stays PAUSED, the End Call button never appears
                        // and the agent is stuck. We still fire-and-forget the WS update
                        // for backend bookkeeping.
                        try {
                            $scope.setCallStatus('oncall');
                            if ($scope.agentDashboardStatus && typeof $scope.agentDashboardStatus.next === 'function') {
                                setAgentDashboardStatus('oncall');
                            }
                            setDesiredOnline(true);
                        }
                        catch (e) {
                            console.error('[Rush] failed to force local oncall status', e);
                        }
                        if (rushSalesCallId) {
                            $scope.salesuserCallId = rushSalesCallId;
                        }
                        if (rushCustomer) {
                            var phone = rushCustomer.phone_number || '';
                            $scope.phoneNumberIncoming = phone;
                            // Same idea as inbound `modifyPhoneNumberUser`: keep full E.164 digits
                            // (e.g. 17032231110). Do NOT use /^\+?1?/ — that strips the US country digit.
                            var firstSeg = (phone || '').toString().trim().split('@')[0];
                            var callerDigits = firstSeg.charAt(0) === '+'
                                ? firstSeg.slice(1).replace(/\D/g, '')
                                : firstSeg.replace(/\D/g, '');
                            $scope.strNumber = callerDigits;
                            $scope.salesuserDetails = rushCustomer;
                            $scope.salesuserEmail = rushCustomer.email || null;
                            if ($scope.staticCustomerDetails) {
                                $scope.staticCustomerDetails.first_name = rushCustomer.first_name || '';
                                $scope.staticCustomerDetails.last_name = rushCustomer.last_name || '';
                                $scope.staticCustomerDetails.gender = rushCustomer.gender || null;
                                $scope.staticCustomerDetails.email = rushCustomer.email || null;
                                $scope.staticCustomerDetails.zip_code = rushCustomer.zip_code || null;
                                $scope.staticCustomerDetails.city = rushCustomer.city || '';
                                $scope.staticCustomerDetails.state = rushCustomer.state || '';
                                $scope.staticCustomerDetails.secondary_phone_number = (phone || '').toString().slice(-11);
                                $scope.staticCustomerDetails.caller_id = callerDigits;
                            }
                            $scope.isPhoneMasked = false;
                            $scope.unmaskedByDuration = true;
                        }
                        $('#btn-container').show();
                        $scope.postAgentBusyStatus();
                        console.log('[Rush] dashboard hydrated from rush claim', {
                            callUUID: $scope.callUUID,
                            salesuserCallId: $scope.salesuserCallId,
                        });
                    }
                }
                catch (rushHydrateErr) {
                    console.error('[Rush] failed to hydrate dashboard $scope', rushHydrateErr);
                }
                // Close any pending Customer Service incoming-call popup when call is answered
                try {
                    toaster.clear();
                }
                catch (e) {
                    console.log('Error clearing toaster on answer', e);
                }
                $scope.syncAudioDevices({
                    forcePermission: false,
                    applyToPlivo: true,
                    showWarnings: false,
                    source: 'call-answered',
                    forceRealtimeUpdate: false,
                }).then(function () {
                    $scope.startMicrophoneMonitor(false);
                    $scope.applySelectedAudioDevices(false);
                    $scope.applyAudioOutputSinkToRemoteAudio($scope.selectedAudioOutputDeviceId);
                    // Plivo SDK pauses the remote <audio> element on call end but only
                    // calls play() for outgoing calls.  Force play() here so incoming
                    // calls (2nd+) are audible.
                    try {
                        var rv = document.getElementById('plivo_webrtc_remoteview');
                        if (rv && rv.paused) {
                            rv.play().catch(function (e) { console.error('[onCallAnswered] remoteView play() failed:', e); });
                        }
                    }
                    catch (e) {
                        console.error('[onCallAnswered] Error ensuring remote audio playback:', e);
                    }
                    // Start realtime transcription now that media is flowing
                    $scope.setupRealtime(answeredUuid);
                    // Start OpenAI Realtime coaching connection alongside Deepgram
                    (0, OpenAIRealtimeCtrl_1.setupOpenAIRealtime)(environment_1.environment.openAiEphemeralUrl);
                });
            }
        }
        function onCallTerminated(evt, callInfo) {
            console.log("----- On Plivo Call Terminate event", evt, callInfo);
            console.log("$scope.callUUID ^^^^^^^^^", $scope.callUUID);
            // Always clear the Rush "CONNECTING…" indicator on terminate.
            $rootScope.rushDialing = false;
            // console.log("callInfo",callInfo)
            if (callInfo) {
                console.log('-----------------------');
                // Rush: if this terminated call originated from a claimed Rush
                // opportunity AND the disposition flow won't fire (no salesCallId
                // bound, e.g. when Rush calls don't yet create a backend salesCall),
                // resolve the opportunity here so the claim is released and counter
                // restarts. If a disposition is submitted later, the rootScope vars
                // are already cleared so we won't double-resolve.
                try {
                    var rushId = $rootScope.activeRushOpportunityId;
                    var rushAgentId = $rootScope.activeRushAgentExternalId;
                    var rushAgentEmail = $rootScope.activeRushAgentEmail;
                    if (rushId && (rushAgentId || rushAgentEmail)) {
                        // Use call info to decide what to do with the claimed opportunity:
                        //  - Answered (state=ended + code=16): mark as 'reached' so it
                        //    transitions to resolved and won't reappear in the queue.
                        //  - NOT answered (busy, no-answer, destination barred, peer
                        //    rejected, etc.): RELEASE the opportunity so it returns to
                        //    'pending' and any agent (including the same one) can take
                        //    it again immediately. Avoid using resolve('no_answer')
                        //    here because that closes the opportunity for good even
                        //    though no human conversation actually happened.
                        var info = callInfo || {};
                        // Prefer the local `callWasAnswered` flag (set in onCallAnswered)
                        // over the SDK code check: when the agent hangs up first the
                        // code may not be 16 even though there WAS a real conversation.
                        // Falling back to the SDK code only when the flag is unset.
                        var answered = !!$scope.callWasAnswered
                            || (info.state === 'ended' && info.code === 16);
                        var rushIdentity = { externalId: rushAgentId || undefined, email: rushAgentEmail || undefined };
                        if (answered) {
                            console.log('[Rush] auto-resolving as reached on call terminate', { rushId: rushId });
                            RushOpportunityService_1.RushOpportunityService.resolve(rushIdentity, rushId, 'reached');
                        }
                        else {
                            console.log('[Rush] releasing opportunity (call never connected) on terminate', { rushId: rushId });
                            RushOpportunityService_1.RushOpportunityService.release(rushIdentity, rushId);
                            try {
                                toaster.pop('warning', 'Could not connect', 'The opportunity was returned to the queue.');
                            }
                            catch (_) { /* noop */ }
                        }
                        // Mark this terminated leg as a Rush-originated call so the
                        // post-disposition flow can return the agent to 'waiting'
                        // (auto-available) instead of leaving them in 'paused'.
                        $rootScope.activeRushOpportunityId = null;
                        $rootScope.activeRushAgentExternalId = null;
                        $rootScope.activeRushAgentEmail = null;
                        $rootScope.activeRushTriggeredCall = false;
                    }
                }
                catch (e) {
                    console.error('[Rush] resolve from onCallTerminated failed', e);
                }
                // Drop any parked Rush claim payload so a future unrelated call does
                // not get accidentally marked as RUSH_CALLBACK by a late early-shot.
                $rootScope.pendingRushClaim = null;
                // Cancel any pending unmask timers and restore mask for next call
                try {
                    if ($scope.unmaskTimer) {
                        $timeout.cancel($scope.unmaskTimer);
                        $scope.unmaskTimer = null;
                    }
                }
                catch (_) { }
                if (!$scope.unmaskedByDuration) {
                    $scope.isPhoneMasked = true;
                }
                $scope.callClosed = true;
                $scope.isToggleDisabled = false;
                $scope.callUUID = null;
                // Stop incoming call audio if it's playing
                $scope.stopIncomingCallAudio();
                if ($scope.duplicateTab) {
                    $scope.logoutPlivo();
                    return;
                }
                settingOnEndCallLayout();
                return;
            }
        }
        function onCallFailed(reason, callInfo) {
            console.log('onCallFailed ----->', reason, callInfo);
            console.info('onCallFailed', reason);
            // Clear the Rush "CONNECTING…" indicator on failure.
            $rootScope.rushDialing = false;
            // Drop any parked Rush claim payload so a future unrelated call does
            // not get accidentally marked as RUSH_CALLBACK by a late early-shot.
            $rootScope.pendingRushClaim = null;
            $scope.isToggleDisabled = false;
            // Stop incoming call audio if it's playing
            $scope.stopIncomingCallAudio();
            // Rush: if this failed call was originated by a claimed opportunity,
            // RELEASE it (return to pending) so the same or another agent can
            // immediately retry. Show a toast so the user knows what happened.
            try {
                var rushId = $rootScope.activeRushOpportunityId;
                var rushAgentId = $rootScope.activeRushAgentExternalId;
                var rushAgentEmail = $rootScope.activeRushAgentEmail;
                if (rushId && (rushAgentId || rushAgentEmail)) {
                    RushOpportunityService_1.RushOpportunityService.release({ externalId: rushAgentId || undefined, email: rushAgentEmail || undefined }, rushId);
                    try {
                        toaster.pop('warning', 'Could not connect', 'The opportunity was returned to the queue.');
                    }
                    catch (_) { /* noop */ }
                    $rootScope.activeRushOpportunityId = null;
                    $rootScope.activeRushAgentExternalId = null;
                    $rootScope.activeRushAgentEmail = null;
                    $rootScope.activeRushTriggeredCall = false;
                }
            }
            catch (_) { /* noop */ }
            // Cancel any pending unmask timers and restore mask for next call
            try {
                if ($scope.unmaskTimer) {
                    $timeout.cancel($scope.unmaskTimer);
                    $scope.unmaskTimer = null;
                }
            }
            catch (_) { }
            if (!$scope.unmaskedByDuration) {
                $scope.isPhoneMasked = true;
            }
            settingOnEndCallLayout();
        }
        function onIncomingCallCanceled(callInfo) {
            console.log("------- Incoming Plivo call cancelled----", callInfo);
            $scope.isToggleDisabled = false;
            // Stop incoming call audio if it's playing
            $scope.stopIncomingCallAudio();
            // Cancel any pending unmask timers and restore mask for next call
            try {
                if ($scope.unmaskTimer) {
                    $timeout.cancel($scope.unmaskTimer);
                    $scope.unmaskTimer = null;
                }
            }
            catch (_) { }
            if (!$scope.unmaskedByDuration) {
                $scope.isPhoneMasked = true;
            }
            settingOnEndCallLayout();
        }
        $scope.logoutPlivo = function () {
            console.info('onLogout');
            if ($rootScope.plivoWebSdk) {
                $rootScope.plivoWebSdk.client.logout();
            }
            //     function onLogout(){
            //     console.info('onLogout');
            // }
        };
        $scope.logout = function () {
            var refresh_token = window.localStorage.getItem('refresh_token');
            var callbacks = {
                success: function (data, status) {
                    if (status == 204) {
                        setDesiredOnline(false);
                        stopTimeout();
                        $scope.logoutPlivo();
                        $scope.disconnectWebSocket();
                        window.clearInterval(timerInter);
                        // $state.go('access.login');
                    }
                    else {
                        toaster.pop('error', 'Error', data);
                    }
                },
                error: function (data) {
                    toaster.pop('error', 'Error', data.message);
                }
            };
            UserService.logout(refresh_token, callbacks);
        };
        $scope.initPhone = function () {
            if ($scope.duplicateTab)
                return;
            console.log("initPhone");
            // Guard: never create a new Plivo instance while a call is in progress
            if ($rootScope.plivoWebSdk) {
                if ($rootScope.plivoWebSdk.client.getCallUUID()) {
                    console.warn('[initPhone] Skipping re-init — active call in progress');
                    return;
                }
                // Tear down the dead instance before creating a new one
                try {
                    $rootScope.plivoWebSdk.client.logout();
                }
                catch (e) { /* ignore */ }
                $rootScope.plivoWebSdk = null;
            }
            // Disable Plivo telemetry (enableTracking:false); explicitly enable quality tracking
            $rootScope.plivoWebSdk = new plivo_browser_sdk_1.default({
                disableRtpTimeOut: true,
                debug: environment_1.environment.plivo.debug,
                permOnClick: true,
                enableTracking: false,
                enableQualityTracking: 'ALL',
                enableNoiseReduction: true,
                useDefaultAudioDevice: true,
                closeProtection: true,
            });
            $scope.bindPlivoAudioDeviceChangeHandler();
            $rootScope.plivoWebSdk.client.on('onWebrtcNotSupported', webrtcNotSupportedAlert);
            $rootScope.plivoWebSdk.client.on('onLoginFailed', onLoginFailed);
            $rootScope.plivoWebSdk.client.on('onLogout', onLogout);
            $rootScope.plivoWebSdk.client.on('onCallFailed', onCallFailed);
            $rootScope.plivoWebSdk.client.on('onCallAnswered', onCallAnswered);
            $rootScope.plivoWebSdk.client.on('onCallTerminated', onCallTerminated);
            $rootScope.plivoWebSdk.client.on('onIncomingCall', onIncomingCall);
            $rootScope.plivoWebSdk.client.on('onMediaPermission', onMediaPermission);
            $rootScope.plivoWebSdk.client.on('onIncomingCallCanceled', onIncomingCallCanceled);
            $rootScope.plivoWebSdk.client.on('onConnectionChange', onConnectionChange);
            $rootScope.plivoWebSdk.client.setRingTone(false); // Disable Plivo ringtone - using custom audio
            // Reset end-of-call dedup flags whenever RushOpportunitiesCtrl dispatches
            // a new outbound dial. Counterpart of the reset in onIncomingCall — covers
            // the case of two consecutive Rush calls where the previous one was never
            // answered (so onCallAnswered, the other reset point, never ran).
            $scope.$on('rush:dialStarted', function () {
                $scope._endCallLayoutProcessed = false;
                $scope.callWasAnswered = false;
            });
            if ($scope.selectedAudioInputDeviceId || $scope.selectedAudioOutputDeviceId) {
                $scope.applySelectedAudioDevices(false);
            }
            console.log('initPhone ready!');
        };
        $scope.runNow = function () {
            console.log("entered here");
            $(document).ready(function () {
                console.log("HTML ready!");
                $scope.initPhone();
            });
        };
        $scope.handleSuccess = function (stream) {
            if (window.stream) {
                //   window.stream.getAudioTracks().forEach(track => track.stop());
                angular.forEach(window.stream.getAudioTracks(), function (item, index) {
                    item.stop();
                });
                window.stream = null;
            }
            else {
                var audio = document.createElement('audio');
                audio.controls = true;
                audio.autoplay = true;
                window.stream = stream;
                audio.srcObject = stream;
            }
        };
        $scope.handleError = function (e) {
            console.log("ruin", e.message);
        };
        // Function to disconnect WebSocket manually
        $scope.disconnectWebSocket = function () {
            console.log('Manually disconnected from APP');
            // Deliberate disconnect: the close event must not be treated as an
            // abnormal closure (client-initiated closes can surface as code 1005).
            intentionalSocketDisconnect = true;
            // Tell the backend explicitly before closing so it doesn't have to
            // infer the offline transition from the socket close alone. Bypasses
            // sendMessageThroughWebSocket on purpose: no retry/pending bookkeeping
            // should outlive a socket we are about to close.
            if ($rootScope.socket && $rootScope.socket.readyState === WebSocket.OPEN) {
                try {
                    $rootScope.socket.send(JSON.stringify({ status: 'offline', agentId: userId }));
                }
                catch (e) {
                    console.error('Failed to send offline status before disconnect', e);
                }
            }
            cancelSocketReconnect();
            lastStatusAnnouncementSocket = null;
            webSocketService.disconnect();
        };
        // ─── Audio Device Management delegated to AudioDeviceController ──────────
        // All audio-device and microphone-monitoring code lives in
        // AudioDeviceController.js and is composed onto this $scope via
        //   $controller('AudioDeviceController', { $scope: $scope })
        // (called above).  The functions below are now available as $scope.*
        // ─────────────────────────────────────────────────────────────────────────
        function getDailyAudioDeviceConfirmationKey() {
            return 'callxAudioDeviceConfirmationDate:' + ($scope.user_id || 'unknown');
        }
        function getLocalDateStamp() {
            var now = new Date();
            return [
                now.getFullYear(),
                ('0' + (now.getMonth() + 1)).slice(-2),
                ('0' + now.getDate()).slice(-2),
            ].join('-');
        }
        function needsDailyAudioDeviceConfirmation() {
            try {
                return window.localStorage.getItem(getDailyAudioDeviceConfirmationKey()) !== getLocalDateStamp();
            }
            catch (_) {
                return true;
            }
        }
        function markDailyAudioDeviceConfirmation() {
            try {
                window.localStorage.setItem(getDailyAudioDeviceConfirmationKey(), getLocalDateStamp());
            }
            catch (_) { }
        }
        $scope.changeStatus = function (event) {
            if (($rootScope.currentPage === 'callhistory') || ($rootScope.currentPage === 'contactpage') || ($rootScope.currentPage === 'application') || ($rootScope.currentPage === 'settings') || ($rootScope.currentPage === 'support')) {
                $rootScope.currentPage = 'home';
                $state.go('app.sales-agent', { username: $scope.user_name, userId: $scope.user_id });
            }
            // Do not set loader yet; avoid visual flicker until validation passes
            $scope.showValue = window.localStorage.getItem("show_value");
            const nextState = !isOnlineDesired();
            if (nextState) {
                util_helper_1.UtilHelper.preventDefaultAndStopPropagation(event);
                if (is_prepaid_billing_filter_1.IsPrepaidBillingFilter.transform($scope.billingStatus) && $scope.billingConfig && $scope.billingConfig.balanceCents <= 10000) {
                    // Show warning but proceed to go online
                    toaster.pop('error', 'Low Credits', 'Your credits are low. Please add more credits to receive calls.', 3000);
                    // Do NOT return; allow normal online flow to continue below
                }
                if (needs_payment_setup_filter_1.NeedsPaymentSetupFilter.transform($scope.billingStatus)) {
                    toaster.pop('error', 'Payment Setup Required', 'Please add a valid payment method under Settings → Billing to go online.');
                    $scope.agentDashboradLoaderFlag = false;
                    return;
                }
                // Force checkbox back to current model state to avoid flicker
                try {
                    var el = document.getElementById('custom-toggle-box');
                    if (el) {
                        el.checked = !!$scope.switchStatus;
                    }
                }
                catch (_) { }
                // Temporarily disable toggle while validating
                $scope.isToggleDisabled = true;
                // Going ONLINE: resolve the active/default route, then validate it before proceeding
                $scope.syncAudioDevices({
                    forcePermission: true,
                    applyToPlivo: !!$rootScope.plivoWebSdk,
                    showWarnings: false,
                    source: 'go-online',
                    restartMonitor: false,
                    updateRealtime: false,
                }).then(() => media_helper_1.MediaHelper.verifyMediaAccess($scope.selectedAudioInputDeviceId, $scope.selectedAudioOutputDeviceId)).then((res) => {
                    if (!res.mic) {
                        $scope.applyMicrophoneCheckResult({ ok: false, reason: res.micReason });
                        toaster.pop('error', 'Microphone Unavailable', $scope.getMicrophoneAccessFailureMessage(res.micReason));
                        $scope.switchStatus = false;
                        $scope.isToggleDisabled = false;
                        $scope.$applyAsync();
                        return;
                    }
                    $scope.applyMicrophoneCheckResult({ ok: true, reason: 'ok' });
                    if (!res.speaker) {
                        toaster.pop('error', 'Speaker Test Failed', "If you don't hear the audio, please check your browser sound settings.");
                        $scope.switchStatus = false;
                        $scope.isToggleDisabled = false;
                        $scope.$applyAsync();
                        return;
                    }
                    // Passed validation; proceed
                    $scope.switchStatus = true;
                    $scope.agentDashboradLoaderFlag = true;
                    if ($scope.showValue == 'true' || needsDailyAudioDeviceConfirmation()) {
                        $scope.openCallSetupStationModal();
                    }
                    else {
                        $scope.goLive(true, false);
                    }
                    $scope.isToggleDisabled = false;
                });
            }
            else {
                // Going OFFLINE
                $scope.switchStatus = false;
                $scope.agentDashboradLoaderFlag = true;
                $scope.goLive(false, false);
                $scope.isToggleDisabled = false;
            }
        };
        $scope.getStats = function () {
            if ($scope.role == 'useragent') {
                $scope.getAgentStats();
            }
            else if ($scope.role == 'salesagent') {
                $scope.getsalesAgentStats();
            }
        };
        $scope.goLive = function (status, isReconnected) {
            $scope.isToggleDisabled = true;
            if (status == true && $scope.duplicateTab) {
                $scope.agentDashboradLoaderFlag = false;
                $scope.isToggleDisabled = false;
                return;
            }
            if (status == true) {
                setDesiredOnline(true);
                intentionalSocketDisconnect = false;
                if (!$scope.reconnectingState) {
                    $scope.agentDashboradLoaderFlag = true;
                }
                startRecoveryWindow(isReconnected ? 'go-live-reconnect' : 'go-live');
                $scope.startMicrophoneMonitor(false);
                // Only create a new Plivo instance if none exists; otherwise let SDK recover
                if (!$rootScope.plivoWebSdk) {
                    $scope.initPhone();
                }
                recoverPlivoRegistration(isReconnected ? 'go-live-reconnect' : 'go-live');
                schedulePlivoRecovery(isReconnected ? 'go-live-reconnect' : 'go-live');
                $scope.connectWebSocketConnection(userId, isReconnected);
            }
            else {
                setDesiredOnline(false);
                intentionalSocketDisconnect = true;
                cancelSocketReconnect();
                if ($scope.reconnectTimer) {
                    $timeout.cancel($scope.reconnectTimer);
                    $scope.reconnectTimer = null;
                }
                if (plivoRecoveryTimer) {
                    $timeout.cancel(plivoRecoveryTimer);
                    plivoRecoveryTimer = null;
                }
                plivoReconnectAttempt = 0;
                if (statusAnnouncementTimer) {
                    $timeout.cancel(statusAnnouncementTimer);
                    statusAnnouncementTimer = null;
                }
                if (foregroundHeartbeatTimer) {
                    $timeout.cancel(foregroundHeartbeatTimer);
                    foregroundHeartbeatTimer = null;
                }
                clearPlivoLoginGuard();
                resetStatusMessagingState();
                $scope.reconnectingState = false;
                $scope.stopMicrophoneMonitor(true);
                $scope.updateMicrophoneSignal('appMuted', false);
                $scope.logoutPlivo();
                $scope.disconnectWebSocket();
                setAgentDashboardStatus('offline');
                $scope.agentDashboradLoaderFlag = false;
            }
            $scope.loadBillingConfig();
            $scope.getStats();
            $scope.isToggleDisabled = false;
        };
        $scope.openCallSetupStationModal = function () {
            var modalInstance = $modal.open({
                templateUrl: 'tpl/blocks/call_setup_station.html',
                controller: 'CallSetupStationCtrl',
                size: 'md',
                windowClass: 'custom-rounded-modal',
                backdrop: 'static',
                resolve: {
                    object: function () {
                        return {
                            // status: status,
                            firstName: $scope.username_firstName,
                            lastName: $scope.username_lastName,
                            id: $scope.user_id,
                            role: $scope.role,
                            audioInputDevices: $scope.audioInputDevices,
                            audioOutputDevices: $scope.audioOutputDevices,
                            selectedAudioInputDeviceId: $scope.selectedAudioInputDeviceId,
                            selectedAudioOutputDeviceId: $scope.selectedAudioOutputDeviceId,
                            applyAudioDeviceSettings: $scope.applyAudioDeviceSettings,
                        };
                    }
                }
            });
            modalInstance.result.then(function (selectedItem) {
                $scope.selected = selectedItem;
                if ($scope.selected) {
                    $scope.showValue = 'false';
                    $scope.switchStatus = true;
                    markDailyAudioDeviceConfirmation();
                    $scope.goLive($scope.selected, false);
                    window.localStorage.setItem("show_value", $scope.showValue);
                }
                else {
                    $scope.switchStatus = false;
                    $scope.agentDashboradLoaderFlag = false;
                }
            }, function () {
            });
        };
        function updateTimerText(elementId, value) {
            var element = document.getElementById(elementId);
            if (element) {
                element.textContent = value;
            }
        }
        var sec = 0;
        function pad(val) { return val > 9 ? val : "0" + val; }
        setInterval(function () {
            updateTimerText('seconds', pad(++sec % 60));
            updateTimerText('minutes', pad(parseInt(sec / 60, 10)));
        }, 1000);
        var sec1 = 0;
        function pad1(val) { return val > 9 ? val : "0" + val; }
        setInterval(function () {
            updateTimerText('seconds1', pad(++sec1 % 60));
            updateTimerText('minutes1', pad(parseInt(sec1 / 60, 10)));
        }, 1000);
        var sec2 = 0;
        function pad2(val) { return val > 9 ? val : "0" + val; }
        setInterval(function () {
            updateTimerText('seconds2', pad(++sec2 % 60));
            updateTimerText('minutes2', pad(parseInt(sec2 / 60, 10)));
        }, 1000);
        var sec3 = 0;
        function pad3(val) { return val > 9 ? val : "0" + val; }
        setInterval(function () {
            updateTimerText('seconds3', pad(++sec3 % 60));
            updateTimerText('minutes3', pad(parseInt(sec3 / 60, 10)));
        }, 1000);
        $scope.nextForwardCall = function (readData, questions, optId, index, answer) {
            $scope.forwardData = { "read_data": readData, "user_answer": answer, "opt_id": optId, "script_id": $scope.scriptCallId };
            // editscript --> storing the response - start
            if (answer != "") {
                //questions[index].result=answer;
                questions[index].response = answer;
                $scope.rightblock = true;
            }
            // editscript --> storing the response - end
        };
        $rootScope.currentPage = 'home';
        // Helper function to reset page state variables
        function resetPageStates() {
            $scope.callHistory = false;
            $scope.contactsPage = false;
            $scope.application = false;
            $scope.settings = false;
            $scope.support = false;
        }
        // Reusable function for navigation
        $scope.navigateToPage = function (pageName, stateName) {
            $rootScope.currentPage = pageName;
            if ($scope.switchStatus || $scope.agentDashboradLoaderFlag) {
                // If switchStatus is true, block navigation and show error
                $rootScope.currentPage = 'home';
                toaster.pop('error', 'Error', 'To access ' + pageName + ' page, you need to move to the offline status');
                return;
            }
            // Reset all page states and activate the current one
            resetPageStates();
            $scope[pageName] = true;
            // Navigate to the specified state
            $state.go(stateName, { username: $scope.user_name, userId: $scope.user_id });
        };
        // Page-specific functions
        $scope.callScreenPage = function () {
            $scope.navigateToPage('home', 'app.sales-agent');
        };
        $scope.agentCallHistory = function () {
            if ($scope.switchStatus || $scope.agentDashboradLoaderFlag) {
                $rootScope.currentPage = 'home';
                toaster.pop('error', 'Error', 'To access History, please move to Offline.');
                return;
            }
            var baseUrl = window.location.origin;
            var url = baseUrl + "/v2/agent/callhistory";
            window.location.href = url;
        };
        $scope.agentContactPage = function () {
            if ($scope.switchStatus || $scope.agentDashboradLoaderFlag) {
                $rootScope.currentPage = 'home';
                toaster.pop('error', 'Error', 'To access Contacts, please move to Offline.');
                return;
            }
            var baseUrl = window.location.origin;
            var url = baseUrl + "/v2/agent/contacts";
            window.location.href = url;
        };
        $scope.applicationPage = function () {
            if ($scope.switchStatus || $scope.agentDashboradLoaderFlag) {
                $rootScope.currentPage = 'home';
                toaster.pop('error', 'Error', 'To access Applications, please move to Offline.');
                return;
            }
            var baseUrl = window.location.origin;
            var url = baseUrl + "/v2/agent/applications";
            window.location.href = url;
        };
        $scope.referralEarningsPage = function () {
            if ($scope.switchStatus || $scope.agentDashboradLoaderFlag) {
                $rootScope.currentPage = 'home';
                toaster.pop('error', 'Error', 'To access Referral Earnings, please move to Offline.');
                return;
            }
            var baseUrl = window.location.origin;
            var url = baseUrl + "/v2/agent/referral-earnings";
            window.location.href = url;
        };
        $scope.settingsPage = function () {
            if ($scope.switchStatus || $scope.agentDashboradLoaderFlag) {
                $rootScope.currentPage = 'home';
                toaster.pop('error', 'Error', 'To access Settings, please move to Offline.');
                return;
            }
            var baseUrl = window.location.origin;
            var url = baseUrl + "/v2/agent/settings";
            window.location.href = url;
        };
        $scope.settingsBillingPage = function () {
            var baseUrl = window.location.origin;
            var url = baseUrl + "/v2/agent/settings?tab=billing";
            window.location.href = url;
        };
        $scope.supportPage = function () {
            if ($scope.switchStatus || $scope.agentDashboradLoaderFlag) {
                $rootScope.currentPage = 'home';
                toaster.pop('error', 'Error', 'To access Support, please move to Offline.');
                return;
            }
            var baseUrl = window.location.origin;
            var url = baseUrl + "/v2/agent/support";
            console.log(url);
            window.location.href = url;
        };
        $scope.stopImpersonation = function () {
            $rootScope.showMainLoader = true;
            var callbacks = {
                success: function (data) {
                },
                error: function (data) {
                }
            };
            var fromAdmin = localStorage.getItem('impersonation_from_admin') === 'true';
            UserService.exitImpersonation(fromAdmin ? 'ADMIN' : impersonationRole, callbacks);
        };
        $scope.initNavigation = function () {
            var currentState = $state.current.name; // Get the current route name
            var routeMappings = {
                'app.sales-agent': 'home',
                'app.sales-agent.callhistory': 'callHistory',
                'app.sales-agent.contacts': 'contactsPage',
                'app.sales-agent.applications': 'application',
                'app.sales-agent.settings': 'settings',
                'app.sales-agent.support': 'support',
                'app.sales-agent.details': 'contactsPage'
            };
            // If the current route is in our mapping, navigate to the corresponding page
            if (routeMappings[currentState]) {
                $scope.navigateToPage(routeMappings[currentState], currentState);
            }
        };
        $scope.initNavigation();
        // Initialize by navigating to the home page
        // $scope.callScreenPage();
        $scope.dispositionStatus = function (selected_disposition) {
            // console.log("hangup sales call", selected_disposition);
            // console.log($scope.salesuserDetails, "in dispostion page -----------")
            //highlight selected card
            // console.log("Selected ID:", selected_disposition);
            var callDispositions = document.querySelectorAll('.salesblock');
            // console.log("callDispositions",callDispositions)
            callDispositions.forEach(function (disposition) {
                disposition.classList.remove('selected-disposition');
            });
            var selectedDisposition = document.getElementById(selected_disposition);
            // console.log(selectedDisposition,"selectedDisposition")
            selectedDisposition.classList.add('selected-disposition');
            //highlight selected card
            // Find the element by replacing spaces with underscores
            var selectedDisposition = document.getElementById(selected_disposition.replace(/\s/g, "_"));
            // console.log(selectedDisposition, "selectedDisposition");
            // Add class to highlight selected card
            if (selectedDisposition) {
                selectedDisposition.classList.add('selected-disposition');
            }
            // $scope.postSalesDispositionsData(selected_disposition)
            $scope.openDispositionStatusModal(selected_disposition);
            // $scope.getsalesAgentStats();
            // $scope.resetSalesPages();
            $scope.salesDisposition = true;
            $scope.salesLayout = true;
        };
        // reset disposition status on next call
        $scope.resetDispositionSelection = function () {
            var callDispositions = document.querySelectorAll('.salesblock');
            callDispositions.forEach(function (disposition) {
                disposition.classList.remove('selected-disposition');
            });
            $scope.salesDisposition = false;
            $scope.salesLayout = false;
        };
        $scope.updateFieldsAndSkipToNextQuestion = function (data, userAnswer, questions, optId, index, answer) {
            if (data.message == 'Data saved successfully') {
                //toaster.pop('success', 'Success', 'Data saved successfully', 2000);
                if (questions.length == index + 1) {
                    $scope.nextQuestion();
                }
                else {
                    $scope.next_1();
                }
                // editscript --> storing the response - start
                if (userAnswer != "") {
                    questions[index].response = userAnswer;
                    $scope.rightblock = true;
                }
                if ((userAnswer == undefined && answer != "") || (userAnswer == "" && answer != "")) {
                    questions[index].response = answer;
                    $scope.rightblock = true;
                }
                $("#sideLeadfield input").prop("disabled", true);
                $("#sideLeadfield select").prop("disabled", true);
                $("#edit_right").prop("disabled", false);
                $("#save_right").prop("disabled", true);
                // editscript --> storing the response - end
                // $scope.updateLeadFields(questions[index].options[0].lead_field.code,userAnswer);
            }
        };
        //added -start
        $scope.forwardTheCall = function (userAnswer, questions, optId, index, answer) {
            var callbacks = {
                success: function (data) {
                    // console.log("forward call");
                    $scope.offerErrorCode = data.statusCode;
                    $scope.offerErrorMsg = data.message;
                    $scope.frwdOfferData = data.data;
                    //    console.log($scope.frwdOfferData)
                    $scope.frwdOfferData2 = $scope.frwdOfferData;
                    if (data.data) {
                        $scope.disableEdit();
                    }
                    if (data.statusCode == 200) {
                        document.getElementById("offerListFrwd").style.display = 'table';
                        //document.getElementById("offerStmt").style.display='block';
                        document.getElementById("offerStmt").style.visibility = 'visible';
                        var modal = document.getElementById("myModal5");
                        if (modal) {
                            modal.style.display = "none";
                        }
                        //added
                        if ($scope.forwardData.read_data != null) {
                            if (($scope.forwardData.read_data).includes("{offer_display_name}")) {
                                $scope.forwardData.read_data = ($scope.forwardData.read_data).replace(/{offer_display_name}/g, $scope.frwdOfferData[0].offer_name);
                            }
                            document.getElementById("myModal1").style.display = 'block';
                            document.getElementById("myModal1").style.opacity = 1;
                            document.getElementById("myModal1").style.backgroundColor = 'rgb(' + 0 + ',' + 0 + ',' + 0 + ',' + 0.34 + ')';
                        }
                    }
                    if (data.statusCode == 205) {
                        document.getElementById("offerListFrwd").style.display = 'none';
                        // document.getElementById("offerStmt").style.display='none';
                        document.getElementById("offerStmt").style.visibility = 'hidden';
                        //no agents or no offers msg below
                        var modal = document.getElementById("myModal5");
                        if (modal) {
                            modal.style.display = 'block';
                            modal.style.opacity = 1;
                            modal.style.backgroundColor = 'rgba(0, 0, 0, 0.34)'; // better: rgba instead of rgb with 4th arg
                        }
                        document.getElementById("myModal1").style.display = 'none';
                    }
                    // new code for going to next question
                    $scope.updateFieldsAndSkipToNextQuestion(data, userAnswer, questions, optId, index, answer);
                },
                error: function (data) {
                    $scope.tableContentLoading = false;
                    toaster.pop('error', 'Error', data.data);
                }
            };
            UserService.getForwardOfferData({ "value": $scope.forwardData.user_answer }, $scope.forwardData.opt_id, $scope.forwardData.script_id, callbacks);
            //UserService.getForwardOfferData($scope.scriptCallId,callbacks);
        };
        $scope.onOfferSelect = function (offerselected, index) {
            // console.log(offerselected);
            // console.log(index);
            $scope.forwardflag = true;
            // document.getElementById("offerStmt").style.display='none';
            document.getElementById("offerStmt").style.visibility = "hidden";
            document.getElementById("disposition").style.display = 'none';
            $scope.offerselect = offerselected.offer_id;
            //added-start
            for (var i = 0; i < $scope.frwdOfferData2.length; i++) {
                if (i != index) {
                    $('#button' + i).prop('disabled', true);
                }
            }
            //added-end
            var callbacks = {
                success: function (data) {
                    // console.log(data,"get whole data");
                    $scope.concurreyResult = data.statusCode;
                    $scope.offerType = data.offer_type;
                    // console.log($scope.offerType);
                    //$scope.concurreyMsg=null;
                    //error scenario
                    if (data.statusCode == 205) {
                        document.getElementById("myModal4").style.display = 'block';
                        document.getElementById("myModal4").style.opacity = 1;
                        document.getElementById("myModal4").style.backgroundColor = 'rgb(' + 0 + ',' + 0 + ',' + 0 + ',' + 0.34 + ')';
                        document.getElementById("disposition").style.display = 'none';
                        var parent_button = document.getElementById("offerListFrwd");
                        var child_button = parent_button.querySelectorAll("tr button");
                        child_button[index].disabled = true;
                        $scope.frwdOfferData = $scope.frwdOfferData2;
                        // console.log("get forward data",$scope.frwdOfferData) ;
                        if ($scope.role == 'useragent') {
                            $scope.totalLayout = true;
                            $scope.dynamicLayout = true;
                        }
                        else if ($scope.role == 'salesagent') {
                            $scope.salesLayout = true;
                            $scope.scriptStep = 0;
                            $scope.staticQuestionsLayout = true;
                            $scope.showFormStepOne = true;
                        }
                        $scope.setCallStatus('oncall');
                        $scope.concurreyMsg = data.message;
                        //added-start
                        for (var i = 0; i < $scope.frwdOfferData2.length; i++) {
                            if (i != index) {
                                $('#button' + i).prop('disabled', false);
                            }
                            else {
                                $('#button' + index).prop('disabled', true);
                            }
                        }
                        //added-end
                    }
                    //success scenario
                    if (data.statusCode == 202) {
                        document.getElementById("myModal4").style.display = 'none';
                        $scope.concurreyMsg = null;
                        toaster.pop('success', 'Success', 'Forwarding the call', 2000);
                        $scope.meal_index = 0;
                        $scope.meal_index_1 = 0;
                        $scope.dataNew = {};
                        setDesiredOnline(false);
                        $scope.setCallStatus('offline');
                        $scope.frwdOfferData = {};
                        if ($scope.getuserRole == 'useragent') {
                            $scope.totalLayout = false;
                            $scope.dynamicLayout = false;
                        }
                        else if ($scope.getsalesRole == 'salesagent') {
                            $scope.salesLayout = false;
                            $scope.staticQuestionsLayout = false;
                            $scope.showFormStepOne = false;
                        }
                        angular.element(".modal-backdrop").removeClass("modal-backdrop");
                        document.getElementById("disposition").style.display = 'none';
                        //UserService.putAgentTransferStatus(userId,callbacks);
                        $scope.putTransferAgentStatus();
                        $scope.postAgentAvailableStatus();
                    }
                },
                error: function (data) {
                    $scope.tableContentLoading = false;
                    toaster.pop('error', 'Error', data.data);
                }
            };
            UserService.postSelectedOfferFrwd($scope.offerselect, $scope.scriptCallId, callbacks);
            //$scope.frwdOfferData={};
        };
        $scope.errorPopupOk = function () {
            $scope.concurreyMsg = null;
            document.getElementById("myModal4").style.display = 'none';
            $scope.offerErrorMsg = null;
            var modal = document.getElementById("myModal5");
            if (modal) {
                modal.style.display = "none";
            }
            document.getElementById("myModal1").style.display = 'none';
        };
        //added-end
        $scope.openCopyConfirmationModalData = function () {
            var forwardData = $scope.forwardData;
            var modalInstance = $modal.open({
                templateUrl: 'tpl/blocks/forward_call.html',
                controller: 'AgentDashboardCtrl',
                size: 'lg',
            });
            modalInstance.result.then(function (selectedItem) {
                $scope.selected = selectedItem;
            }, function () {
                $log.info('Modal dismissed at: ' + new Date());
            });
        };
        $scope.openCopyConfirmationModal = function () {
            var callHistory = $scope.callHistoryData;
            var modalInstance = $modal.open({
                templateUrl: 'tpl/blocks/call_history.html',
                controller: 'CallHistoryCtrl',
                size: 'lg',
                resolve: {
                    object: function () {
                        return callHistory;
                    }
                }
            });
            modalInstance.result.then(function (selectedItem) {
                $scope.selected = selectedItem;
            }, function () {
                $log.info('Modal dismissed at: ' + new Date());
            });
        };
        $scope.openAddApplicationModal = function (status_disposition, call_disposition) {
            // console.log(status_disposition, "get disposition status value")
            var statusValue = status_disposition;
            var modalInstance = $modal.open({
                templateUrl: 'tpl/blocks/application_form.html',
                controller: 'ApplicationFormCtrl',
                size: 'md',
                windowClass: 'custom-rounded-modal',
                backdrop: 'static',
                resolve: {
                    object: function () {
                        return {
                            contact_id: $scope.salesuserDetails.contact_id
                        };
                    }
                }
            });
            modalInstance.result.then(function (formData) {
                // console.log(formData, "get form data")
                // console.log("result submitted form data", $scope.showAnotherCallPrompt)
                if (formData !== 'cancel') {
                    // $scope.showAnotherCallPrompt = true;
                    // $scope.applicationSubmittedStatus = true;
                    // console.log("result submitted form data", $scope.showAnotherCallPrompt)
                    $scope.status = null;
                    var notes = '';
                    $scope.postDisposition(status_disposition, call_disposition, notes);
                    //    $scope.openDispositionConfirmationModal(true, true);
                }
                else {
                    $scope.status = null;
                    $scope.showAnotherCallPrompt = false;
                    //   $modalInstance.close('cancel')
                }
            }, function () {
            });
        };
        $scope.openTechnicalReportModal = function (status, call_disposition) {
            var modalInstance = $modal.open({
                templateUrl: 'tpl/blocks/technical_error_form.html',
                controller: 'TechnicalErrorFormCtrl',
                size: 'md',
                windowClass: 'custom-rounded-modal',
                backdrop: 'static',
                resolve: {
                    object: function () {
                        return {
                            contact_id: $scope.salesuserDetails.contact_id,
                            rootStatus: status,
                            dispositionStatus: call_disposition
                        };
                    }
                }
            });
            modalInstance.result.then(function (formData) {
                // console.log(formData, "get Techncial form data")
                if (formData !== 'cancel') {
                    // $scope.showAnotherCallPrompt = true;
                    var notes = '';
                    $scope.postDisposition(status, call_disposition, notes);
                    $scope.status = null;
                    //   $scope.openDispositionConfirmationModal(true, false)
                }
                else {
                    $scope.status = 'Refund';
                    $scope.showAnotherCallPrompt = false;
                }
            }, function () {
            });
        };
        $scope.postDisposition = function (root_disposition, selected_disposition, notes) {
            console.log(root_disposition, selected_disposition, "Start combined disposition process");
            if (selected_disposition && root_disposition) {
                var salesSuccess = false;
                var etlSuccess = false;
                function handleSuccess() {
                    if (salesSuccess && etlSuccess) {
                        toaster.pop('success', 'Success', 'Dispositions Submitted Successfully', 2000);
                        $scope.status = null;
                        // Rush Opportunity resolve hook (Etapa 2): if this call originated
                        // from a claimed Rush opportunity, report the outcome to Convex.
                        try {
                            var rushId = $rootScope.activeRushOpportunityId;
                            var rushAgentId = $rootScope.activeRushAgentExternalId;
                            var rushAgentEmail = $rootScope.activeRushAgentEmail;
                            if (rushId && (rushAgentId || rushAgentEmail)) {
                                var outcome = (0, RushOpportunityService_1.mapDispositionToOutcome)(root_disposition, selected_disposition);
                                RushOpportunityService_1.RushOpportunityService.resolve({ externalId: rushAgentId || undefined, email: rushAgentEmail || undefined }, rushId, outcome);
                                $rootScope.activeRushOpportunityId = null;
                                $rootScope.activeRushAgentExternalId = null;
                                $rootScope.activeRushAgentEmail = null;
                                $rootScope.activeRushTriggeredCall = false;
                            }
                        }
                        catch (e) {
                            console.error('[Rush] resolve from disposition failed', e);
                        }
                        // $scope.showAnotherCallPrompt = true;
                        if (root_disposition === 'Application Submitted') {
                            $scope.openDispositionConfirmationModal(true, true);
                        }
                        else {
                            $scope.openDispositionConfirmationModal(true, false);
                        }
                    }
                }
                var salesCallbacks = {
                    success: function (response, statusCode) {
                        console.log(response, statusCode, "Sales disposition success");
                        if (statusCode === 200) {
                            salesSuccess = true;
                            handleSuccess();
                        }
                        else {
                            toaster.pop('error', 'Error', 'Unexpected Sales Disposition Response', 2000);
                        }
                    },
                    error: function (response, statusCode) {
                        console.log('Sales disposition error', JSON.stringify(response), statusCode);
                        if (!salesSuccess) {
                            toaster.pop('error', 'Error', 'Sales Disposition Failed', 2000);
                        }
                    }
                };
                var etlCallbacks = {
                    success: function (response, statusCode) {
                        console.log(response, statusCode, "ETL disposition success");
                        if (statusCode === 200) {
                            etlSuccess = true;
                            handleSuccess();
                        }
                        else {
                            toaster.pop('error', 'Error', 'Unexpected ETL Disposition Response', 2000);
                        }
                    },
                    error: function (response, statusCode) {
                        console.log('ETL disposition error', JSON.stringify(response), statusCode);
                        if (!etlSuccess) {
                            toaster.pop('error', 'Error', 'ETL Disposition Failed', 2000);
                        }
                    }
                };
                UserService.postsalesDispositions($scope.strNumber, $scope.user_id, root_disposition, selected_disposition, notes, salesCallbacks);
                UserService.postetlDispostionStatus($scope.user_id, $scope.strNumber, root_disposition, selected_disposition, etlCallbacks);
            }
        };
        //Disposition status update
        $scope.openDispositionStatusModal = function (status_disposition) {
            // console.log(status_disposition, "----- status disposition")
            var selected_disposition = status_disposition;
            var modalInstance = $modal.open({
                templateUrl: 'tpl/blocks/disposition_status.html',
                controller: 'DispositionStatusCtrl',
                size: 'md',
                windowClass: 'custom-rounded-modal',
                backdrop: 'static',
                resolve: {
                    object: function () {
                        return {
                            dispositionStatus: selected_disposition,
                            user_Id: $scope.user_id,
                            role: $scope.role,
                            strNumber: $scope.strNumber,
                            contactId: $scope.salesuserDetails.contact_id
                        };
                    }
                }
            });
            modalInstance.result.then(function (val) {
                console.log(" ----------------------- root , disposition value", val);
                if (val.status === 'Application Submitted') {
                    $scope.openAddApplicationModal(val.status, val.call_disposition);
                }
                else if (val.status === 'Refund' && val.call_disposition === 'Technical Issue') {
                    $scope.openTechnicalReportModal(val.status, val.call_disposition);
                }
                else if (val.status == 'cancel') {
                    $scope.salesDisposition = true;
                    $scope.salesLayout = true;
                }
                else {
                    $scope.postDisposition(val.status, val.call_disposition, val.notes);
                }
            }, function () {
                //   $log.info('Modal dismissed at: ' + new Date());
            });
        };
        $scope.openDispositionConfirmationModal = function (confirmStatus, applicationStatus) {
            var modalInstance = $modal.open({
                templateUrl: 'tpl/blocks/disposition_confirmation.html',
                controller: 'DispositionConfirmationCtrl',
                size: 'md',
                windowClass: 'custom-rounded-modal',
                backdrop: 'static',
                resolve: {
                    object: function () {
                        return {
                            showConfirmation: confirmStatus,
                            showApplicationSubmitted: applicationStatus
                        };
                    }
                }
            });
            return modalInstance.result.then(function (result) {
                $scope.selected = result;
                $scope.isInDispositionPage = false;
                //   console.log("get the disposition result status",$scope.selected)
                if ($scope.selected === 'No') {
                    // console.log("on NO -------")
                    $scope.setCallStatus('offline');
                    $scope.resetSalesPages();
                    $scope.goLive(false, false);
                }
                else if ($scope.selected === 'Yes') {
                    $scope.resetDispositionSelection();
                    $scope.salesuserDetails = {};
                    $scope.resetSalesPages();
                    clearStatusUpdateQueue();
                    if ($scope.pendingStatusUpdateTimeoutId) {
                        clearTimeout($scope.pendingStatusUpdateTimeoutId);
                    }
                    $scope.pendingStatusUpdate = null;
                    $scope.pendingStatusUpdateTimeoutId = null;
                    setAgentDashboardStatus('waiting');
                    $scope.setCallStatus('waiting', true);
                    $scope.postAgentAvailableStatus();
                }
            }, function (dismissal) {
                return 'cancel';
            });
        };
        //added in case of browser close event
        function handleBeforeUnload(event) {
            if (!isOnlineDesired() || $scope.duplicateTab)
                return;
            event.preventDefault();
            event.returnValue = '';
            return '';
        }
        function handlePageUnload() {
            $scope.teardownRealtime();
            (0, OpenAIRealtimeCtrl_1.teardownOpenAIRealtime)();
        }
        window.addEventListener('beforeunload', handleBeforeUnload);
        window.addEventListener('unload', handlePageUnload);
        //checking internet connectivity
        function handleBrowserOnline() {
            if ($state.current.name !== 'app.sales-agent' || $scope.duplicateTab)
                return;
            console.log('------------- Browser Online Event -----------------');
            var wasDisconnected = $scope.internetDisconnectedByBrowser || $scope.netflag == false;
            $scope.internetDisconnectedByBrowser = false;
            $scope.netflag = true;
            $scope.isToggleDisabled = false;
            if (wasDisconnected) {
                toaster.pop('success', 'Success', 'Internet connection restored', 3000);
            }
            if (isOnlineDesired()) {
                $scope.reconnectingState = true;
                $scope.connectWebSocketConnection(userId, true);
                recoverPlivoRegistration('browser-online');
                schedulePlivoRecovery('browser-online');
                announceStatusWhenReady('browser-online');
            }
            else if (isPlivoRegistered()) {
                $scope.logoutPlivo();
            }
            $scope.stopConnectionCheck();
            $scope.startConnectionCheck();
            clearRecoveryIfHealthy();
        }
        function handleBrowserOffline() {
            if ($state.current.name !== 'app.sales-agent' || $scope.duplicateTab)
                return;
            console.log('----- Browser Offline ---------');
            $scope.netflag = false;
            $scope.agentDashboradLoaderFlag = false;
            cancelSocketReconnect();
            lastStatusAnnouncementSocket = null;
            lastStatusConfirmationSocket = null;
            resetStatusMessagingState();
            webSocketService.discard();
            if (isOnlineDesired()) {
                if (!$scope.internetDisconnectedByBrowser) {
                    toaster.pop('error', 'Error', 'Internet disconnected');
                }
                $scope.internetDisconnectedByBrowser = true;
                $scope.reconnectingState = true;
                $scope.isToggleDisabled = false;
                startRecoveryWindow('browser-offline');
                captureAgentStatusEvent('browser-offline');
            }
            $scope.$evalAsync();
        }
        window.addEventListener('online', handleBrowserOnline);
        window.addEventListener('offline', handleBrowserOffline);
        function turnOffSwitch() {
            $scope.goLive(false, false);
            $scope.$evalAsync();
        }
        $scope.turnOffSwitch = turnOffSwitch;
        // ─── Realtime Transcription ──────────────────────────────────────────────
        $scope.realtimeTranscripts = [];
        $scope.openaiRealtimeResponses = [];
        $scope.rebuttalEntries = [];
        $scope.callCheckLifeInsurance = false;
        $scope.callCheckLegalAge = false;
        $scope.callCheckValidState = false;
        $scope.callCheckPriceAware = false;
        $scope.billableCall = false;
        $scope.smartCheckCount = 0;
        $scope.smartCheckPercent = 0;
        $scope._realtimeDeepgramWs = null;
        $scope._realtimeAudioCtx = null;
        $scope._realtimeProcessor = null;
        $scope._realtimeSource = null;
        $scope._realtimeMicSource = null;
        $scope._realtimeMerger = null;
        $scope._realtimeMicStream = null;
        $scope._realtimeRemoteClonedStream = null;
        $scope._realtimeDeepgramRequestId = null;
        $scope._realtimeSettingUp = false;
        /**
         * Downsample a Float32Array from `fromSampleRate` to `toSampleRate`
         * using simple linear interpolation, then convert to 16-bit PCM (Int16).
         */
        function downsampleToInt16(buffer, fromSampleRate, toSampleRate) {
            if (fromSampleRate === toSampleRate) {
                var direct = new Int16Array(buffer.length);
                for (var d = 0; d < buffer.length; d++) {
                    var s = Math.max(-1, Math.min(1, buffer[d]));
                    direct[d] = s < 0 ? s * 0x8000 : s * 0x7FFF;
                }
                return direct;
            }
            var ratio = fromSampleRate / toSampleRate;
            var newLength = Math.round(buffer.length / ratio);
            var result = new Int16Array(newLength);
            for (var i = 0; i < newLength; i++) {
                var srcIndex = i * ratio;
                var index = Math.floor(srcIndex);
                var frac = srcIndex - index;
                var sample;
                if (index + 1 < buffer.length) {
                    sample = buffer[index] * (1 - frac) + buffer[index + 1] * frac;
                }
                else {
                    sample = buffer[index] || 0;
                }
                sample = Math.max(-1, Math.min(1, sample));
                result[i] = sample < 0 ? sample * 0x8000 : sample * 0x7FFF;
            }
            return result;
        }
        /**
         * Invoked each time Deepgram returns a transcription result.
         * Stores the result in `$scope.realtimeTranscripts`, grouping words by
         * speaker index (diarization).  Interim (non-final) results replace the
         * last pending entry; final results are appended.
         */
        function onTranscriptionDone(transcript) {
            if (!transcript || !transcript.channel) {
                return;
            }
            var alternatives = transcript.channel.alternatives;
            if (!alternatives || alternatives.length === 0) {
                return;
            }
            var best = alternatives[0];
            var text = best.transcript;
            if (!text) {
                return;
            }
            // Determine speaker from channel_index (multichannel mode)
            // channel_index is [channelNumber, totalChannels]
            // Channel 0 = Agent (mic), Channel 1 = Customer (remote)
            var channelIdx = (transcript.channel_index && transcript.channel_index.length > 0)
                ? transcript.channel_index[0]
                : 0;
            var speakerLabel = channelIdx === 0 ? 'Agent' : 'Customer';
            // Build a speaker-labelled segment map from diarized words
            var speakerSegments = {};
            if (best.words && best.words.length > 0) {
                best.words.forEach(function (word) {
                    var speaker = (word.speaker !== undefined && word.speaker !== null) ? word.speaker : channelIdx;
                    if (!speakerSegments[speaker]) {
                        speakerSegments[speaker] = [];
                    }
                    speakerSegments[speaker].push(word.punctuated_word || word.word);
                });
            }
            var entry = {
                isFinal: transcript.is_final,
                text: text,
                speakerSegments: speakerSegments,
                speakerLabel: speakerLabel,
                channelIndex: channelIdx,
                timestamp: Date.now(),
            };
            console.log('[Realtime] [' + speakerLabel + '] ' + (transcript.is_final ? '(final)' : '(interim)') + ': ' + text);
            // Only show final results in the UI — skip interim entries
            if (!entry.isFinal) {
                return;
            }
            // Cap the stored transcript list to avoid unbounded memory growth
            if ($scope.realtimeTranscripts.length >= 200) {
                $scope.realtimeTranscripts.shift();
            }
            $scope.realtimeTranscripts.push(entry);
            // When a final transcription arrives, send the last 3 final entries to OpenAI
            if (entry.isFinal) {
                var finalEntries = $scope.realtimeTranscripts.filter(function (e) { return e.isFinal; });
                var last3 = finalEntries.slice(-3);
                if (last3.length > 0) {
                    (0, OpenAIRealtimeCtrl_1.sendTranscriptions)(last3);
                }
            }
            // Schedule a digest only if one is not already in progress
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        }
        /**
         * Closes any open realtime connections, stops audio capture, and resets
         * internal state.  Safe to call even if no session is currently active.
         */
        $scope.teardownRealtime = function () {
            // Close Deepgram WebSocket
            if ($scope._realtimeDeepgramWs) {
                try {
                    if ($scope._realtimeDeepgramWs.readyState === WebSocket.OPEN) {
                        $scope._realtimeDeepgramWs.send(JSON.stringify({ type: 'CloseStream' }));
                    }
                    $scope._realtimeDeepgramWs.close(1000, 'teardown');
                }
                catch (e) { }
                $scope._realtimeDeepgramWs = null;
                $scope._realtimeDeepgramRequestId = null;
            }
            // Disconnect audio processing graph
            if ($scope._realtimeProcessor) {
                try {
                    $scope._realtimeProcessor.disconnect();
                    $scope._realtimeProcessor.onaudioprocess = null;
                }
                catch (e) { }
                $scope._realtimeProcessor = null;
            }
            if ($scope._realtimeMerger) {
                try {
                    $scope._realtimeMerger.disconnect();
                }
                catch (e) { }
                $scope._realtimeMerger = null;
            }
            if ($scope._realtimeSource) {
                try {
                    $scope._realtimeSource.disconnect();
                }
                catch (e) { }
                $scope._realtimeSource = null;
            }
            // Stop cloned remote stream tracks so the browser releases the audio resource
            if ($scope._realtimeRemoteClonedStream) {
                try {
                    $scope._realtimeRemoteClonedStream.getTracks().forEach(function (t) { t.stop(); });
                }
                catch (e) { }
                $scope._realtimeRemoteClonedStream = null;
            }
            if ($scope._realtimeMicSource) {
                try {
                    $scope._realtimeMicSource.disconnect();
                }
                catch (e) { }
                $scope._realtimeMicSource = null;
            }
            // Stop agent mic tracks so the browser releases the mic
            if ($scope._realtimeMicStream) {
                try {
                    $scope._realtimeMicStream.getTracks().forEach(function (t) { t.stop(); });
                }
                catch (e) { }
                $scope._realtimeMicStream = null;
            }
            if ($scope._realtimeAudioCtx) {
                try {
                    $scope._realtimeAudioCtx.close();
                }
                catch (e) { }
                $scope._realtimeAudioCtx = null;
            }
            console.log('[Realtime] Realtime connections and audio capture torn down');
        };
        /**
         * Sets up real-time transcription by capturing WebRTC audio from the
         * Plivo call and streaming it to Deepgram.
         *
         * Flow:
         *  1. Grab the remote audio MediaStream from the Plivo <audio> element
         *     that carries the call audio.
         *  1b. Capture the agent's mic via getUserMedia.
         *  2. Create an AudioContext, merge both streams into a stereo signal
         *     (left = agent mic, right = caller) via a ChannelMergerNode, and
         *     capture raw PCM through a ScriptProcessorNode.
         *  3. Interleave the two channels and downsample to 16 kHz linear16.
         *  4. Open a Deepgram streaming WebSocket with multichannel=true,
         *     channels=2 so Deepgram knows each channel is a separate speaker.
         *  5. Forward PCM buffers to Deepgram; route transcription results to
         *     `onTranscriptionDone`.
         */
        $scope.setupRealtime = function (callUUID) {
            return __awaiter(this, void 0, void 0, function* () {
                if ($scope._realtimeSettingUp) {
                    console.warn('[Realtime] setupRealtime already in progress – ignoring duplicate call');
                    return;
                }
                $scope._realtimeSettingUp = true;
                try {
                    // ── Obtain Deepgram token (ephemeral preferred, static fallback) ──
                    var deepgramToken = '';
                    if (environment_1.environment.deepgramEphemeralUrl) {
                        try {
                            var kcToken = localStorage.getItem('access_token') || '';
                            var tokenResp = yield fetch(environment_1.environment.deepgramEphemeralUrl, {
                                method: 'GET',
                                headers: {
                                    'Accept': 'application/json',
                                    'Authorization': 'Bearer ' + kcToken,
                                },
                            });
                            if (!tokenResp.ok) {
                                throw new Error('HTTP ' + tokenResp.status);
                            }
                            var tokenData = yield tokenResp.json();
                            deepgramToken = (tokenData.access_token || tokenData.token || tokenData.key || '').trim();
                        }
                        catch (tokenErr) {
                            console.warn('[Realtime] Failed to fetch Deepgram ephemeral token, falling back to static key.', tokenErr);
                        }
                    }
                    if (!deepgramToken) {
                        deepgramToken = environment_1.environment.deepgramApiKey || '';
                    }
                    if (!deepgramToken || deepgramToken === 'YOUR_DEEPGRAM_API_KEY') {
                        console.warn('[Realtime] Deepgram API key not configured – skipping transcription.');
                        return;
                    }
                    // Close any existing session before starting a new one
                    $scope.teardownRealtime();
                    console.log('[Realtime] Setting up realtime transcription for call', callUUID);
                    // ── Step 1: Capture the call audio from the Plivo WebRTC stream ────
                    //
                    // Plivo's Browser SDK renders remote audio through a hidden <audio>
                    // element.  After the call is answered the SDK sets el.srcObject to
                    // the remote MediaStream.  There can be a brief delay after
                    // onCallAnswered before the element is populated, so we poll for
                    // up to 5 seconds (every 200 ms).
                    var remoteStream = yield new Promise(function (resolve) {
                        var MAX_ATTEMPTS = 25; // 25 × 200 ms = 5 s
                        var attempt = 0;
                        function tryFindStream() {
                            attempt++;
                            // Strategy A: Scan all <audio> elements for a srcObject MediaStream
                            var audioElements = document.querySelectorAll('audio');
                            for (var a = 0; a < audioElements.length; a++) {
                                var el = audioElements[a];
                                if (el.srcObject && el.srcObject instanceof MediaStream) {
                                    var tracks = el.srcObject.getAudioTracks();
                                    var hasLiveTrack = tracks.some(function (t) { return t.readyState === 'live'; });
                                    if (hasLiveTrack) {
                                        console.log('[Realtime] Found remote MediaStream with live audio track (attempt ' + attempt + ')');
                                        resolve(el.srcObject);
                                        return;
                                    }
                                    else {
                                        console.log('[Realtime] Found MediaStream but all audio tracks ended, skipping (attempt ' + attempt + ')');
                                    }
                                }
                            }
                            // Strategy B: Try Plivo SDK's internal remoteStream if exposed
                            if ($rootScope.plivoWebSdk && $rootScope.plivoWebSdk.client) {
                                try {
                                    var client = $rootScope.plivoWebSdk.client;
                                    if (typeof client.getRemoteStream === 'function') {
                                        var stream = client.getRemoteStream();
                                        if (stream) {
                                            console.log('[Realtime] Got remote stream via plivoWebSdk.client.getRemoteStream() (attempt ' + attempt + ')');
                                            resolve(stream);
                                            return;
                                        }
                                    }
                                }
                                catch (e) {
                                    console.warn('[Realtime] plivoWebSdk.client.getRemoteStream() error', e);
                                }
                            }
                            if (attempt < MAX_ATTEMPTS) {
                                console.log('[Realtime] Remote stream not available yet, retrying... (' + attempt + '/' + MAX_ATTEMPTS + ')');
                                setTimeout(tryFindStream, 200);
                            }
                            else {
                                console.error('[Realtime] Could not find remote MediaStream after ' + MAX_ATTEMPTS + ' attempts (' + (MAX_ATTEMPTS * 200 / 1000) + 's). Aborting realtime setup.');
                                resolve(null);
                            }
                        }
                        tryFindStream();
                    });
                    if (!remoteStream) {
                        console.error('[Realtime] No remote MediaStream available – cannot start transcription.');
                        return;
                    }
                    // ── Step 1b: Capture the agent's mic ───────────────────────────────
                    var micStream;
                    try {
                        var micAudioConstraints = $scope.selectedAudioInputDeviceId && $scope.selectedAudioInputDeviceId !== 'default'
                            ? { deviceId: { exact: $scope.selectedAudioInputDeviceId } }
                            : true;
                        var micConstraints = { audio: micAudioConstraints, video: false };
                        micStream = yield navigator.mediaDevices.getUserMedia(micConstraints);
                        console.log('[Realtime] Got agent mic stream (device:', $scope.selectedAudioInputDeviceId || 'default', ')');
                    }
                    catch (micErr) {
                        console.error('[Realtime] Could not get agent mic – cannot start transcription.', micErr);
                        return;
                    }
                    // ── Step 2: Merge agent mic + caller into stereo AudioContext ──────
                    //    Left channel (0) = Agent mic
                    //    Right channel (1) = Caller / remote audio
                    var targetSampleRate = 16000;
                    var audioCtx = new (window.AudioContext || window.webkitAudioContext)();
                    var nativeSampleRate = audioCtx.sampleRate;
                    console.log('[Realtime] AudioContext sampleRate:', nativeSampleRate);
                    var remoteClonedStream = remoteStream.clone();
                    var remoteSource = audioCtx.createMediaStreamSource(remoteClonedStream);
                    var micSource = audioCtx.createMediaStreamSource(micStream);
                    // ChannelMergerNode with 2 inputs → 2-channel (stereo) output
                    var merger = audioCtx.createChannelMerger(2);
                    micSource.connect(merger, 0, 0); // mic  → left  (channel 0)
                    remoteSource.connect(merger, 0, 1); // caller → right (channel 1)
                    // ScriptProcessor with 2 input channels to read the merged stereo
                    var processor = audioCtx.createScriptProcessor(2048, 2, 2);
                    $scope._realtimeAudioCtx = audioCtx;
                    $scope._realtimeSource = remoteSource;
                    $scope._realtimeMicSource = micSource;
                    $scope._realtimeMerger = merger;
                    $scope._realtimeProcessor = processor;
                    $scope._realtimeMicStream = micStream;
                    $scope._realtimeRemoteClonedStream = remoteClonedStream;
                    // ── Step 3: Open Deepgram streaming WebSocket ──────────────────────
                    //    For JWT tokens from /v1/auth/grant, use Sec-WebSocket-Protocol
                    //    with 'token' scheme per Deepgram docs.
                    //    multichannel=true + channels=2 tells Deepgram to transcribe
                    //    each channel independently (channel 0 = Agent, channel 1 = Customer).
                    var deepgramUrl = [
                        'wss://api.deepgram.com/v1/listen',
                        '?model=nova-2',
                        '&multichannel=true',
                        // '&punctuate=true',
                        '&interim_results=true',
                        '&encoding=linear16',
                        '&sample_rate=', targetSampleRate.toString(),
                        '&channels=2',
                        '&endpointing=300',
                        '&utterance_end_ms=1500',
                    ].join('');
                    var deepgramWs = new WebSocket(deepgramUrl, ['bearer', deepgramToken]);
                    deepgramWs.binaryType = 'arraybuffer';
                    $scope._realtimeDeepgramWs = deepgramWs;
                    // ── Step 4: Wire everything up ─────────────────────────────────────
                    deepgramWs.onopen = function () {
                        console.log('[Realtime] Deepgram connection open – capturing and streaming audio');
                        // Start capturing audio: downsample each channel and interleave
                        // into a single buffer [L0, R0, L1, R1, …] so Deepgram sees
                        // channel 0 (agent) and channel 1 (customer) in every frame.
                        processor.onaudioprocess = function (e) {
                            if (deepgramWs.readyState !== WebSocket.OPEN) {
                                return;
                            }
                            var ch0 = e.inputBuffer.getChannelData(0); // agent mic
                            var ch1 = e.inputBuffer.getChannelData(1); // caller
                            // When agent is muted, send silence on channel 0 so Deepgram
                            // doesn't transcribe the agent's voice.
                            if ($scope.isMuted) {
                                ch0 = new Float32Array(ch0.length); // all zeros = silence
                            }
                            var ds0 = downsampleToInt16(ch0, nativeSampleRate, targetSampleRate);
                            var ds1 = downsampleToInt16(ch1, nativeSampleRate, targetSampleRate);
                            // Interleave: [L0, R0, L1, R1, …]
                            var interleaved = new Int16Array(ds0.length + ds1.length);
                            for (var s = 0; s < ds0.length; s++) {
                                interleaved[s * 2] = ds0[s];
                                interleaved[s * 2 + 1] = ds1[s];
                            }
                            deepgramWs.send(interleaved.buffer);
                        };
                        // Connect the audio graph: merger → processor → destination
                        // (destination is needed for ScriptProcessor to fire)
                        merger.connect(processor);
                        processor.connect(audioCtx.destination);
                    };
                    // Handle transcription results from Deepgram
                    deepgramWs.onmessage = function (event) {
                        try {
                            var data = JSON.parse(event.data);
                            if (data && data.type === 'Results') {
                                // Capture request_id from the first Results message metadata
                                if (!$scope._realtimeDeepgramRequestId && data.metadata && data.metadata.request_id) {
                                    $scope._realtimeDeepgramRequestId = data.metadata.request_id;
                                    console.log('[Realtime] Deepgram request_id:', data.metadata.request_id);
                                }
                                onTranscriptionDone(data);
                            }
                            else if (data && data.type === 'Metadata') {
                                console.log('[Realtime] Deepgram metadata', data);
                                if (data.request_id) {
                                    $scope._realtimeDeepgramRequestId = data.request_id;
                                    console.log('[Realtime] Deepgram request_id:', data.request_id);
                                }
                            }
                            else if (data && data.type === 'Error') {
                                console.error('[Realtime] Deepgram error message', data);
                            }
                            else {
                                console.log('[Realtime] Deepgram unknown message type', data);
                            }
                        }
                        catch (e) {
                            console.error('[Realtime] Failed to parse Deepgram message', e, event.data);
                        }
                    };
                    deepgramWs.onerror = function (err) {
                        console.error('[Realtime] Deepgram WebSocket error', err);
                        console.error('[Realtime] WS readyState at error:', deepgramWs.readyState, '(0=CONNECTING, 1=OPEN, 2=CLOSING, 3=CLOSED)');
                    };
                    deepgramWs.onclose = function (event) {
                        console.log('[Realtime] Deepgram connection closed | code:', event.code, '| reason:', event.reason, '| wasClean:', event.wasClean);
                        // Stop the processor when Deepgram disconnects
                        if (processor) {
                            try {
                                processor.disconnect();
                            }
                            catch (_) { }
                            processor.onaudioprocess = null;
                        }
                    };
                }
                catch (error) {
                    console.error('[Realtime] setupRealtime failed', error);
                }
                finally {
                    $scope._realtimeSettingUp = false;
                }
            });
        };
        // ── OpenAI Realtime setup ────────────────────────────────────────────────
        // Register the response handler.  The token fetch + WS connection happens
        // inside setupOpenAIRealtime(), called at call-answered time.
        (0, OpenAIRealtimeCtrl_1.onOpenAIResponse)(function (entry) {
            // Cap stored responses to prevent unbounded memory growth
            if ($scope.openaiRealtimeResponses.length >= 100) {
                $scope.openaiRealtimeResponses.shift();
            }
            $scope.openaiRealtimeResponses.push(entry);
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        });
        var VALID_FINAL_EXPENSE_STATES = ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'];
        function updateCallChecks() {
            var ct = String($scope.staticCustomerDetails.coverage_type || '').toLowerCase().trim();
            $scope.callCheckLifeInsurance = ct === 'burial' || ct === 'cremation' ||
                ct.indexOf('final') !== -1 || ct.indexOf('life') !== -1;
            var age = parseInt($scope.staticCustomerDetails.age, 10);
            $scope.callCheckLegalAge = !isNaN(age) && age >= 18 && age <= 90;
            var state = String($scope.staticCustomerDetails.state || '').toUpperCase().trim();
            $scope.callCheckValidState = VALID_FINAL_EXPENSE_STATES.indexOf(state) !== -1;
            var priceAware = $scope.staticCustomerDetails.price_aware;
            if (typeof priceAware === 'string') {
                priceAware = priceAware.toLowerCase().trim();
            }
            $scope.callCheckPriceAware = priceAware === true || priceAware === 'true' || priceAware === 'yes' || priceAware === '1';
            $scope.billableCall = $scope.callCheckLifeInsurance && $scope.callCheckLegalAge && $scope.callCheckValidState;
            $scope.smartCheckCount = ($scope.callCheckLifeInsurance ? 1 : 0) + ($scope.callCheckLegalAge ? 1 : 0) + ($scope.callCheckValidState ? 1 : 0) + ($scope.callCheckPriceAware ? 1 : 0);
            $scope.smartCheckPercent = $scope.smartCheckCount * 25;
        }
        $scope.addData = function (key, value) {
            if (!key || value == null) {
                return;
            }
            var k = key.toLowerCase().trim().replace(/\s+/g, '_');
            console.warn('[addData] Received key:', key, 'normalized to:', k, 'with value:', value);
            switch (k) {
                case 'first_name':
                    $scope.staticCustomerDetails.first_name = value;
                    break;
                case 'last_name':
                    $scope.staticCustomerDetails.last_name = value;
                    break;
                case 'zip_code':
                    $scope.staticCustomerDetails.zip_code = value;
                    break;
                case 'age':
                    $scope.staticCustomerDetails.age = value;
                    break;
                case 'date_of_birth': {
                    $scope.staticCustomerDetails.dob = value;
                    // Parse mm-dd-yyyy (or m-d-yyyy) and populate dobMonth, dobDay, dobYear + age
                    var dobParts = value.split('-');
                    if (dobParts.length === 3) {
                        var parsedMonth = parseInt(dobParts[0], 10);
                        var parsedDay = parseInt(dobParts[1], 10);
                        var parsedYear = parseInt(dobParts[2], 10);
                        if (!isNaN(parsedMonth) && !isNaN(parsedDay) && !isNaN(parsedYear)) {
                            $scope.staticCustomerDetails.dobMonth = parsedMonth;
                            $scope.staticCustomerDetails.dobDay = parsedDay;
                            $scope.staticCustomerDetails.dobYear = parsedYear;
                            var today = new Date();
                            var calculatedAge = today.getFullYear() - parsedYear;
                            if (today.getMonth() + 1 < parsedMonth ||
                                (today.getMonth() + 1 === parsedMonth && today.getDate() < parsedDay)) {
                                calculatedAge--;
                            }
                            $scope.staticCustomerDetails.age = calculatedAge;
                        }
                    }
                    break;
                }
                case 'bank_type':
                    $scope.staticCustomerDetails.bank_account_mode = value;
                    break;
                case 'address':
                case 'street1':
                case 'street':
                    $scope.staticCustomerDetails.street1 = value;
                    break;
                case 'city':
                    $scope.staticCustomerDetails.city = value;
                    break;
                case 'state':
                    $scope.staticCustomerDetails.state = value;
                    break;
                case 'gender':
                    $scope.staticCustomerDetails.gender = value;
                    break;
                case 'email':
                    $scope.staticCustomerDetails.email = value;
                    break;
                case 'height_feet':
                    $scope.staticCustomerDetails.height_feet = value;
                    break;
                case 'height_inches':
                    $scope.staticCustomerDetails.height_inches = value;
                    break;
                case 'weight':
                    $scope.staticCustomerDetails.weight = value;
                    break;
                case 'tobacco_use':
                    $scope.staticCustomerDetails.tobacco_user = value;
                    break;
                case 'beneficiary_first_name':
                    $scope.staticCustomerDetails.beneficiary_first_name = value;
                    break;
                case 'beneficiary_last_name':
                    $scope.staticCustomerDetails.beneficiary_last_name = value;
                    break;
                case 'social_security_or_disability':
                    $scope.staticCustomerDetails.social_security_or_disability = value;
                    break;
                case 'coverage_type':
                    $scope.staticCustomerDetails.coverage_type = value;
                    break;
                case 'diseases_list':
                    $scope.staticCustomerDetails.medications = value;
                    break;
                case 'opt_in_sms':
                case 'opt in sms':
                case 'sms opt in':
                    $scope.staticCustomerDetails.opt_in_sms = value;
                    break;
                case 'secondary_phone_number':
                case 'secondary phone':
                case 'secondary phone number':
                    $scope.staticCustomerDetails.secondary_phone_number = value;
                    break;
                case 'price_aware':
                    $scope.staticCustomerDetails.price_aware = value;
                    break;
                default:
                    console.warn('[addData] Unknown key:', key);
                    return;
            }
            updateCallChecks();
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        };
        (0, OpenAIRealtimeCtrl_1.onAddData)(function (key, value) {
            $scope.addData(key, value);
        });
        $scope.addRebuttal = function (objection, rebuttal) {
            if (!objection && !rebuttal) {
                return;
            }
            $scope.rebuttalEntries.push({
                objection: objection,
                rebuttal: rebuttal,
                timestamp: Date.now(),
            });
            if (!$scope.$$phase) {
                $scope.$apply();
            }
        };
        (0, OpenAIRealtimeCtrl_1.onAddRebuttal)(function (objection, rebuttal) {
            $scope.addRebuttal(objection, rebuttal);
        });
        // Teardown realtime connections when the scope is destroyed
        $scope.$on('$destroy', function () {
            $scope.stopMicrophoneMonitor(true);
            $scope.teardownRealtime();
            (0, OpenAIRealtimeCtrl_1.teardownOpenAIRealtime)();
        });
        // ─────────────────────────────────────────────────────────────────────────
        function onComponentMount() {
            if (localStorage.getItem('switchStatus') == 'true') {
                $scope.syncAudioDevices({
                    forcePermission: false,
                    applyToPlivo: !!$rootScope.plivoWebSdk,
                    showWarnings: false,
                    source: 'resume-online',
                    restartMonitor: false,
                    updateRealtime: false,
                }).then(function () {
                    return media_helper_1.MediaHelper.checkMicrophone($scope.selectedAudioInputDeviceId);
                }).then(function (result) {
                    $scope.applyMicrophoneCheckResult(result);
                    if (result.ok) {
                        $scope.showValue = window.localStorage.getItem("show_value");
                        if ($scope.showValue == 'true' || needsDailyAudioDeviceConfirmation()) {
                            setDesiredOnline(false);
                            $scope.switchStatus = false;
                            $scope.openCallSetupStationModal();
                        }
                        else {
                            $scope.goLive(true, false);
                        }
                    }
                    else {
                        setDesiredOnline(false);
                    }
                    $scope.$evalAsync();
                });
            }
            else {
                setDesiredOnline(false);
            }
        }
        onComponentMount();
        $scope.monitorMicrophonePermission();
        // Agent internet check status
        $scope.postConnectionDetails();
        // Start the interval to check internet connection every 5 seconds
        $scope.startConnectionCheck();
    }
]);
